/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.15.5.0 (NJsonSchema v10.6.6.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

export class AbpApiDefinitionClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param includeTypes (optional) 
     * @return Success
     */
    apiDefinition(includeTypes: boolean | undefined): Promise<ApplicationApiDescriptionModel> {
        let url_ = this.baseUrl + "/api/abp/api-definition?";
        if (includeTypes === null)
            throw new Error("The parameter 'includeTypes' cannot be null.");
        else if (includeTypes !== undefined)
            url_ += "IncludeTypes=" + encodeURIComponent("" + includeTypes) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApiDefinition(_response);
        });
    }

    protected processApiDefinition(response: Response): Promise<ApplicationApiDescriptionModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApplicationApiDescriptionModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApplicationApiDescriptionModel>(<any>null);
    }
}

export class AbpApplicationConfigurationClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    applicationConfiguration(): Promise<ApplicationConfigurationDto> {
        let url_ = this.baseUrl + "/api/abp/application-configuration";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApplicationConfiguration(_response);
        });
    }

    protected processApplicationConfiguration(response: Response): Promise<ApplicationConfigurationDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApplicationConfigurationDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApplicationConfigurationDto>(<any>null);
    }
}

export class ActivityClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    activityPost(body: CreateUpdateActivityDto | undefined): Promise<ActivityDto> {
        let url_ = this.baseUrl + "/api/Activity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processActivityPost(_response);
        });
    }

    protected processActivityPost(response: Response): Promise<ActivityDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivityDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActivityDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    activityPut(body: CreateUpdateActivityDto | undefined): Promise<ActivityDto> {
        let url_ = this.baseUrl + "/api/Activity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processActivityPut(_response);
        });
    }

    protected processActivityPut(response: Response): Promise<ActivityDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivityDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActivityDto>(<any>null);
    }

    /**
     * @return Success
     */
    activityGet(activityId: number): Promise<ActivityDto> {
        let url_ = this.baseUrl + "/api/Activity/{activityId}";
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processActivityGet(_response);
        });
    }

    protected processActivityGet(response: Response): Promise<ActivityDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivityDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActivityDto>(<any>null);
    }

    activityDelete(activityId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/Activity/{activityId}";
        if (activityId === undefined || activityId === null)
            throw new Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processActivityDelete(_response);
        });
    }

    protected processActivityDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    record(recordId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/Activity/record/{recordId}";
        if (recordId === undefined || recordId === null)
            throw new Error("The parameter 'recordId' must be defined.");
        url_ = url_.replace("{recordId}", encodeURIComponent("" + recordId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRecord(_response);
        });
    }

    protected processRecord(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    list(body: ActivityQueryDto | undefined): Promise<PagedResultDto_1OfOfActivityDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        let url_ = this.baseUrl + "/api/Activity/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processList(_response);
        });
    }

    protected processList(response: Response): Promise<PagedResultDto_1OfOfActivityDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDto_1OfOfActivityDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultDto_1OfOfActivityDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(<any>null);
    }
}

export class AerialClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getSleepSummary(body: SleepSummaryQueryDto | undefined): Promise<SleepSummaryProcessedDto> {
        let url_ = this.baseUrl + "/api/Aerial/GetSleepSummary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSleepSummary(_response);
        });
    }

    protected processGetSleepSummary(response: Response): Promise<SleepSummaryProcessedDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SleepSummaryProcessedDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SleepSummaryProcessedDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getMotion(body: MotionQueryDto | undefined): Promise<MotionResponseDto> {
        let url_ = this.baseUrl + "/api/Aerial/GetMotion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMotion(_response);
        });
    }

    protected processGetMotion(response: Response): Promise<MotionResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MotionResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MotionResponseDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getActivitySummary(body: ActivitySummaryQueryDto | undefined): Promise<ActivityResponseDto> {
        let url_ = this.baseUrl + "/api/Aerial/GetActivitySummary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetActivitySummary(_response);
        });
    }

    protected processGetActivitySummary(response: Response): Promise<ActivityResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivityResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActivityResponseDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getActivityPrediction(body: ActivityPredictionQueryDto | undefined): Promise<ActivityPredictionResponseDto> {
        let url_ = this.baseUrl + "/api/Aerial/GetActivityPrediction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetActivityPrediction(_response);
        });
    }

    protected processGetActivityPrediction(response: Response): Promise<ActivityPredictionResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivityPredictionResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActivityPredictionResponseDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getSleepPrediction(body: SleepPredictionQueryDto | undefined): Promise<SleepPredictionResponseDto> {
        let url_ = this.baseUrl + "/api/Aerial/GetSleepPrediction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSleepPrediction(_response);
        });
    }

    protected processGetSleepPrediction(response: Response): Promise<SleepPredictionResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SleepPredictionResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SleepPredictionResponseDto>(<any>null);
    }

    /**
     * @param serial (optional) 
     * @return Success
     */
    verifySocketSupply(serial: string | null | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Aerial/VerifySocketSupply?";
        if (serial !== undefined && serial !== null)
            url_ += "serial=" + encodeURIComponent("" + serial) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVerifySocketSupply(_response);
        });
    }

    protected processVerifySocketSupply(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * @param groupId (optional) 
     * @return Success
     */
    groupMotionStatus(groupId: string | null | undefined): Promise<GroupMotionStatusResponseDto> {
        let url_ = this.baseUrl + "/api/Aerial/GroupMotionStatus?";
        if (groupId !== undefined && groupId !== null)
            url_ += "groupId=" + encodeURIComponent("" + groupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGroupMotionStatus(_response);
        });
    }

    protected processGroupMotionStatus(response: Response): Promise<GroupMotionStatusResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GroupMotionStatusResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GroupMotionStatusResponseDto>(<any>null);
    }

    /**
     * @param serial (optional) 
     * @return Success
     */
    thingMotionStatus(serial: string | null | undefined): Promise<ThingMotionStatusResponseDto> {
        let url_ = this.baseUrl + "/api/Aerial/ThingMotionStatus?";
        if (serial !== undefined && serial !== null)
            url_ += "serial=" + encodeURIComponent("" + serial) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processThingMotionStatus(_response);
        });
    }

    protected processThingMotionStatus(response: Response): Promise<ThingMotionStatusResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ThingMotionStatusResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ThingMotionStatusResponseDto>(<any>null);
    }

    /**
     * @param serial (optional) 
     * @return Success
     */
    thingDiagnostic(serial: string | null | undefined): Promise<DiagnosticResponseDto> {
        let url_ = this.baseUrl + "/api/Aerial/ThingDiagnostic?";
        if (serial !== undefined && serial !== null)
            url_ += "serial=" + encodeURIComponent("" + serial) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processThingDiagnostic(_response);
        });
    }

    protected processThingDiagnostic(response: Response): Promise<DiagnosticResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DiagnosticResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiagnosticResponseDto>(<any>null);
    }

    /**
     * @param groupId (optional) 
     * @return Success
     */
    groupAssignedClient(groupId: string | null | undefined): Promise<ClientDto> {
        let url_ = this.baseUrl + "/api/Aerial/GroupAssignedClient?";
        if (groupId !== undefined && groupId !== null)
            url_ += "groupId=" + encodeURIComponent("" + groupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGroupAssignedClient(_response);
        });
    }

    protected processGroupAssignedClient(response: Response): Promise<ClientDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClientDto>(<any>null);
    }

    /**
     * @return Success
     */
    unassignedGroups(): Promise<ClientExternalPartnersDto[]> {
        let url_ = this.baseUrl + "/api/Aerial/UnassignedGroups";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUnassignedGroups(_response);
        });
    }

    protected processUnassignedGroups(response: Response): Promise<ClientExternalPartnersDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClientExternalPartnersDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClientExternalPartnersDto[]>(<any>null);
    }

    /**
     * @param groupId (optional) 
     * @return Success
     */
    clientExternalPartnersByGroupId(groupId: string | null | undefined): Promise<ClientExternalPartnersDto> {
        let url_ = this.baseUrl + "/api/Aerial/ClientExternalPartnersByGroupId?";
        if (groupId !== undefined && groupId !== null)
            url_ += "groupId=" + encodeURIComponent("" + groupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processClientExternalPartnersByGroupId(_response);
        });
    }

    protected processClientExternalPartnersByGroupId(response: Response): Promise<ClientExternalPartnersDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientExternalPartnersDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClientExternalPartnersDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    groupCreationOrquestratorCreate(body: GroupCreateUpdateDto | undefined): Promise<ClientExternalPartnersDto> {
        let url_ = this.baseUrl + "/api/Aerial/GroupCreationOrquestratorCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGroupCreationOrquestratorCreate(_response);
        });
    }

    protected processGroupCreationOrquestratorCreate(response: Response): Promise<ClientExternalPartnersDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientExternalPartnersDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClientExternalPartnersDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    groupCreationOrquestratorUpdate(body: GroupCreateUpdateDto | undefined): Promise<ClientExternalPartnersDto> {
        let url_ = this.baseUrl + "/api/Aerial/GroupCreationOrquestratorUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGroupCreationOrquestratorUpdate(_response);
        });
    }

    protected processGroupCreationOrquestratorUpdate(response: Response): Promise<ClientExternalPartnersDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientExternalPartnersDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClientExternalPartnersDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    checkSupply(body: ThingDto | undefined): Promise<ThingResponseDto> {
        let url_ = this.baseUrl + "/api/Aerial/checkSupply";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCheckSupply(_response);
        });
    }

    protected processCheckSupply(response: Response): Promise<ThingResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ThingResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ThingResponseDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    connectedClients(body: ThingDto | undefined): Promise<ConnectedClientsResponseDto> {
        let url_ = this.baseUrl + "/api/Aerial/ConnectedClients";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processConnectedClients(_response);
        });
    }

    protected processConnectedClients(response: Response): Promise<ConnectedClientsResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConnectedClientsResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConnectedClientsResponseDto>(<any>null);
    }
}

export class AffinityClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    list(body: ClientAffinityQueryDto | undefined): Promise<PagedResultDto_1OfOfClientAffinityDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        let url_ = this.baseUrl + "/api/Affinity/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processList(_response);
        });
    }

    protected processList(response: Response): Promise<PagedResultDto_1OfOfClientAffinityDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDto_1OfOfClientAffinityDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultDto_1OfOfClientAffinityDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(<any>null);
    }

    affinity(body: CreateUpdateClientAffinityDto | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Affinity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAffinity(_response);
        });
    }

    protected processAffinity(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    affinityForUser(clientId: number): Promise<AffinityDto[]> {
        let url_ = this.baseUrl + "/api/Affinity/affinityForUser/{clientId}";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAffinityForUser(_response);
        });
    }

    protected processAffinityForUser(response: Response): Promise<AffinityDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AffinityDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AffinityDto[]>(<any>null);
    }
}

export class AndroidDeviceClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    androidDevicePost(body: AndroidDeviceDto | undefined): Promise<AndroidDeviceDto> {
        let url_ = this.baseUrl + "/api/AndroidDevice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAndroidDevicePost(_response);
        });
    }

    protected processAndroidDevicePost(response: Response): Promise<AndroidDeviceDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AndroidDeviceDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AndroidDeviceDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    androidDevicePut(body: AndroidDeviceDto | undefined): Promise<AndroidDeviceDto> {
        let url_ = this.baseUrl + "/api/AndroidDevice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAndroidDevicePut(_response);
        });
    }

    protected processAndroidDevicePut(response: Response): Promise<AndroidDeviceDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AndroidDeviceDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AndroidDeviceDto>(<any>null);
    }

    /**
     * @return Success
     */
    androidDeviceGet(androidDeviceId: number): Promise<AndroidDeviceDto> {
        let url_ = this.baseUrl + "/api/AndroidDevice/{androidDeviceId}";
        if (androidDeviceId === undefined || androidDeviceId === null)
            throw new Error("The parameter 'androidDeviceId' must be defined.");
        url_ = url_.replace("{androidDeviceId}", encodeURIComponent("" + androidDeviceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAndroidDeviceGet(_response);
        });
    }

    protected processAndroidDeviceGet(response: Response): Promise<AndroidDeviceDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AndroidDeviceDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AndroidDeviceDto>(<any>null);
    }

    androidDeviceDelete(androidDeviceId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/AndroidDevice/{androidDeviceId}";
        if (androidDeviceId === undefined || androidDeviceId === null)
            throw new Error("The parameter 'androidDeviceId' must be defined.");
        url_ = url_.replace("{androidDeviceId}", encodeURIComponent("" + androidDeviceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAndroidDeviceDelete(_response);
        });
    }

    protected processAndroidDeviceDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    list(body: AndroidDeviceQueryDto | undefined): Promise<PagedResultDto_1OfOfAndroidDeviceDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        let url_ = this.baseUrl + "/api/AndroidDevice/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processList(_response);
        });
    }

    protected processList(response: Response): Promise<PagedResultDto_1OfOfAndroidDeviceDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDto_1OfOfAndroidDeviceDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultDto_1OfOfAndroidDeviceDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(<any>null);
    }
}

export class ClientClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    clientPost(body: CreateUpdateClientDto | undefined): Promise<ClientDto> {
        let url_ = this.baseUrl + "/api/Client";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processClientPost(_response);
        });
    }

    protected processClientPost(response: Response): Promise<ClientDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClientDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    clientPut(body: CreateUpdateClientDto | undefined): Promise<ClientDto> {
        let url_ = this.baseUrl + "/api/Client";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processClientPut(_response);
        });
    }

    protected processClientPut(response: Response): Promise<ClientDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClientDto>(<any>null);
    }

    /**
     * @return Success
     */
    clientGet(clientId: number): Promise<ClientDto> {
        let url_ = this.baseUrl + "/api/Client/{clientId}";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processClientGet(_response);
        });
    }

    protected processClientGet(response: Response): Promise<ClientDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClientDto>(<any>null);
    }

    clientDelete(clientId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/Client/{clientId}";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processClientDelete(_response);
        });
    }

    protected processClientDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    pass(clientId: number): Promise<SeePasswordDto> {
        let url_ = this.baseUrl + "/api/Client/{clientId}/pass";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPass(_response);
        });
    }

    protected processPass(response: Response): Promise<SeePasswordDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SeePasswordDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SeePasswordDto>(<any>null);
    }

    /**
     * @return Success
     */
    pendingSessions(clientId: number): Promise<number> {
        let url_ = this.baseUrl + "/api/Client/{clientId}/pendingSessions";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPendingSessions(_response);
        });
    }

    protected processPendingSessions(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(<any>null);
    }

    /**
     * @return Success
     */
    user(userId: number): Promise<ClientDto> {
        let url_ = this.baseUrl + "/api/Client/user/{UserId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUser(_response);
        });
    }

    protected processUser(response: Response): Promise<ClientDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClientDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    list(body: ClientQueryDto | undefined): Promise<PagedResultDto_1OfOfClientDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        let url_ = this.baseUrl + "/api/Client/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processList(_response);
        });
    }

    protected processList(response: Response): Promise<PagedResultDto_1OfOfClientDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDto_1OfOfClientDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultDto_1OfOfClientDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(<any>null);
    }

    /**
     * @return Success
     */
    getnotaerial(): Promise<DropdownDto[]> {
        let url_ = this.baseUrl + "/api/Client/getnotaerial";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetnotaerial(_response);
        });
    }

    protected processGetnotaerial(response: Response): Promise<DropdownDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DropdownDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DropdownDto[]>(<any>null);
    }
}

export class ClientExternalPartnersClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    list(body: ClientExternalPartnersQueryDto | undefined): Promise<PagedResultDto_1OfOfClientExternalPartnersDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        let url_ = this.baseUrl + "/api/ClientExternalPartners/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processList(_response);
        });
    }

    protected processList(response: Response): Promise<PagedResultDto_1OfOfClientExternalPartnersDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDto_1OfOfClientExternalPartnersDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultDto_1OfOfClientExternalPartnersDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(<any>null);
    }

    /**
     * @return Success
     */
    clientExternalPartners(installationId: number): Promise<GroupCreateUpdateDto> {
        let url_ = this.baseUrl + "/api/ClientExternalPartners/{installationId}";
        if (installationId === undefined || installationId === null)
            throw new Error("The parameter 'installationId' must be defined.");
        url_ = url_.replace("{installationId}", encodeURIComponent("" + installationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processClientExternalPartners(_response);
        });
    }

    protected processClientExternalPartners(response: Response): Promise<GroupCreateUpdateDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GroupCreateUpdateDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GroupCreateUpdateDto>(<any>null);
    }
}

export class CommunicationDeviceClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    communicationDevicePost(body: CommunicationDeviceDto | undefined): Promise<CommunicationDeviceDto> {
        let url_ = this.baseUrl + "/api/CommunicationDevice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCommunicationDevicePost(_response);
        });
    }

    protected processCommunicationDevicePost(response: Response): Promise<CommunicationDeviceDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommunicationDeviceDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CommunicationDeviceDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    communicationDevicePut(body: CustomCommunicationDeviceDto | undefined): Promise<CommunicationDeviceDto> {
        let url_ = this.baseUrl + "/api/CommunicationDevice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCommunicationDevicePut(_response);
        });
    }

    protected processCommunicationDevicePut(response: Response): Promise<CommunicationDeviceDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommunicationDeviceDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CommunicationDeviceDto>(<any>null);
    }

    /**
     * @return Success
     */
    communicationDeviceGet(communicationDeviceId: number): Promise<CommunicationDeviceDto> {
        let url_ = this.baseUrl + "/api/CommunicationDevice/{communicationDeviceId}";
        if (communicationDeviceId === undefined || communicationDeviceId === null)
            throw new Error("The parameter 'communicationDeviceId' must be defined.");
        url_ = url_.replace("{communicationDeviceId}", encodeURIComponent("" + communicationDeviceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCommunicationDeviceGet(_response);
        });
    }

    protected processCommunicationDeviceGet(response: Response): Promise<CommunicationDeviceDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommunicationDeviceDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CommunicationDeviceDto>(<any>null);
    }

    communicationDeviceDelete(communicationDeviceId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/CommunicationDevice/{communicationDeviceId}";
        if (communicationDeviceId === undefined || communicationDeviceId === null)
            throw new Error("The parameter 'communicationDeviceId' must be defined.");
        url_ = url_.replace("{communicationDeviceId}", encodeURIComponent("" + communicationDeviceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCommunicationDeviceDelete(_response);
        });
    }

    protected processCommunicationDeviceDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    list(body: CommunicationDeviceQueryDto | undefined): Promise<PagedResultDto_1OfOfCommunicationDeviceDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        let url_ = this.baseUrl + "/api/CommunicationDevice/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processList(_response);
        });
    }

    protected processList(response: Response): Promise<PagedResultDto_1OfOfCommunicationDeviceDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDto_1OfOfCommunicationDeviceDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultDto_1OfOfCommunicationDeviceDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(<any>null);
    }
}

export class ContactClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    contactPost(body: CreateContactDto | undefined): Promise<ContactDto> {
        let url_ = this.baseUrl + "/api/Contact";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processContactPost(_response);
        });
    }

    protected processContactPost(response: Response): Promise<ContactDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContactDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContactDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    contactPut(body: UpdateContactDto | undefined): Promise<ContactDto> {
        let url_ = this.baseUrl + "/api/Contact";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processContactPut(_response);
        });
    }

    protected processContactPut(response: Response): Promise<ContactDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContactDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContactDto>(<any>null);
    }

    /**
     * @param clientId (optional) 
     * @return Success
     */
    contactGet(contactId: number, clientId: number | undefined): Promise<ContactDto> {
        let url_ = this.baseUrl + "/api/Contact/{contactId}?";
        if (contactId === undefined || contactId === null)
            throw new Error("The parameter 'contactId' must be defined.");
        url_ = url_.replace("{contactId}", encodeURIComponent("" + contactId));
        if (clientId === null)
            throw new Error("The parameter 'clientId' cannot be null.");
        else if (clientId !== undefined)
            url_ += "clientId=" + encodeURIComponent("" + clientId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processContactGet(_response);
        });
    }

    protected processContactGet(response: Response): Promise<ContactDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContactDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContactDto>(<any>null);
    }

    /**
     * @return Success
     */
    bynif(contactNif: string | null): Promise<ContactDto> {
        let url_ = this.baseUrl + "/api/Contact/bynif/{contactNif}";
        if (contactNif === undefined || contactNif === null)
            throw new Error("The parameter 'contactNif' must be defined.");
        url_ = url_.replace("{contactNif}", encodeURIComponent("" + contactNif));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processBynif(_response);
        });
    }

    protected processBynif(response: Response): Promise<ContactDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContactDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContactDto>(<any>null);
    }

    /**
     * @return Success
     */
    getNifList(): Promise<string[]> {
        let url_ = this.baseUrl + "/api/Contact/getNifList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetNifList(_response);
        });
    }

    protected processGetNifList(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(<any>null);
    }

    /**
     * @return Success
     */
    client(clientId: number): Promise<ContactDto[]> {
        let url_ = this.baseUrl + "/api/Contact/client/{clientId}";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processClient(_response);
        });
    }

    protected processClient(response: Response): Promise<ContactDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ContactDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContactDto[]>(<any>null);
    }

    contactDelete(contactRelativeId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/Contact/{contactRelativeId}";
        if (contactRelativeId === undefined || contactRelativeId === null)
            throw new Error("The parameter 'contactRelativeId' must be defined.");
        url_ = url_.replace("{contactRelativeId}", encodeURIComponent("" + contactRelativeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processContactDelete(_response);
        });
    }

    protected processContactDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    sendmailtest(): Promise<void> {
        let url_ = this.baseUrl + "/api/Contact/sendmailtest";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendmailtest(_response);
        });
    }

    protected processSendmailtest(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class ContractClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    contractPost(body: CreateUpdateContractDto | undefined): Promise<ContractDto> {
        let url_ = this.baseUrl + "/api/Contract";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processContractPost(_response);
        });
    }

    protected processContractPost(response: Response): Promise<ContractDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContractDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContractDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    contractPut(body: CreateUpdateContractDto | undefined): Promise<ContractDto> {
        let url_ = this.baseUrl + "/api/Contract";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processContractPut(_response);
        });
    }

    protected processContractPut(response: Response): Promise<ContractDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContractDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContractDto>(<any>null);
    }

    /**
     * @return Success
     */
    contractGet(contractId: number): Promise<ContractDto> {
        let url_ = this.baseUrl + "/api/Contract/{contractId}";
        if (contractId === undefined || contractId === null)
            throw new Error("The parameter 'contractId' must be defined.");
        url_ = url_.replace("{contractId}", encodeURIComponent("" + contractId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processContractGet(_response);
        });
    }

    protected processContractGet(response: Response): Promise<ContractDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContractDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContractDto>(<any>null);
    }

    contractDelete(contractId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/Contract/{contractId}";
        if (contractId === undefined || contractId === null)
            throw new Error("The parameter 'contractId' must be defined.");
        url_ = url_.replace("{contractId}", encodeURIComponent("" + contractId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processContractDelete(_response);
        });
    }

    protected processContractDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    logos(contractId: number): Promise<LogoFooterDto> {
        let url_ = this.baseUrl + "/api/Contract/{contractId}/logos";
        if (contractId === undefined || contractId === null)
            throw new Error("The parameter 'contractId' must be defined.");
        url_ = url_.replace("{contractId}", encodeURIComponent("" + contractId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLogos(_response);
        });
    }

    protected processLogos(response: Response): Promise<LogoFooterDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LogoFooterDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LogoFooterDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addUserAndProfessionalContract(body: UserAndProfessionalContractDto | undefined): Promise<ContractDto> {
        let url_ = this.baseUrl + "/api/Contract/addUserAndProfessionalContract";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddUserAndProfessionalContract(_response);
        });
    }

    protected processAddUserAndProfessionalContract(response: Response): Promise<ContractDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContractDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContractDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteUserAndProfessionalContract(body: UserAndProfessionalContractDto | undefined): Promise<ContractDto> {
        let url_ = this.baseUrl + "/api/Contract/deleteUserAndProfessionalContract";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteUserAndProfessionalContract(_response);
        });
    }

    protected processDeleteUserAndProfessionalContract(response: Response): Promise<ContractDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContractDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContractDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    list(body: ContractQueryDto | undefined): Promise<PagedResultDto_1OfOfContractDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        let url_ = this.baseUrl + "/api/Contract/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processList(_response);
        });
    }

    protected processList(response: Response): Promise<PagedResultDto_1OfOfContractDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDto_1OfOfContractDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultDto_1OfOfContractDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(<any>null);
    }
}

export class ContractingAuthorityClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    contractingAuthorityPost(body: CreateUpdateContractingAuthorityDto | undefined): Promise<ContractingAuthorityDto> {
        let url_ = this.baseUrl + "/api/ContractingAuthority";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processContractingAuthorityPost(_response);
        });
    }

    protected processContractingAuthorityPost(response: Response): Promise<ContractingAuthorityDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContractingAuthorityDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContractingAuthorityDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    contractingAuthorityPut(body: CreateUpdateContractingAuthorityDto | undefined): Promise<ContractingAuthorityDto> {
        let url_ = this.baseUrl + "/api/ContractingAuthority";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processContractingAuthorityPut(_response);
        });
    }

    protected processContractingAuthorityPut(response: Response): Promise<ContractingAuthorityDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContractingAuthorityDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContractingAuthorityDto>(<any>null);
    }

    /**
     * @return Success
     */
    contractingAuthorityGet(contractingAuthorityId: number): Promise<ContractingAuthorityDto> {
        let url_ = this.baseUrl + "/api/ContractingAuthority/{contractingAuthorityId}";
        if (contractingAuthorityId === undefined || contractingAuthorityId === null)
            throw new Error("The parameter 'contractingAuthorityId' must be defined.");
        url_ = url_.replace("{contractingAuthorityId}", encodeURIComponent("" + contractingAuthorityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processContractingAuthorityGet(_response);
        });
    }

    protected processContractingAuthorityGet(response: Response): Promise<ContractingAuthorityDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContractingAuthorityDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContractingAuthorityDto>(<any>null);
    }

    contractingAuthorityDelete(contractingAuthorityId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/ContractingAuthority/{contractingAuthorityId}";
        if (contractingAuthorityId === undefined || contractingAuthorityId === null)
            throw new Error("The parameter 'contractingAuthorityId' must be defined.");
        url_ = url_.replace("{contractingAuthorityId}", encodeURIComponent("" + contractingAuthorityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processContractingAuthorityDelete(_response);
        });
    }

    protected processContractingAuthorityDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    list(body: ContractingAuthorityQueryDto | undefined): Promise<PagedResultDto_1OfOfContractingAuthorityDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        let url_ = this.baseUrl + "/api/ContractingAuthority/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processList(_response);
        });
    }

    protected processList(response: Response): Promise<PagedResultDto_1OfOfContractingAuthorityDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDto_1OfOfContractingAuthorityDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultDto_1OfOfContractingAuthorityDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(<any>null);
    }
}

export class DocumentClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    documentNameGet(identificationNumber: string | null, documentName: string | null): Promise<DocumentDto> {
        let url_ = this.baseUrl + "/api/Document/user/{identificationNumber}/documentName/{documentName}";
        if (identificationNumber === undefined || identificationNumber === null)
            throw new Error("The parameter 'identificationNumber' must be defined.");
        url_ = url_.replace("{identificationNumber}", encodeURIComponent("" + identificationNumber));
        if (documentName === undefined || documentName === null)
            throw new Error("The parameter 'documentName' must be defined.");
        url_ = url_.replace("{documentName}", encodeURIComponent("" + documentName));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDocumentNameGet(_response);
        });
    }

    protected processDocumentNameGet(response: Response): Promise<DocumentDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DocumentDto>(<any>null);
    }

    /**
     * @return Success
     */
    documentNameDelete(identificationNumber: string | null, documentName: string | null): Promise<DocumentDto> {
        let url_ = this.baseUrl + "/api/Document/user/{identificationNumber}/documentName/{documentName}";
        if (identificationNumber === undefined || identificationNumber === null)
            throw new Error("The parameter 'identificationNumber' must be defined.");
        url_ = url_.replace("{identificationNumber}", encodeURIComponent("" + identificationNumber));
        if (documentName === undefined || documentName === null)
            throw new Error("The parameter 'documentName' must be defined.");
        url_ = url_.replace("{documentName}", encodeURIComponent("" + documentName));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDocumentNameDelete(_response);
        });
    }

    protected processDocumentNameDelete(response: Response): Promise<DocumentDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DocumentDto>(<any>null);
    }

    /**
     * @return Success
     */
    typeDocumentGet(identificationNumber: string | null, documentName: string | null, typeDocument: OhlConstants_TypeDocument): Promise<DocumentDto> {
        let url_ = this.baseUrl + "/api/Document/user/{identificationNumber}/documentName/{documentName}/TypeDocument/{typeDocument}";
        if (identificationNumber === undefined || identificationNumber === null)
            throw new Error("The parameter 'identificationNumber' must be defined.");
        url_ = url_.replace("{identificationNumber}", encodeURIComponent("" + identificationNumber));
        if (documentName === undefined || documentName === null)
            throw new Error("The parameter 'documentName' must be defined.");
        url_ = url_.replace("{documentName}", encodeURIComponent("" + documentName));
        if (typeDocument === undefined || typeDocument === null)
            throw new Error("The parameter 'typeDocument' must be defined.");
        url_ = url_.replace("{typeDocument}", encodeURIComponent("" + typeDocument));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTypeDocumentGet(_response);
        });
    }

    protected processTypeDocumentGet(response: Response): Promise<DocumentDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DocumentDto>(<any>null);
    }

    /**
     * @return Success
     */
    typeDocumentDelete(identificationNumber: string | null, documentName: string | null, typeDocument: OhlConstants_TypeDocument): Promise<DocumentDto> {
        let url_ = this.baseUrl + "/api/Document/user/{identificationNumber}/documentName/{documentName}/TypeDocument/{typeDocument}";
        if (identificationNumber === undefined || identificationNumber === null)
            throw new Error("The parameter 'identificationNumber' must be defined.");
        url_ = url_.replace("{identificationNumber}", encodeURIComponent("" + identificationNumber));
        if (documentName === undefined || documentName === null)
            throw new Error("The parameter 'documentName' must be defined.");
        url_ = url_.replace("{documentName}", encodeURIComponent("" + documentName));
        if (typeDocument === undefined || typeDocument === null)
            throw new Error("The parameter 'typeDocument' must be defined.");
        url_ = url_.replace("{typeDocument}", encodeURIComponent("" + typeDocument));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTypeDocumentDelete(_response);
        });
    }

    protected processTypeDocumentDelete(response: Response): Promise<DocumentDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DocumentDto>(<any>null);
    }

    /**
     * @return Success
     */
    documentGet(identificationNumber: string | null, documentName: string | null, typeDocument: OhlConstants_TypeDocument, userType: UserType): Promise<DocumentDto> {
        let url_ = this.baseUrl + "/api/Document/{userType}/{typeDocument}/{identificationNumber}/{documentName}";
        if (identificationNumber === undefined || identificationNumber === null)
            throw new Error("The parameter 'identificationNumber' must be defined.");
        url_ = url_.replace("{identificationNumber}", encodeURIComponent("" + identificationNumber));
        if (documentName === undefined || documentName === null)
            throw new Error("The parameter 'documentName' must be defined.");
        url_ = url_.replace("{documentName}", encodeURIComponent("" + documentName));
        if (typeDocument === undefined || typeDocument === null)
            throw new Error("The parameter 'typeDocument' must be defined.");
        url_ = url_.replace("{typeDocument}", encodeURIComponent("" + typeDocument));
        if (userType === undefined || userType === null)
            throw new Error("The parameter 'userType' must be defined.");
        url_ = url_.replace("{userType}", encodeURIComponent("" + userType));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDocumentGet(_response);
        });
    }

    protected processDocumentGet(response: Response): Promise<DocumentDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DocumentDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    documentPost(body: DocumentDto | undefined): Promise<DocumentDto> {
        let url_ = this.baseUrl + "/api/Document";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDocumentPost(_response);
        });
    }

    protected processDocumentPost(response: Response): Promise<DocumentDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DocumentDto>(<any>null);
    }

    /**
     * @return Success
     */
    list(identificationNumber: string | null): Promise<DocumentListDto> {
        let url_ = this.baseUrl + "/api/Document/user/{identificationNumber}/list";
        if (identificationNumber === undefined || identificationNumber === null)
            throw new Error("The parameter 'identificationNumber' must be defined.");
        url_ = url_.replace("{identificationNumber}", encodeURIComponent("" + identificationNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processList(_response);
        });
    }

    protected processList(response: Response): Promise<DocumentListDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentListDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DocumentListDto>(<any>null);
    }

    /**
     * @return Success
     */
    generic(identificationNumber: string | null, typeDocument: OhlConstants_TypeDocument): Promise<DocumentListDto> {
        let url_ = this.baseUrl + "/api/Document/user/{identificationNumber}/TypeDocument/{typeDocument}/Generic";
        if (identificationNumber === undefined || identificationNumber === null)
            throw new Error("The parameter 'identificationNumber' must be defined.");
        url_ = url_.replace("{identificationNumber}", encodeURIComponent("" + identificationNumber));
        if (typeDocument === undefined || typeDocument === null)
            throw new Error("The parameter 'typeDocument' must be defined.");
        url_ = url_.replace("{typeDocument}", encodeURIComponent("" + typeDocument));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGeneric(_response);
        });
    }

    protected processGeneric(response: Response): Promise<DocumentListDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentListDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DocumentListDto>(<any>null);
    }
}

export class ExceptionClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    list(body: ActivityQueryDto | undefined): Promise<PagedResultDto_1OfOfRecordDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        let url_ = this.baseUrl + "/api/Exception/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processList(_response);
        });
    }

    protected processList(response: Response): Promise<PagedResultDto_1OfOfRecordDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDto_1OfOfRecordDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultDto_1OfOfRecordDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(<any>null);
    }
}

export class ExternalInformationClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    historyGet(clientId: number): Promise<UserHistoryDto> {
        let url_ = this.baseUrl + "/api/ExternalInformation/client/{clientId}/history";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHistoryGet(_response);
        });
    }

    protected processHistoryGet(response: Response): Promise<UserHistoryDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserHistoryDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserHistoryDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    historyPut(body: UpdateUserHistoryDto | undefined): Promise<UserHistoryDto> {
        let url_ = this.baseUrl + "/api/ExternalInformation/client/history";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHistoryPut(_response);
        });
    }

    protected processHistoryPut(response: Response): Promise<UserHistoryDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserHistoryDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserHistoryDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    interactions(body: InteractionsQueryDto | undefined): Promise<PagedResultDto_1OfOfInteractionDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        let url_ = this.baseUrl + "/api/ExternalInformation/interactions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processInteractions(_response);
        });
    }

    protected processInteractions(response: Response): Promise<PagedResultDto_1OfOfInteractionDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDto_1OfOfInteractionDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultDto_1OfOfInteractionDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    lastInteraction(body: InteractionsQueryDto | undefined): Promise<InteractionDto> {
        let url_ = this.baseUrl + "/api/ExternalInformation/lastInteraction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLastInteraction(_response);
        });
    }

    protected processLastInteraction(response: Response): Promise<InteractionDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InteractionDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InteractionDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    interactionPost(body: CreateInteractionDto | undefined): Promise<InteractionDto> {
        let url_ = this.baseUrl + "/api/ExternalInformation/client/interaction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processInteractionPost(_response);
        });
    }

    protected processInteractionPost(response: Response): Promise<InteractionDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InteractionDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InteractionDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    interactionPut(body: UpdateInteractionDto | undefined): Promise<InteractionDto> {
        let url_ = this.baseUrl + "/api/ExternalInformation/client/interaction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processInteractionPut(_response);
        });
    }

    protected processInteractionPut(response: Response): Promise<InteractionDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InteractionDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InteractionDto>(<any>null);
    }

    /**
     * @return Success
     */
    interactionGet(interactionId: number): Promise<InteractionDto> {
        let url_ = this.baseUrl + "/api/ExternalInformation/interaction/{interactionId}";
        if (interactionId === undefined || interactionId === null)
            throw new Error("The parameter 'interactionId' must be defined.");
        url_ = url_.replace("{interactionId}", encodeURIComponent("" + interactionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processInteractionGet(_response);
        });
    }

    protected processInteractionGet(response: Response): Promise<InteractionDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InteractionDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InteractionDto>(<any>null);
    }

    many(body: InteractionDto[] | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/ExternalInformation/client/interaction/many";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMany(_response);
        });
    }

    protected processMany(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    interactionDelete(interactionId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/ExternalInformation/client/interaction/{interactionId}";
        if (interactionId === undefined || interactionId === null)
            throw new Error("The parameter 'interactionId' must be defined.");
        url_ = url_.replace("{interactionId}", encodeURIComponent("" + interactionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processInteractionDelete(_response);
        });
    }

    protected processInteractionDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class JitsiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    initRoom(scheduledActivityId: number): Promise<JitsiRoom> {
        let url_ = this.baseUrl + "/api/Jitsi/ScheduledActivity/{scheduledActivityId}/InitRoom";
        if (scheduledActivityId === undefined || scheduledActivityId === null)
            throw new Error("The parameter 'scheduledActivityId' must be defined.");
        url_ = url_.replace("{scheduledActivityId}", encodeURIComponent("" + scheduledActivityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "PUT",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processInitRoom(_response);
        });
    }

    protected processInitRoom(response: Response): Promise<JitsiRoom> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JitsiRoom.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JitsiRoom>(<any>null);
    }

    /**
     * @return Success
     */
    end(scheduledActivityId: number): Promise<ScheduledActivityDto> {
        let url_ = this.baseUrl + "/api/Jitsi/ScheduledActivity/{scheduledActivityId}/End";
        if (scheduledActivityId === undefined || scheduledActivityId === null)
            throw new Error("The parameter 'scheduledActivityId' must be defined.");
        url_ = url_.replace("{scheduledActivityId}", encodeURIComponent("" + scheduledActivityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "PUT",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEnd(_response);
        });
    }

    protected processEnd(response: Response): Promise<ScheduledActivityDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScheduledActivityDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ScheduledActivityDto>(<any>null);
    }

    /**
     * @return Success
     */
    jitsiRoom(scheduledActivityId: number): Promise<JitsiRoom> {
        let url_ = this.baseUrl + "/api/Jitsi/ScheduledActivity/{scheduledActivityId}/JitsiRoom";
        if (scheduledActivityId === undefined || scheduledActivityId === null)
            throw new Error("The parameter 'scheduledActivityId' must be defined.");
        url_ = url_.replace("{scheduledActivityId}", encodeURIComponent("" + scheduledActivityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processJitsiRoom(_response);
        });
    }

    protected processJitsiRoom(response: Response): Promise<JitsiRoom> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JitsiRoom.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JitsiRoom>(<any>null);
    }

    /**
     * @return Success
     */
    jitsiToken(scheduledActivityId: number): Promise<JitsiRoom> {
        let url_ = this.baseUrl + "/api/Jitsi/ScheduledActivity/{scheduledActivityId}/JitsiToken";
        if (scheduledActivityId === undefined || scheduledActivityId === null)
            throw new Error("The parameter 'scheduledActivityId' must be defined.");
        url_ = url_.replace("{scheduledActivityId}", encodeURIComponent("" + scheduledActivityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processJitsiToken(_response);
        });
    }

    protected processJitsiToken(response: Response): Promise<JitsiRoom> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = JitsiRoom.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JitsiRoom>(<any>null);
    }

    /**
     * @return Success
     */
    clientConnect(scheduledActivityId: number): Promise<number> {
        let url_ = this.baseUrl + "/api/Jitsi/ScheduledActivity/{scheduledActivityId}/ClientConnect";
        if (scheduledActivityId === undefined || scheduledActivityId === null)
            throw new Error("The parameter 'scheduledActivityId' must be defined.");
        url_ = url_.replace("{scheduledActivityId}", encodeURIComponent("" + scheduledActivityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processClientConnect(_response);
        });
    }

    protected processClientConnect(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(<any>null);
    }

    /**
     * @return Success
     */
    clientDisconnect(scheduledActivityId: number): Promise<number> {
        let url_ = this.baseUrl + "/api/Jitsi/ScheduledActivity/{scheduledActivityId}/ClientDisconnect";
        if (scheduledActivityId === undefined || scheduledActivityId === null)
            throw new Error("The parameter 'scheduledActivityId' must be defined.");
        url_ = url_.replace("{scheduledActivityId}", encodeURIComponent("" + scheduledActivityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processClientDisconnect(_response);
        });
    }

    protected processClientDisconnect(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(<any>null);
    }

    /**
     * @return Success
     */
    refreshAllClients(scheduledActivityId: number): Promise<number> {
        let url_ = this.baseUrl + "/api/Jitsi/ScheduledActivity/{scheduledActivityId}/RefreshAllClients";
        if (scheduledActivityId === undefined || scheduledActivityId === null)
            throw new Error("The parameter 'scheduledActivityId' must be defined.");
        url_ = url_.replace("{scheduledActivityId}", encodeURIComponent("" + scheduledActivityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRefreshAllClients(_response);
        });
    }

    protected processRefreshAllClients(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(<any>null);
    }
}

export class JobsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    send2faemails(): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Jobs/send2faemails";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSend2faemails(_response);
        });
    }

    protected processSend2faemails(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(<any>null);
    }
}

export class LoginClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    authenticate(body: LoginRequestDto | undefined): Promise<AuthenticateResultDto> {
        let url_ = this.baseUrl + "/api/Login/authenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAuthenticate(_response);
        });
    }

    protected processAuthenticate(response: Response): Promise<AuthenticateResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthenticateResultDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AuthenticateResultDto>(<any>null);
    }

    /**
     * @return Success
     */
    renew(): Promise<AuthenticateResultDto> {
        let url_ = this.baseUrl + "/api/Login/renew";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRenew(_response);
        });
    }

    protected processRenew(response: Response): Promise<AuthenticateResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthenticateResultDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AuthenticateResultDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    authenticateAppFamiliares(body: LoginRequestDto | undefined): Promise<AuthenticateResultDto> {
        let url_ = this.baseUrl + "/api/Login/authenticateAppFamiliares";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAuthenticateAppFamiliares(_response);
        });
    }

    protected processAuthenticateAppFamiliares(response: Response): Promise<AuthenticateResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthenticateResultDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AuthenticateResultDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeDefaultPassword(body: ChangeDefaultPasswordDto | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Login/changeDefaultPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processChangeDefaultPassword(_response);
        });
    }

    protected processChangeDefaultPassword(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    forgotPassword(body: ForgotPasswordDto | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Login/forgotPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processForgotPassword(_response);
        });
    }

    protected processForgotPassword(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(<any>null);
    }

    /**
     * @return Success
     */
    current(): Promise<CurrentUserDto2> {
        let url_ = this.baseUrl + "/api/Login/current";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCurrent(_response);
        });
    }

    protected processCurrent(response: Response): Promise<CurrentUserDto2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CurrentUserDto2.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CurrentUserDto2>(<any>null);
    }
}

export class LogsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    logs(body: LogsDto | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Logs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLogs(_response);
        });
    }

    protected processLogs(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class MasterTableClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    multiple(body: MasterTableListQueryDto | undefined): Promise<MasterTableListResult> {
        let url_ = this.baseUrl + "/api/MasterTable/multiple";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMultiple(_response);
        });
    }

    protected processMultiple(response: Response): Promise<MasterTableListResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MasterTableListResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MasterTableListResult>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    single(body: MasterTableQueryDto | undefined): Promise<MasterTableResult> {
        let url_ = this.baseUrl + "/api/MasterTable/single";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSingle(_response);
        });
    }

    protected processSingle(response: Response): Promise<MasterTableResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MasterTableResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MasterTableResult>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    masterTable(body: CreateOrUpdateMasterTable[] | null | undefined): Promise<MasterTableResult> {
        let url_ = this.baseUrl + "/api/MasterTable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMasterTable(_response);
        });
    }

    protected processMasterTable(response: Response): Promise<MasterTableResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MasterTableResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MasterTableResult>(<any>null);
    }
}

export class ObjectiveClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    list(body: ScaleObjectiveQueryDto | undefined): Promise<PagedResultDto_1OfOfScaleObjectiveDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        let url_ = this.baseUrl + "/api/Objective/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processList(_response);
        });
    }

    protected processList(response: Response): Promise<PagedResultDto_1OfOfScaleObjectiveDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDto_1OfOfScaleObjectiveDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultDto_1OfOfScaleObjectiveDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    objectivePost(body: CreateUpdateScaleObjectiveDto | undefined): Promise<ScaleObjectiveDto> {
        let url_ = this.baseUrl + "/api/Objective";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processObjectivePost(_response);
        });
    }

    protected processObjectivePost(response: Response): Promise<ScaleObjectiveDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScaleObjectiveDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ScaleObjectiveDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    objectivePut(body: CreateUpdateScaleObjectiveDto | undefined): Promise<ScaleObjectiveDto> {
        let url_ = this.baseUrl + "/api/Objective";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processObjectivePut(_response);
        });
    }

    protected processObjectivePut(response: Response): Promise<ScaleObjectiveDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScaleObjectiveDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ScaleObjectiveDto>(<any>null);
    }

    /**
     * @return Success
     */
    objectiveGet(objectiveId: number): Promise<ScaleObjectiveDto> {
        let url_ = this.baseUrl + "/api/Objective/{objectiveId}";
        if (objectiveId === undefined || objectiveId === null)
            throw new Error("The parameter 'objectiveId' must be defined.");
        url_ = url_.replace("{objectiveId}", encodeURIComponent("" + objectiveId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processObjectiveGet(_response);
        });
    }

    protected processObjectiveGet(response: Response): Promise<ScaleObjectiveDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScaleObjectiveDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ScaleObjectiveDto>(<any>null);
    }
}

export class PlannedActivityClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    list(): Promise<PagedResultDto_1OfOfPlannedActivityDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        let url_ = this.baseUrl + "/api/PlannedActivity/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processList(_response);
        });
    }

    protected processList(response: Response): Promise<PagedResultDto_1OfOfPlannedActivityDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDto_1OfOfPlannedActivityDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultDto_1OfOfPlannedActivityDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    initialProcess(body: InitialPlannedActivityDto | undefined): Promise<PagedResultDto_1OfOfPlannedActivityDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        let url_ = this.baseUrl + "/api/PlannedActivity/initialProcess";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processInitialProcess(_response);
        });
    }

    protected processInitialProcess(response: Response): Promise<PagedResultDto_1OfOfPlannedActivityDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDto_1OfOfPlannedActivityDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultDto_1OfOfPlannedActivityDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    plannedActivity(body: CreatePlannedActivityDto | undefined): Promise<PlannedActivityDto> {
        let url_ = this.baseUrl + "/api/PlannedActivity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPlannedActivity(_response);
        });
    }

    protected processPlannedActivity(response: Response): Promise<PlannedActivityDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PlannedActivityDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlannedActivityDto>(<any>null);
    }
}

export class ProfessionalClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    professionalPost(body: CreateUpdateProfessionalDto | undefined): Promise<ProfessionalDto> {
        let url_ = this.baseUrl + "/api/Professional";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProfessionalPost(_response);
        });
    }

    protected processProfessionalPost(response: Response): Promise<ProfessionalDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProfessionalDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProfessionalDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    professionalPut(body: CreateUpdateProfessionalDto | undefined): Promise<ProfessionalDto> {
        let url_ = this.baseUrl + "/api/Professional";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProfessionalPut(_response);
        });
    }

    protected processProfessionalPut(response: Response): Promise<ProfessionalDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProfessionalDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProfessionalDto>(<any>null);
    }

    /**
     * @return Success
     */
    professionalGet(professionalId: number): Promise<ProfessionalDto> {
        let url_ = this.baseUrl + "/api/Professional/{ProfessionalId}";
        if (professionalId === undefined || professionalId === null)
            throw new Error("The parameter 'professionalId' must be defined.");
        url_ = url_.replace("{ProfessionalId}", encodeURIComponent("" + professionalId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProfessionalGet(_response);
        });
    }

    protected processProfessionalGet(response: Response): Promise<ProfessionalDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProfessionalDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProfessionalDto>(<any>null);
    }

    /**
     * @return Success
     */
    user(userId: number): Promise<ProfessionalDto> {
        let url_ = this.baseUrl + "/api/Professional/user/{UserId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUser(_response);
        });
    }

    protected processUser(response: Response): Promise<ProfessionalDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProfessionalDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProfessionalDto>(<any>null);
    }

    /**
     * @return Success
     */
    profile(identificationNumber: string | null): Promise<ImageAttachmentProfessional> {
        let url_ = this.baseUrl + "/api/Professional/profile/{IdentificationNumber}";
        if (identificationNumber === undefined || identificationNumber === null)
            throw new Error("The parameter 'identificationNumber' must be defined.");
        url_ = url_.replace("{IdentificationNumber}", encodeURIComponent("" + identificationNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProfile(_response);
        });
    }

    protected processProfile(response: Response): Promise<ImageAttachmentProfessional> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImageAttachmentProfessional.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImageAttachmentProfessional>(<any>null);
    }

    professionalDelete(professionalId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/Professional/{professionalId}";
        if (professionalId === undefined || professionalId === null)
            throw new Error("The parameter 'professionalId' must be defined.");
        url_ = url_.replace("{professionalId}", encodeURIComponent("" + professionalId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProfessionalDelete(_response);
        });
    }

    protected processProfessionalDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    list(body: ProfessionalQueryDto | undefined): Promise<PagedResultDto_1OfOfProfessionalDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        let url_ = this.baseUrl + "/api/Professional/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processList(_response);
        });
    }

    protected processList(response: Response): Promise<PagedResultDto_1OfOfProfessionalDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDto_1OfOfProfessionalDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultDto_1OfOfProfessionalDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(<any>null);
    }
}

export class RoleClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    professionals(): Promise<RoleDto[]> {
        let url_ = this.baseUrl + "/api/Role/professionals";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProfessionals(_response);
        });
    }

    protected processProfessionals(response: Response): Promise<RoleDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RoleDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RoleDto[]>(<any>null);
    }
}

export class ScaleClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    all(body: ScaleQueryDto | undefined): Promise<PagedResultDto_1OfOfScaleDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        let url_ = this.baseUrl + "/api/Scale/All";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAll(_response);
        });
    }

    protected processAll(response: Response): Promise<PagedResultDto_1OfOfScaleDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDto_1OfOfScaleDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultDto_1OfOfScaleDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    list(body: ScaleRegisterQueryDto | undefined): Promise<PagedResultDto_1OfOfScaleRegisterDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        let url_ = this.baseUrl + "/api/Scale/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processList(_response);
        });
    }

    protected processList(response: Response): Promise<PagedResultDto_1OfOfScaleRegisterDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDto_1OfOfScaleRegisterDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultDto_1OfOfScaleRegisterDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(<any>null);
    }

    /**
     * @return Success
     */
    scaleById(scaleId: number): Promise<ScaleDto> {
        let url_ = this.baseUrl + "/api/Scale/ScaleById/{scaleId}";
        if (scaleId === undefined || scaleId === null)
            throw new Error("The parameter 'scaleId' must be defined.");
        url_ = url_.replace("{scaleId}", encodeURIComponent("" + scaleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processScaleById(_response);
        });
    }

    protected processScaleById(response: Response): Promise<ScaleDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScaleDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ScaleDto>(<any>null);
    }

    /**
     * @return Success
     */
    scaleGet(scaleRegisterId: number): Promise<ScaleRegisterDto> {
        let url_ = this.baseUrl + "/api/Scale/{scaleRegisterId}";
        if (scaleRegisterId === undefined || scaleRegisterId === null)
            throw new Error("The parameter 'scaleRegisterId' must be defined.");
        url_ = url_.replace("{scaleRegisterId}", encodeURIComponent("" + scaleRegisterId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processScaleGet(_response);
        });
    }

    protected processScaleGet(response: Response): Promise<ScaleRegisterDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScaleRegisterDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ScaleRegisterDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updatedNote(body: CreateUpdateScaleRegisterDto | undefined): Promise<ScaleRegisterDto> {
        let url_ = this.baseUrl + "/api/Scale/UpdatedNote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdatedNote(_response);
        });
    }

    protected processUpdatedNote(response: Response): Promise<ScaleRegisterDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScaleRegisterDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ScaleRegisterDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    finishScaleRegister(body: FinishScaleRegisterDto | undefined): Promise<ScaleRegisterDto> {
        let url_ = this.baseUrl + "/api/Scale/FinishScaleRegister";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processFinishScaleRegister(_response);
        });
    }

    protected processFinishScaleRegister(response: Response): Promise<ScaleRegisterDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScaleRegisterDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ScaleRegisterDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    scalePost(body: CreateUpdateScaleRegisterDto | undefined): Promise<ScaleRegisterDto> {
        let url_ = this.baseUrl + "/api/Scale";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processScalePost(_response);
        });
    }

    protected processScalePost(response: Response): Promise<ScaleRegisterDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScaleRegisterDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ScaleRegisterDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    scalePut(body: CreateUpdateScaleRegisterDto | undefined): Promise<ScaleRegisterDto> {
        let url_ = this.baseUrl + "/api/Scale";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processScalePut(_response);
        });
    }

    protected processScalePut(response: Response): Promise<ScaleRegisterDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScaleRegisterDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ScaleRegisterDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updatedResponse(body: UpdateScaleResponseDto | undefined): Promise<ScaleResponseDto> {
        let url_ = this.baseUrl + "/api/Scale/UpdatedResponse";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdatedResponse(_response);
        });
    }

    protected processUpdatedResponse(response: Response): Promise<ScaleResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScaleResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ScaleResponseDto>(<any>null);
    }
}

export class ScheduledActivityClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    scheduledActivityGet(scheduledActivityId: number): Promise<ScheduledActivityDto> {
        let url_ = this.baseUrl + "/api/ScheduledActivity/{scheduledActivityId}";
        if (scheduledActivityId === undefined || scheduledActivityId === null)
            throw new Error("The parameter 'scheduledActivityId' must be defined.");
        url_ = url_.replace("{scheduledActivityId}", encodeURIComponent("" + scheduledActivityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processScheduledActivityGet(_response);
        });
    }

    protected processScheduledActivityGet(response: Response): Promise<ScheduledActivityDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScheduledActivityDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ScheduledActivityDto>(<any>null);
    }

    scheduledActivityDelete(scheduledActivityId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/ScheduledActivity/{scheduledActivityId}";
        if (scheduledActivityId === undefined || scheduledActivityId === null)
            throw new Error("The parameter 'scheduledActivityId' must be defined.");
        url_ = url_.replace("{scheduledActivityId}", encodeURIComponent("" + scheduledActivityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processScheduledActivityDelete(_response);
        });
    }

    protected processScheduledActivityDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    list(body: ScheduledActivityQueryDto | undefined): Promise<PagedResultDto_1OfOfScheduledActivityDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        let url_ = this.baseUrl + "/api/ScheduledActivity/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processList(_response);
        });
    }

    protected processList(response: Response): Promise<PagedResultDto_1OfOfScheduledActivityDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDto_1OfOfScheduledActivityDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultDto_1OfOfScheduledActivityDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    scheduledActivityPut(body: ScheduledActivityDto | undefined): Promise<ScheduledActivityDto> {
        let url_ = this.baseUrl + "/api/ScheduledActivity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processScheduledActivityPut(_response);
        });
    }

    protected processScheduledActivityPut(response: Response): Promise<ScheduledActivityDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScheduledActivityDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ScheduledActivityDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    comments(body: ScheduledActivityDto | undefined): Promise<ScheduledActivityDto> {
        let url_ = this.baseUrl + "/api/ScheduledActivity/comments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processComments(_response);
        });
    }

    protected processComments(response: Response): Promise<ScheduledActivityDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScheduledActivityDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ScheduledActivityDto>(<any>null);
    }

    /**
     * @return Success
     */
    calendar(): Promise<CalendarDayDto[]> {
        let url_ = this.baseUrl + "/api/ScheduledActivity/calendar";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCalendar(_response);
        });
    }

    protected processCalendar(response: Response): Promise<CalendarDayDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CalendarDayDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CalendarDayDto[]>(<any>null);
    }

    updateStatusScheduledActivity(): Promise<void> {
        let url_ = this.baseUrl + "/api/ScheduledActivity/updateStatusScheduledActivity";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "PUT",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateStatusScheduledActivity(_response);
        });
    }

    protected processUpdateStatusScheduledActivity(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    cancelScheduledActivity(scheduledActivityId: number | undefined, reasonForCancellationId: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/ScheduledActivity/cancelScheduledActivity?";
        if (scheduledActivityId === null)
            throw new Error("The parameter 'scheduledActivityId' cannot be null.");
        else if (scheduledActivityId !== undefined)
            url_ += "scheduledActivityId=" + encodeURIComponent("" + scheduledActivityId) + "&";
        if (reasonForCancellationId === null)
            throw new Error("The parameter 'reasonForCancellationId' cannot be null.");
        else if (reasonForCancellationId !== undefined)
            url_ += "reasonForCancellationId=" + encodeURIComponent("" + reasonForCancellationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "PUT",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCancelScheduledActivity(_response);
        });
    }

    protected processCancelScheduledActivity(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class ServicePackageClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    list(body: ServicePackageQueryDto | undefined): Promise<PagedResultDto_1OfOfServicePackageDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        let url_ = this.baseUrl + "/api/ServicePackage/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processList(_response);
        });
    }

    protected processList(response: Response): Promise<PagedResultDto_1OfOfServicePackageDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDto_1OfOfServicePackageDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultDto_1OfOfServicePackageDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(<any>null);
    }

    /**
     * @return Success
     */
    servicePackageGet(servicePackageId: number): Promise<ServicePackageDto> {
        let url_ = this.baseUrl + "/api/ServicePackage/{servicePackageId}";
        if (servicePackageId === undefined || servicePackageId === null)
            throw new Error("The parameter 'servicePackageId' must be defined.");
        url_ = url_.replace("{servicePackageId}", encodeURIComponent("" + servicePackageId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processServicePackageGet(_response);
        });
    }

    protected processServicePackageGet(response: Response): Promise<ServicePackageDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServicePackageDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ServicePackageDto>(<any>null);
    }

    servicePackageDelete(servicePackageId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/ServicePackage/{servicePackageId}";
        if (servicePackageId === undefined || servicePackageId === null)
            throw new Error("The parameter 'servicePackageId' must be defined.");
        url_ = url_.replace("{servicePackageId}", encodeURIComponent("" + servicePackageId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processServicePackageDelete(_response);
        });
    }

    protected processServicePackageDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    servicePackagePut(body: CreateUpdateServicePackageDto | undefined): Promise<ServicePackageDto> {
        let url_ = this.baseUrl + "/api/ServicePackage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processServicePackagePut(_response);
        });
    }

    protected processServicePackagePut(response: Response): Promise<ServicePackageDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServicePackageDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ServicePackageDto>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    servicePackagePost(body: CreateUpdateServicePackageDto | undefined): Promise<ServicePackageDto> {
        let url_ = this.baseUrl + "/api/ServicePackage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processServicePackagePost(_response);
        });
    }

    protected processServicePackagePost(response: Response): Promise<ServicePackageDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServicePackageDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ServicePackageDto>(<any>null);
    }
}

export class SSENotifierClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    suscribe(room: string | null, client: string | null): Promise<boolean> {
        let url_ = this.baseUrl + "/api/SSENotifier/suscribe/{room}/{client}";
        if (room === undefined || room === null)
            throw new Error("The parameter 'room' must be defined.");
        url_ = url_.replace("{room}", encodeURIComponent("" + room));
        if (client === undefined || client === null)
            throw new Error("The parameter 'client' must be defined.");
        url_ = url_.replace("{client}", encodeURIComponent("" + client));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSuscribe(_response);
        });
    }

    protected processSuscribe(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(<any>null);
    }

    publish(body: SSEEvent | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/SSENotifier/publish";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPublish(_response);
        });
    }

    protected processPublish(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    notify(body: SSEEvent | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/SSENotifier/notify";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processNotify(_response);
        });
    }

    protected processNotify(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class SuggestionClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    suggestion(body: CreateUpdateSuggestionDto | undefined): Promise<SuggestionDto> {
        let url_ = this.baseUrl + "/api/Suggestion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSuggestion(_response);
        });
    }

    protected processSuggestion(response: Response): Promise<SuggestionDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SuggestionDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SuggestionDto>(<any>null);
    }
}

export class TownClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    list(body: TownQueryDto | undefined): Promise<PagedResultDto_1OfOfTownDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        let url_ = this.baseUrl + "/api/Town/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processList(_response);
        });
    }

    protected processList(response: Response): Promise<PagedResultDto_1OfOfTownDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDto_1OfOfTownDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultDto_1OfOfTownDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(<any>null);
    }

    /**
     * @return Success
     */
    provinces(townId: number): Promise<MasterTableResult> {
        let url_ = this.baseUrl + "/api/Town/provinces/{townId}";
        if (townId === undefined || townId === null)
            throw new Error("The parameter 'townId' must be defined.");
        url_ = url_.replace("{townId}", encodeURIComponent("" + townId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProvinces(_response);
        });
    }

    protected processProvinces(response: Response): Promise<MasterTableResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MasterTableResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MasterTableResult>(<any>null);
    }
}

export class WeeklyScheduleClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    list(body: WeeklyScheduleQueryDto | undefined): Promise<PagedResultDto_1OfOfWeeklyScheduleDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        let url_ = this.baseUrl + "/api/WeeklySchedule/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processList(_response);
        });
    }

    protected processList(response: Response): Promise<PagedResultDto_1OfOfWeeklyScheduleDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDto_1OfOfWeeklyScheduleDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultDto_1OfOfWeeklyScheduleDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(<any>null);
    }

    weeklySchedule(body: CreateUpdateWeeklyScheduleDto | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/WeeklySchedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processWeeklySchedule(_response);
        });
    }

    protected processWeeklySchedule(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = RemoteServiceErrorResponse.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = RemoteServiceErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = RemoteServiceErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = RemoteServiceErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            let result501: any = null;
            let resultData501 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result501 = RemoteServiceErrorResponse.fromJS(resultData501);
            return throwException("Server Error", status, _responseText, _headers, result501);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = RemoteServiceErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class ControllerInterfaceApiDescriptionModel implements IControllerInterfaceApiDescriptionModel {
    type?: string | undefined;

    constructor(data?: IControllerInterfaceApiDescriptionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): ControllerInterfaceApiDescriptionModel {
        data = typeof data === 'object' ? data : {};
        let result = new ControllerInterfaceApiDescriptionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        return data;
    }
}

export interface IControllerInterfaceApiDescriptionModel {
    type?: string | undefined;
}

export class MethodParameterApiDescriptionModel implements IMethodParameterApiDescriptionModel {
    name?: string | undefined;
    typeAsString?: string | undefined;
    type?: string | undefined;
    typeSimple?: string | undefined;
    isOptional?: boolean;
    defaultValue?: any | undefined;

    constructor(data?: IMethodParameterApiDescriptionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.typeAsString = _data["typeAsString"];
            this.type = _data["type"];
            this.typeSimple = _data["typeSimple"];
            this.isOptional = _data["isOptional"];
            this.defaultValue = _data["defaultValue"];
        }
    }

    static fromJS(data: any): MethodParameterApiDescriptionModel {
        data = typeof data === 'object' ? data : {};
        let result = new MethodParameterApiDescriptionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["typeAsString"] = this.typeAsString;
        data["type"] = this.type;
        data["typeSimple"] = this.typeSimple;
        data["isOptional"] = this.isOptional;
        data["defaultValue"] = this.defaultValue;
        return data;
    }
}

export interface IMethodParameterApiDescriptionModel {
    name?: string | undefined;
    typeAsString?: string | undefined;
    type?: string | undefined;
    typeSimple?: string | undefined;
    isOptional?: boolean;
    defaultValue?: any | undefined;
}

export class ParameterApiDescriptionModel implements IParameterApiDescriptionModel {
    nameOnMethod?: string | undefined;
    name?: string | undefined;
    type?: string | undefined;
    typeSimple?: string | undefined;
    isOptional?: boolean;
    defaultValue?: any | undefined;
    constraintTypes?: string[] | undefined;
    bindingSourceId?: string | undefined;
    descriptorName?: string | undefined;

    constructor(data?: IParameterApiDescriptionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nameOnMethod = _data["nameOnMethod"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.typeSimple = _data["typeSimple"];
            this.isOptional = _data["isOptional"];
            this.defaultValue = _data["defaultValue"];
            if (Array.isArray(_data["constraintTypes"])) {
                this.constraintTypes = [] as any;
                for (let item of _data["constraintTypes"])
                    this.constraintTypes!.push(item);
            }
            this.bindingSourceId = _data["bindingSourceId"];
            this.descriptorName = _data["descriptorName"];
        }
    }

    static fromJS(data: any): ParameterApiDescriptionModel {
        data = typeof data === 'object' ? data : {};
        let result = new ParameterApiDescriptionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nameOnMethod"] = this.nameOnMethod;
        data["name"] = this.name;
        data["type"] = this.type;
        data["typeSimple"] = this.typeSimple;
        data["isOptional"] = this.isOptional;
        data["defaultValue"] = this.defaultValue;
        if (Array.isArray(this.constraintTypes)) {
            data["constraintTypes"] = [];
            for (let item of this.constraintTypes)
                data["constraintTypes"].push(item);
        }
        data["bindingSourceId"] = this.bindingSourceId;
        data["descriptorName"] = this.descriptorName;
        return data;
    }
}

export interface IParameterApiDescriptionModel {
    nameOnMethod?: string | undefined;
    name?: string | undefined;
    type?: string | undefined;
    typeSimple?: string | undefined;
    isOptional?: boolean;
    defaultValue?: any | undefined;
    constraintTypes?: string[] | undefined;
    bindingSourceId?: string | undefined;
    descriptorName?: string | undefined;
}

export class ReturnValueApiDescriptionModel implements IReturnValueApiDescriptionModel {
    type?: string | undefined;
    typeSimple?: string | undefined;

    constructor(data?: IReturnValueApiDescriptionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.typeSimple = _data["typeSimple"];
        }
    }

    static fromJS(data: any): ReturnValueApiDescriptionModel {
        data = typeof data === 'object' ? data : {};
        let result = new ReturnValueApiDescriptionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["typeSimple"] = this.typeSimple;
        return data;
    }
}

export interface IReturnValueApiDescriptionModel {
    type?: string | undefined;
    typeSimple?: string | undefined;
}

export class ActionApiDescriptionModel implements IActionApiDescriptionModel {
    uniqueName?: string | undefined;
    name?: string | undefined;
    httpMethod?: string | undefined;
    url?: string | undefined;
    supportedVersions?: string[] | undefined;
    parametersOnMethod?: MethodParameterApiDescriptionModel[] | undefined;
    parameters?: ParameterApiDescriptionModel[] | undefined;
    returnValue?: ReturnValueApiDescriptionModel;

    constructor(data?: IActionApiDescriptionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uniqueName = _data["uniqueName"];
            this.name = _data["name"];
            this.httpMethod = _data["httpMethod"];
            this.url = _data["url"];
            if (Array.isArray(_data["supportedVersions"])) {
                this.supportedVersions = [] as any;
                for (let item of _data["supportedVersions"])
                    this.supportedVersions!.push(item);
            }
            if (Array.isArray(_data["parametersOnMethod"])) {
                this.parametersOnMethod = [] as any;
                for (let item of _data["parametersOnMethod"])
                    this.parametersOnMethod!.push(MethodParameterApiDescriptionModel.fromJS(item));
            }
            if (Array.isArray(_data["parameters"])) {
                this.parameters = [] as any;
                for (let item of _data["parameters"])
                    this.parameters!.push(ParameterApiDescriptionModel.fromJS(item));
            }
            this.returnValue = _data["returnValue"] ? ReturnValueApiDescriptionModel.fromJS(_data["returnValue"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ActionApiDescriptionModel {
        data = typeof data === 'object' ? data : {};
        let result = new ActionApiDescriptionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uniqueName"] = this.uniqueName;
        data["name"] = this.name;
        data["httpMethod"] = this.httpMethod;
        data["url"] = this.url;
        if (Array.isArray(this.supportedVersions)) {
            data["supportedVersions"] = [];
            for (let item of this.supportedVersions)
                data["supportedVersions"].push(item);
        }
        if (Array.isArray(this.parametersOnMethod)) {
            data["parametersOnMethod"] = [];
            for (let item of this.parametersOnMethod)
                data["parametersOnMethod"].push(item.toJSON());
        }
        if (Array.isArray(this.parameters)) {
            data["parameters"] = [];
            for (let item of this.parameters)
                data["parameters"].push(item.toJSON());
        }
        data["returnValue"] = this.returnValue ? this.returnValue.toJSON() : <any>undefined;
        return data;
    }
}

export interface IActionApiDescriptionModel {
    uniqueName?: string | undefined;
    name?: string | undefined;
    httpMethod?: string | undefined;
    url?: string | undefined;
    supportedVersions?: string[] | undefined;
    parametersOnMethod?: MethodParameterApiDescriptionModel[] | undefined;
    parameters?: ParameterApiDescriptionModel[] | undefined;
    returnValue?: ReturnValueApiDescriptionModel;
}

export class ControllerApiDescriptionModel implements IControllerApiDescriptionModel {
    controllerName?: string | undefined;
    type?: string | undefined;
    interfaces?: ControllerInterfaceApiDescriptionModel[] | undefined;
    actions?: { [key: string]: ActionApiDescriptionModel; } | undefined;

    constructor(data?: IControllerApiDescriptionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.controllerName = _data["controllerName"];
            this.type = _data["type"];
            if (Array.isArray(_data["interfaces"])) {
                this.interfaces = [] as any;
                for (let item of _data["interfaces"])
                    this.interfaces!.push(ControllerInterfaceApiDescriptionModel.fromJS(item));
            }
            if (_data["actions"]) {
                this.actions = {} as any;
                for (let key in _data["actions"]) {
                    if (_data["actions"].hasOwnProperty(key))
                        (<any>this.actions)![key] = _data["actions"][key] ? ActionApiDescriptionModel.fromJS(_data["actions"][key]) : new ActionApiDescriptionModel();
                }
            }
        }
    }

    static fromJS(data: any): ControllerApiDescriptionModel {
        data = typeof data === 'object' ? data : {};
        let result = new ControllerApiDescriptionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["controllerName"] = this.controllerName;
        data["type"] = this.type;
        if (Array.isArray(this.interfaces)) {
            data["interfaces"] = [];
            for (let item of this.interfaces)
                data["interfaces"].push(item.toJSON());
        }
        if (this.actions) {
            data["actions"] = {};
            for (let key in this.actions) {
                if (this.actions.hasOwnProperty(key))
                    (<any>data["actions"])[key] = this.actions[key] ? this.actions[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }
}

export interface IControllerApiDescriptionModel {
    controllerName?: string | undefined;
    type?: string | undefined;
    interfaces?: ControllerInterfaceApiDescriptionModel[] | undefined;
    actions?: { [key: string]: ActionApiDescriptionModel; } | undefined;
}

export class ModuleApiDescriptionModel implements IModuleApiDescriptionModel {
    rootPath?: string | undefined;
    remoteServiceName?: string | undefined;
    controllers?: { [key: string]: ControllerApiDescriptionModel; } | undefined;

    constructor(data?: IModuleApiDescriptionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rootPath = _data["rootPath"];
            this.remoteServiceName = _data["remoteServiceName"];
            if (_data["controllers"]) {
                this.controllers = {} as any;
                for (let key in _data["controllers"]) {
                    if (_data["controllers"].hasOwnProperty(key))
                        (<any>this.controllers)![key] = _data["controllers"][key] ? ControllerApiDescriptionModel.fromJS(_data["controllers"][key]) : new ControllerApiDescriptionModel();
                }
            }
        }
    }

    static fromJS(data: any): ModuleApiDescriptionModel {
        data = typeof data === 'object' ? data : {};
        let result = new ModuleApiDescriptionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rootPath"] = this.rootPath;
        data["remoteServiceName"] = this.remoteServiceName;
        if (this.controllers) {
            data["controllers"] = {};
            for (let key in this.controllers) {
                if (this.controllers.hasOwnProperty(key))
                    (<any>data["controllers"])[key] = this.controllers[key] ? this.controllers[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }
}

export interface IModuleApiDescriptionModel {
    rootPath?: string | undefined;
    remoteServiceName?: string | undefined;
    controllers?: { [key: string]: ControllerApiDescriptionModel; } | undefined;
}

export class PropertyApiDescriptionModel implements IPropertyApiDescriptionModel {
    name?: string | undefined;
    type?: string | undefined;
    typeSimple?: string | undefined;
    isRequired?: boolean;

    constructor(data?: IPropertyApiDescriptionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.type = _data["type"];
            this.typeSimple = _data["typeSimple"];
            this.isRequired = _data["isRequired"];
        }
    }

    static fromJS(data: any): PropertyApiDescriptionModel {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyApiDescriptionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["type"] = this.type;
        data["typeSimple"] = this.typeSimple;
        data["isRequired"] = this.isRequired;
        return data;
    }
}

export interface IPropertyApiDescriptionModel {
    name?: string | undefined;
    type?: string | undefined;
    typeSimple?: string | undefined;
    isRequired?: boolean;
}

export class TypeApiDescriptionModel implements ITypeApiDescriptionModel {
    baseType?: string | undefined;
    isEnum?: boolean;
    enumNames?: string[] | undefined;
    enumValues?: any[] | undefined;
    genericArguments?: string[] | undefined;
    properties?: PropertyApiDescriptionModel[] | undefined;

    constructor(data?: ITypeApiDescriptionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseType = _data["baseType"];
            this.isEnum = _data["isEnum"];
            if (Array.isArray(_data["enumNames"])) {
                this.enumNames = [] as any;
                for (let item of _data["enumNames"])
                    this.enumNames!.push(item);
            }
            if (Array.isArray(_data["enumValues"])) {
                this.enumValues = [] as any;
                for (let item of _data["enumValues"])
                    this.enumValues!.push(item);
            }
            if (Array.isArray(_data["genericArguments"])) {
                this.genericArguments = [] as any;
                for (let item of _data["genericArguments"])
                    this.genericArguments!.push(item);
            }
            if (Array.isArray(_data["properties"])) {
                this.properties = [] as any;
                for (let item of _data["properties"])
                    this.properties!.push(PropertyApiDescriptionModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TypeApiDescriptionModel {
        data = typeof data === 'object' ? data : {};
        let result = new TypeApiDescriptionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseType"] = this.baseType;
        data["isEnum"] = this.isEnum;
        if (Array.isArray(this.enumNames)) {
            data["enumNames"] = [];
            for (let item of this.enumNames)
                data["enumNames"].push(item);
        }
        if (Array.isArray(this.enumValues)) {
            data["enumValues"] = [];
            for (let item of this.enumValues)
                data["enumValues"].push(item);
        }
        if (Array.isArray(this.genericArguments)) {
            data["genericArguments"] = [];
            for (let item of this.genericArguments)
                data["genericArguments"].push(item);
        }
        if (Array.isArray(this.properties)) {
            data["properties"] = [];
            for (let item of this.properties)
                data["properties"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITypeApiDescriptionModel {
    baseType?: string | undefined;
    isEnum?: boolean;
    enumNames?: string[] | undefined;
    enumValues?: any[] | undefined;
    genericArguments?: string[] | undefined;
    properties?: PropertyApiDescriptionModel[] | undefined;
}

export class ApplicationApiDescriptionModel implements IApplicationApiDescriptionModel {
    modules?: { [key: string]: ModuleApiDescriptionModel; } | undefined;
    types?: { [key: string]: TypeApiDescriptionModel; } | undefined;

    constructor(data?: IApplicationApiDescriptionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["modules"]) {
                this.modules = {} as any;
                for (let key in _data["modules"]) {
                    if (_data["modules"].hasOwnProperty(key))
                        (<any>this.modules)![key] = _data["modules"][key] ? ModuleApiDescriptionModel.fromJS(_data["modules"][key]) : new ModuleApiDescriptionModel();
                }
            }
            if (_data["types"]) {
                this.types = {} as any;
                for (let key in _data["types"]) {
                    if (_data["types"].hasOwnProperty(key))
                        (<any>this.types)![key] = _data["types"][key] ? TypeApiDescriptionModel.fromJS(_data["types"][key]) : new TypeApiDescriptionModel();
                }
            }
        }
    }

    static fromJS(data: any): ApplicationApiDescriptionModel {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationApiDescriptionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.modules) {
            data["modules"] = {};
            for (let key in this.modules) {
                if (this.modules.hasOwnProperty(key))
                    (<any>data["modules"])[key] = this.modules[key] ? this.modules[key].toJSON() : <any>undefined;
            }
        }
        if (this.types) {
            data["types"] = {};
            for (let key in this.types) {
                if (this.types.hasOwnProperty(key))
                    (<any>data["types"])[key] = this.types[key] ? this.types[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }
}

export interface IApplicationApiDescriptionModel {
    modules?: { [key: string]: ModuleApiDescriptionModel; } | undefined;
    types?: { [key: string]: TypeApiDescriptionModel; } | undefined;
}

export class RemoteServiceValidationErrorInfo implements IRemoteServiceValidationErrorInfo {
    message?: string | undefined;
    members?: string[] | undefined;

    constructor(data?: IRemoteServiceValidationErrorInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            if (Array.isArray(_data["members"])) {
                this.members = [] as any;
                for (let item of _data["members"])
                    this.members!.push(item);
            }
        }
    }

    static fromJS(data: any): RemoteServiceValidationErrorInfo {
        data = typeof data === 'object' ? data : {};
        let result = new RemoteServiceValidationErrorInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        if (Array.isArray(this.members)) {
            data["members"] = [];
            for (let item of this.members)
                data["members"].push(item);
        }
        return data;
    }
}

export interface IRemoteServiceValidationErrorInfo {
    message?: string | undefined;
    members?: string[] | undefined;
}

export class RemoteServiceErrorInfo implements IRemoteServiceErrorInfo {
    code?: string | undefined;
    message?: string | undefined;
    details?: string | undefined;
    data?: { [key: string]: any; } | undefined;
    validationErrors?: RemoteServiceValidationErrorInfo[] | undefined;

    constructor(data?: IRemoteServiceErrorInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.message = _data["message"];
            this.details = _data["details"];
            if (_data["data"]) {
                this.data = {} as any;
                for (let key in _data["data"]) {
                    if (_data["data"].hasOwnProperty(key))
                        (<any>this.data)![key] = _data["data"][key];
                }
            }
            if (Array.isArray(_data["validationErrors"])) {
                this.validationErrors = [] as any;
                for (let item of _data["validationErrors"])
                    this.validationErrors!.push(RemoteServiceValidationErrorInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RemoteServiceErrorInfo {
        data = typeof data === 'object' ? data : {};
        let result = new RemoteServiceErrorInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["message"] = this.message;
        data["details"] = this.details;
        if (this.data) {
            data["data"] = {};
            for (let key in this.data) {
                if (this.data.hasOwnProperty(key))
                    (<any>data["data"])[key] = this.data[key];
            }
        }
        if (Array.isArray(this.validationErrors)) {
            data["validationErrors"] = [];
            for (let item of this.validationErrors)
                data["validationErrors"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRemoteServiceErrorInfo {
    code?: string | undefined;
    message?: string | undefined;
    details?: string | undefined;
    data?: { [key: string]: any; } | undefined;
    validationErrors?: RemoteServiceValidationErrorInfo[] | undefined;
}

export class RemoteServiceErrorResponse implements IRemoteServiceErrorResponse {
    error?: RemoteServiceErrorInfo;

    constructor(data?: IRemoteServiceErrorResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"] ? RemoteServiceErrorInfo.fromJS(_data["error"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RemoteServiceErrorResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RemoteServiceErrorResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRemoteServiceErrorResponse {
    error?: RemoteServiceErrorInfo;
}

export class LanguageInfo implements ILanguageInfo {
    readonly cultureName?: string | undefined;
    readonly uiCultureName?: string | undefined;
    readonly displayName?: string | undefined;
    flagIcon?: string | undefined;

    constructor(data?: ILanguageInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).cultureName = _data["cultureName"];
            (<any>this).uiCultureName = _data["uiCultureName"];
            (<any>this).displayName = _data["displayName"];
            this.flagIcon = _data["flagIcon"];
        }
    }

    static fromJS(data: any): LanguageInfo {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cultureName"] = this.cultureName;
        data["uiCultureName"] = this.uiCultureName;
        data["displayName"] = this.displayName;
        data["flagIcon"] = this.flagIcon;
        return data;
    }
}

export interface ILanguageInfo {
    cultureName?: string | undefined;
    uiCultureName?: string | undefined;
    displayName?: string | undefined;
    flagIcon?: string | undefined;
}

export class DateTimeFormatDto implements IDateTimeFormatDto {
    calendarAlgorithmType?: string | undefined;
    dateTimeFormatLong?: string | undefined;
    shortDatePattern?: string | undefined;
    fullDateTimePattern?: string | undefined;
    dateSeparator?: string | undefined;
    shortTimePattern?: string | undefined;
    longTimePattern?: string | undefined;

    constructor(data?: IDateTimeFormatDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.calendarAlgorithmType = _data["calendarAlgorithmType"];
            this.dateTimeFormatLong = _data["dateTimeFormatLong"];
            this.shortDatePattern = _data["shortDatePattern"];
            this.fullDateTimePattern = _data["fullDateTimePattern"];
            this.dateSeparator = _data["dateSeparator"];
            this.shortTimePattern = _data["shortTimePattern"];
            this.longTimePattern = _data["longTimePattern"];
        }
    }

    static fromJS(data: any): DateTimeFormatDto {
        data = typeof data === 'object' ? data : {};
        let result = new DateTimeFormatDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["calendarAlgorithmType"] = this.calendarAlgorithmType;
        data["dateTimeFormatLong"] = this.dateTimeFormatLong;
        data["shortDatePattern"] = this.shortDatePattern;
        data["fullDateTimePattern"] = this.fullDateTimePattern;
        data["dateSeparator"] = this.dateSeparator;
        data["shortTimePattern"] = this.shortTimePattern;
        data["longTimePattern"] = this.longTimePattern;
        return data;
    }
}

export interface IDateTimeFormatDto {
    calendarAlgorithmType?: string | undefined;
    dateTimeFormatLong?: string | undefined;
    shortDatePattern?: string | undefined;
    fullDateTimePattern?: string | undefined;
    dateSeparator?: string | undefined;
    shortTimePattern?: string | undefined;
    longTimePattern?: string | undefined;
}

export class CurrentCultureDto implements ICurrentCultureDto {
    displayName?: string | undefined;
    englishName?: string | undefined;
    threeLetterIsoLanguageName?: string | undefined;
    twoLetterIsoLanguageName?: string | undefined;
    isRightToLeft?: boolean;
    cultureName?: string | undefined;
    name?: string | undefined;
    nativeName?: string | undefined;
    dateTimeFormat?: DateTimeFormatDto;

    constructor(data?: ICurrentCultureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.englishName = _data["englishName"];
            this.threeLetterIsoLanguageName = _data["threeLetterIsoLanguageName"];
            this.twoLetterIsoLanguageName = _data["twoLetterIsoLanguageName"];
            this.isRightToLeft = _data["isRightToLeft"];
            this.cultureName = _data["cultureName"];
            this.name = _data["name"];
            this.nativeName = _data["nativeName"];
            this.dateTimeFormat = _data["dateTimeFormat"] ? DateTimeFormatDto.fromJS(_data["dateTimeFormat"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CurrentCultureDto {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentCultureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["englishName"] = this.englishName;
        data["threeLetterIsoLanguageName"] = this.threeLetterIsoLanguageName;
        data["twoLetterIsoLanguageName"] = this.twoLetterIsoLanguageName;
        data["isRightToLeft"] = this.isRightToLeft;
        data["cultureName"] = this.cultureName;
        data["name"] = this.name;
        data["nativeName"] = this.nativeName;
        data["dateTimeFormat"] = this.dateTimeFormat ? this.dateTimeFormat.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICurrentCultureDto {
    displayName?: string | undefined;
    englishName?: string | undefined;
    threeLetterIsoLanguageName?: string | undefined;
    twoLetterIsoLanguageName?: string | undefined;
    isRightToLeft?: boolean;
    cultureName?: string | undefined;
    name?: string | undefined;
    nativeName?: string | undefined;
    dateTimeFormat?: DateTimeFormatDto;
}

export class NameValue implements INameValue {
    name?: string | undefined;
    value?: string | undefined;

    constructor(data?: INameValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): NameValue {
        data = typeof data === 'object' ? data : {};
        let result = new NameValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface INameValue {
    name?: string | undefined;
    value?: string | undefined;
}

export class ApplicationLocalizationConfigurationDto implements IApplicationLocalizationConfigurationDto {
    values?: { [key: string]: { [key: string]: string; }; } | undefined;
    languages?: LanguageInfo[] | undefined;
    currentCulture?: CurrentCultureDto;
    defaultResourceName?: string | undefined;
    languagesMap?: { [key: string]: NameValue[]; } | undefined;
    languageFilesMap?: { [key: string]: NameValue[]; } | undefined;

    constructor(data?: IApplicationLocalizationConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["values"]) {
                this.values = {} as any;
                for (let key in _data["values"]) {
                    if (_data["values"].hasOwnProperty(key))
                        (<any>this.values)![key] = _data["values"][key] !== undefined ? _data["values"][key] : {};
                }
            }
            if (Array.isArray(_data["languages"])) {
                this.languages = [] as any;
                for (let item of _data["languages"])
                    this.languages!.push(LanguageInfo.fromJS(item));
            }
            this.currentCulture = _data["currentCulture"] ? CurrentCultureDto.fromJS(_data["currentCulture"]) : <any>undefined;
            this.defaultResourceName = _data["defaultResourceName"];
            if (_data["languagesMap"]) {
                this.languagesMap = {} as any;
                for (let key in _data["languagesMap"]) {
                    if (_data["languagesMap"].hasOwnProperty(key))
                        (<any>this.languagesMap)![key] = _data["languagesMap"][key] ? _data["languagesMap"][key].map((i: any) => NameValue.fromJS(i)) : [];
                }
            }
            if (_data["languageFilesMap"]) {
                this.languageFilesMap = {} as any;
                for (let key in _data["languageFilesMap"]) {
                    if (_data["languageFilesMap"].hasOwnProperty(key))
                        (<any>this.languageFilesMap)![key] = _data["languageFilesMap"][key] ? _data["languageFilesMap"][key].map((i: any) => NameValue.fromJS(i)) : [];
                }
            }
        }
    }

    static fromJS(data: any): ApplicationLocalizationConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationLocalizationConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.values) {
            data["values"] = {};
            for (let key in this.values) {
                if (this.values.hasOwnProperty(key))
                    (<any>data["values"])[key] = this.values[key];
            }
        }
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item.toJSON());
        }
        data["currentCulture"] = this.currentCulture ? this.currentCulture.toJSON() : <any>undefined;
        data["defaultResourceName"] = this.defaultResourceName;
        if (this.languagesMap) {
            data["languagesMap"] = {};
            for (let key in this.languagesMap) {
                if (this.languagesMap.hasOwnProperty(key))
                    (<any>data["languagesMap"])[key] = this.languagesMap[key];
            }
        }
        if (this.languageFilesMap) {
            data["languageFilesMap"] = {};
            for (let key in this.languageFilesMap) {
                if (this.languageFilesMap.hasOwnProperty(key))
                    (<any>data["languageFilesMap"])[key] = this.languageFilesMap[key];
            }
        }
        return data;
    }
}

export interface IApplicationLocalizationConfigurationDto {
    values?: { [key: string]: { [key: string]: string; }; } | undefined;
    languages?: LanguageInfo[] | undefined;
    currentCulture?: CurrentCultureDto;
    defaultResourceName?: string | undefined;
    languagesMap?: { [key: string]: NameValue[]; } | undefined;
    languageFilesMap?: { [key: string]: NameValue[]; } | undefined;
}

export class ApplicationAuthConfigurationDto implements IApplicationAuthConfigurationDto {
    policies?: { [key: string]: boolean; } | undefined;
    grantedPolicies?: { [key: string]: boolean; } | undefined;

    constructor(data?: IApplicationAuthConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["policies"]) {
                this.policies = {} as any;
                for (let key in _data["policies"]) {
                    if (_data["policies"].hasOwnProperty(key))
                        (<any>this.policies)![key] = _data["policies"][key];
                }
            }
            if (_data["grantedPolicies"]) {
                this.grantedPolicies = {} as any;
                for (let key in _data["grantedPolicies"]) {
                    if (_data["grantedPolicies"].hasOwnProperty(key))
                        (<any>this.grantedPolicies)![key] = _data["grantedPolicies"][key];
                }
            }
        }
    }

    static fromJS(data: any): ApplicationAuthConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationAuthConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.policies) {
            data["policies"] = {};
            for (let key in this.policies) {
                if (this.policies.hasOwnProperty(key))
                    (<any>data["policies"])[key] = this.policies[key];
            }
        }
        if (this.grantedPolicies) {
            data["grantedPolicies"] = {};
            for (let key in this.grantedPolicies) {
                if (this.grantedPolicies.hasOwnProperty(key))
                    (<any>data["grantedPolicies"])[key] = this.grantedPolicies[key];
            }
        }
        return data;
    }
}

export interface IApplicationAuthConfigurationDto {
    policies?: { [key: string]: boolean; } | undefined;
    grantedPolicies?: { [key: string]: boolean; } | undefined;
}

export class ApplicationSettingConfigurationDto implements IApplicationSettingConfigurationDto {
    values?: { [key: string]: string; } | undefined;

    constructor(data?: IApplicationSettingConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["values"]) {
                this.values = {} as any;
                for (let key in _data["values"]) {
                    if (_data["values"].hasOwnProperty(key))
                        (<any>this.values)![key] = _data["values"][key];
                }
            }
        }
    }

    static fromJS(data: any): ApplicationSettingConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationSettingConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.values) {
            data["values"] = {};
            for (let key in this.values) {
                if (this.values.hasOwnProperty(key))
                    (<any>data["values"])[key] = this.values[key];
            }
        }
        return data;
    }
}

export interface IApplicationSettingConfigurationDto {
    values?: { [key: string]: string; } | undefined;
}

export class CurrentUserDto implements ICurrentUserDto {
    isAuthenticated?: boolean;
    id?: string | undefined;
    tenantId?: string | undefined;
    userName?: string | undefined;
    name?: string | undefined;
    surName?: string | undefined;
    email?: string | undefined;
    emailVerified?: boolean;
    phoneNumber?: string | undefined;
    phoneNumberVerified?: boolean;
    roles?: string[] | undefined;

    constructor(data?: ICurrentUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isAuthenticated = _data["isAuthenticated"];
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
            this.userName = _data["userName"];
            this.name = _data["name"];
            this.surName = _data["surName"];
            this.email = _data["email"];
            this.emailVerified = _data["emailVerified"];
            this.phoneNumber = _data["phoneNumber"];
            this.phoneNumberVerified = _data["phoneNumberVerified"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
        }
    }

    static fromJS(data: any): CurrentUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isAuthenticated"] = this.isAuthenticated;
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        data["userName"] = this.userName;
        data["name"] = this.name;
        data["surName"] = this.surName;
        data["email"] = this.email;
        data["emailVerified"] = this.emailVerified;
        data["phoneNumber"] = this.phoneNumber;
        data["phoneNumberVerified"] = this.phoneNumberVerified;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        return data;
    }
}

export interface ICurrentUserDto {
    isAuthenticated?: boolean;
    id?: string | undefined;
    tenantId?: string | undefined;
    userName?: string | undefined;
    name?: string | undefined;
    surName?: string | undefined;
    email?: string | undefined;
    emailVerified?: boolean;
    phoneNumber?: string | undefined;
    phoneNumberVerified?: boolean;
    roles?: string[] | undefined;
}

export class ApplicationFeatureConfigurationDto implements IApplicationFeatureConfigurationDto {
    values?: { [key: string]: string; } | undefined;

    constructor(data?: IApplicationFeatureConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["values"]) {
                this.values = {} as any;
                for (let key in _data["values"]) {
                    if (_data["values"].hasOwnProperty(key))
                        (<any>this.values)![key] = _data["values"][key];
                }
            }
        }
    }

    static fromJS(data: any): ApplicationFeatureConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationFeatureConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.values) {
            data["values"] = {};
            for (let key in this.values) {
                if (this.values.hasOwnProperty(key))
                    (<any>data["values"])[key] = this.values[key];
            }
        }
        return data;
    }
}

export interface IApplicationFeatureConfigurationDto {
    values?: { [key: string]: string; } | undefined;
}

export class MultiTenancyInfoDto implements IMultiTenancyInfoDto {
    isEnabled?: boolean;

    constructor(data?: IMultiTenancyInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEnabled = _data["isEnabled"];
        }
    }

    static fromJS(data: any): MultiTenancyInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new MultiTenancyInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEnabled"] = this.isEnabled;
        return data;
    }
}

export interface IMultiTenancyInfoDto {
    isEnabled?: boolean;
}

export class CurrentTenantDto implements ICurrentTenantDto {
    id?: string | undefined;
    name?: string | undefined;
    isAvailable?: boolean;

    constructor(data?: ICurrentTenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isAvailable = _data["isAvailable"];
        }
    }

    static fromJS(data: any): CurrentTenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentTenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isAvailable"] = this.isAvailable;
        return data;
    }
}

export interface ICurrentTenantDto {
    id?: string | undefined;
    name?: string | undefined;
    isAvailable?: boolean;
}

export class IanaTimeZone implements IIanaTimeZone {
    timeZoneName?: string | undefined;

    constructor(data?: IIanaTimeZone) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timeZoneName = _data["timeZoneName"];
        }
    }

    static fromJS(data: any): IanaTimeZone {
        data = typeof data === 'object' ? data : {};
        let result = new IanaTimeZone();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeZoneName"] = this.timeZoneName;
        return data;
    }
}

export interface IIanaTimeZone {
    timeZoneName?: string | undefined;
}

export class WindowsTimeZone implements IWindowsTimeZone {
    timeZoneId?: string | undefined;

    constructor(data?: IWindowsTimeZone) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timeZoneId = _data["timeZoneId"];
        }
    }

    static fromJS(data: any): WindowsTimeZone {
        data = typeof data === 'object' ? data : {};
        let result = new WindowsTimeZone();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeZoneId"] = this.timeZoneId;
        return data;
    }
}

export interface IWindowsTimeZone {
    timeZoneId?: string | undefined;
}

export class TimeZone implements ITimeZone {
    iana?: IanaTimeZone;
    windows?: WindowsTimeZone;

    constructor(data?: ITimeZone) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.iana = _data["iana"] ? IanaTimeZone.fromJS(_data["iana"]) : <any>undefined;
            this.windows = _data["windows"] ? WindowsTimeZone.fromJS(_data["windows"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TimeZone {
        data = typeof data === 'object' ? data : {};
        let result = new TimeZone();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["iana"] = this.iana ? this.iana.toJSON() : <any>undefined;
        data["windows"] = this.windows ? this.windows.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITimeZone {
    iana?: IanaTimeZone;
    windows?: WindowsTimeZone;
}

export class TimingDto implements ITimingDto {
    timeZone?: TimeZone;

    constructor(data?: ITimingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timeZone = _data["timeZone"] ? TimeZone.fromJS(_data["timeZone"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TimingDto {
        data = typeof data === 'object' ? data : {};
        let result = new TimingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeZone"] = this.timeZone ? this.timeZone.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITimingDto {
    timeZone?: TimeZone;
}

export class ClockDto implements IClockDto {
    kind?: string | undefined;

    constructor(data?: IClockDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kind = _data["kind"];
        }
    }

    static fromJS(data: any): ClockDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClockDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kind"] = this.kind;
        return data;
    }
}

export interface IClockDto {
    kind?: string | undefined;
}

export class LocalizableStringDto implements ILocalizableStringDto {
    readonly name?: string | undefined;
    resource?: string | undefined;

    constructor(data?: ILocalizableStringDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).name = _data["name"];
            this.resource = _data["resource"];
        }
    }

    static fromJS(data: any): LocalizableStringDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocalizableStringDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["resource"] = this.resource;
        return data;
    }
}

export interface ILocalizableStringDto {
    name?: string | undefined;
    resource?: string | undefined;
}

export class ExtensionPropertyApiGetDto implements IExtensionPropertyApiGetDto {
    isAvailable?: boolean;

    constructor(data?: IExtensionPropertyApiGetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isAvailable = _data["isAvailable"];
        }
    }

    static fromJS(data: any): ExtensionPropertyApiGetDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExtensionPropertyApiGetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isAvailable"] = this.isAvailable;
        return data;
    }
}

export interface IExtensionPropertyApiGetDto {
    isAvailable?: boolean;
}

export class ExtensionPropertyApiCreateDto implements IExtensionPropertyApiCreateDto {
    isAvailable?: boolean;

    constructor(data?: IExtensionPropertyApiCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isAvailable = _data["isAvailable"];
        }
    }

    static fromJS(data: any): ExtensionPropertyApiCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExtensionPropertyApiCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isAvailable"] = this.isAvailable;
        return data;
    }
}

export interface IExtensionPropertyApiCreateDto {
    isAvailable?: boolean;
}

export class ExtensionPropertyApiUpdateDto implements IExtensionPropertyApiUpdateDto {
    isAvailable?: boolean;

    constructor(data?: IExtensionPropertyApiUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isAvailable = _data["isAvailable"];
        }
    }

    static fromJS(data: any): ExtensionPropertyApiUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExtensionPropertyApiUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isAvailable"] = this.isAvailable;
        return data;
    }
}

export interface IExtensionPropertyApiUpdateDto {
    isAvailable?: boolean;
}

export class ExtensionPropertyApiDto implements IExtensionPropertyApiDto {
    onGet?: ExtensionPropertyApiGetDto;
    onCreate?: ExtensionPropertyApiCreateDto;
    onUpdate?: ExtensionPropertyApiUpdateDto;

    constructor(data?: IExtensionPropertyApiDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.onGet = _data["onGet"] ? ExtensionPropertyApiGetDto.fromJS(_data["onGet"]) : <any>undefined;
            this.onCreate = _data["onCreate"] ? ExtensionPropertyApiCreateDto.fromJS(_data["onCreate"]) : <any>undefined;
            this.onUpdate = _data["onUpdate"] ? ExtensionPropertyApiUpdateDto.fromJS(_data["onUpdate"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ExtensionPropertyApiDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExtensionPropertyApiDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["onGet"] = this.onGet ? this.onGet.toJSON() : <any>undefined;
        data["onCreate"] = this.onCreate ? this.onCreate.toJSON() : <any>undefined;
        data["onUpdate"] = this.onUpdate ? this.onUpdate.toJSON() : <any>undefined;
        return data;
    }
}

export interface IExtensionPropertyApiDto {
    onGet?: ExtensionPropertyApiGetDto;
    onCreate?: ExtensionPropertyApiCreateDto;
    onUpdate?: ExtensionPropertyApiUpdateDto;
}

export class ExtensionPropertyUiTableDto implements IExtensionPropertyUiTableDto {
    isVisible?: boolean;

    constructor(data?: IExtensionPropertyUiTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isVisible = _data["isVisible"];
        }
    }

    static fromJS(data: any): ExtensionPropertyUiTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExtensionPropertyUiTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isVisible"] = this.isVisible;
        return data;
    }
}

export interface IExtensionPropertyUiTableDto {
    isVisible?: boolean;
}

export class ExtensionPropertyUiFormDto implements IExtensionPropertyUiFormDto {
    isVisible?: boolean;

    constructor(data?: IExtensionPropertyUiFormDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isVisible = _data["isVisible"];
        }
    }

    static fromJS(data: any): ExtensionPropertyUiFormDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExtensionPropertyUiFormDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isVisible"] = this.isVisible;
        return data;
    }
}

export interface IExtensionPropertyUiFormDto {
    isVisible?: boolean;
}

export class ExtensionPropertyUiLookupDto implements IExtensionPropertyUiLookupDto {
    url?: string | undefined;
    resultListPropertyName?: string | undefined;
    displayPropertyName?: string | undefined;
    valuePropertyName?: string | undefined;
    filterParamName?: string | undefined;

    constructor(data?: IExtensionPropertyUiLookupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
            this.resultListPropertyName = _data["resultListPropertyName"];
            this.displayPropertyName = _data["displayPropertyName"];
            this.valuePropertyName = _data["valuePropertyName"];
            this.filterParamName = _data["filterParamName"];
        }
    }

    static fromJS(data: any): ExtensionPropertyUiLookupDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExtensionPropertyUiLookupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["resultListPropertyName"] = this.resultListPropertyName;
        data["displayPropertyName"] = this.displayPropertyName;
        data["valuePropertyName"] = this.valuePropertyName;
        data["filterParamName"] = this.filterParamName;
        return data;
    }
}

export interface IExtensionPropertyUiLookupDto {
    url?: string | undefined;
    resultListPropertyName?: string | undefined;
    displayPropertyName?: string | undefined;
    valuePropertyName?: string | undefined;
    filterParamName?: string | undefined;
}

export class ExtensionPropertyUiDto implements IExtensionPropertyUiDto {
    onTable?: ExtensionPropertyUiTableDto;
    onCreateForm?: ExtensionPropertyUiFormDto;
    onEditForm?: ExtensionPropertyUiFormDto;
    lookup?: ExtensionPropertyUiLookupDto;

    constructor(data?: IExtensionPropertyUiDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.onTable = _data["onTable"] ? ExtensionPropertyUiTableDto.fromJS(_data["onTable"]) : <any>undefined;
            this.onCreateForm = _data["onCreateForm"] ? ExtensionPropertyUiFormDto.fromJS(_data["onCreateForm"]) : <any>undefined;
            this.onEditForm = _data["onEditForm"] ? ExtensionPropertyUiFormDto.fromJS(_data["onEditForm"]) : <any>undefined;
            this.lookup = _data["lookup"] ? ExtensionPropertyUiLookupDto.fromJS(_data["lookup"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ExtensionPropertyUiDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExtensionPropertyUiDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["onTable"] = this.onTable ? this.onTable.toJSON() : <any>undefined;
        data["onCreateForm"] = this.onCreateForm ? this.onCreateForm.toJSON() : <any>undefined;
        data["onEditForm"] = this.onEditForm ? this.onEditForm.toJSON() : <any>undefined;
        data["lookup"] = this.lookup ? this.lookup.toJSON() : <any>undefined;
        return data;
    }
}

export interface IExtensionPropertyUiDto {
    onTable?: ExtensionPropertyUiTableDto;
    onCreateForm?: ExtensionPropertyUiFormDto;
    onEditForm?: ExtensionPropertyUiFormDto;
    lookup?: ExtensionPropertyUiLookupDto;
}

export class ExtensionPropertyAttributeDto implements IExtensionPropertyAttributeDto {
    typeSimple?: string | undefined;
    config?: { [key: string]: any; } | undefined;

    constructor(data?: IExtensionPropertyAttributeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.typeSimple = _data["typeSimple"];
            if (_data["config"]) {
                this.config = {} as any;
                for (let key in _data["config"]) {
                    if (_data["config"].hasOwnProperty(key))
                        (<any>this.config)![key] = _data["config"][key];
                }
            }
        }
    }

    static fromJS(data: any): ExtensionPropertyAttributeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExtensionPropertyAttributeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeSimple"] = this.typeSimple;
        if (this.config) {
            data["config"] = {};
            for (let key in this.config) {
                if (this.config.hasOwnProperty(key))
                    (<any>data["config"])[key] = this.config[key];
            }
        }
        return data;
    }
}

export interface IExtensionPropertyAttributeDto {
    typeSimple?: string | undefined;
    config?: { [key: string]: any; } | undefined;
}

export class ExtensionPropertyDto implements IExtensionPropertyDto {
    type?: string | undefined;
    typeSimple?: string | undefined;
    displayName?: LocalizableStringDto;
    api?: ExtensionPropertyApiDto;
    ui?: ExtensionPropertyUiDto;
    attributes?: ExtensionPropertyAttributeDto[] | undefined;
    configuration?: { [key: string]: any; } | undefined;
    defaultValue?: any | undefined;

    constructor(data?: IExtensionPropertyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.typeSimple = _data["typeSimple"];
            this.displayName = _data["displayName"] ? LocalizableStringDto.fromJS(_data["displayName"]) : <any>undefined;
            this.api = _data["api"] ? ExtensionPropertyApiDto.fromJS(_data["api"]) : <any>undefined;
            this.ui = _data["ui"] ? ExtensionPropertyUiDto.fromJS(_data["ui"]) : <any>undefined;
            if (Array.isArray(_data["attributes"])) {
                this.attributes = [] as any;
                for (let item of _data["attributes"])
                    this.attributes!.push(ExtensionPropertyAttributeDto.fromJS(item));
            }
            if (_data["configuration"]) {
                this.configuration = {} as any;
                for (let key in _data["configuration"]) {
                    if (_data["configuration"].hasOwnProperty(key))
                        (<any>this.configuration)![key] = _data["configuration"][key];
                }
            }
            this.defaultValue = _data["defaultValue"];
        }
    }

    static fromJS(data: any): ExtensionPropertyDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExtensionPropertyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["typeSimple"] = this.typeSimple;
        data["displayName"] = this.displayName ? this.displayName.toJSON() : <any>undefined;
        data["api"] = this.api ? this.api.toJSON() : <any>undefined;
        data["ui"] = this.ui ? this.ui.toJSON() : <any>undefined;
        if (Array.isArray(this.attributes)) {
            data["attributes"] = [];
            for (let item of this.attributes)
                data["attributes"].push(item.toJSON());
        }
        if (this.configuration) {
            data["configuration"] = {};
            for (let key in this.configuration) {
                if (this.configuration.hasOwnProperty(key))
                    (<any>data["configuration"])[key] = this.configuration[key];
            }
        }
        data["defaultValue"] = this.defaultValue;
        return data;
    }
}

export interface IExtensionPropertyDto {
    type?: string | undefined;
    typeSimple?: string | undefined;
    displayName?: LocalizableStringDto;
    api?: ExtensionPropertyApiDto;
    ui?: ExtensionPropertyUiDto;
    attributes?: ExtensionPropertyAttributeDto[] | undefined;
    configuration?: { [key: string]: any; } | undefined;
    defaultValue?: any | undefined;
}

export class EntityExtensionDto implements IEntityExtensionDto {
    properties?: { [key: string]: ExtensionPropertyDto; } | undefined;
    configuration?: { [key: string]: any; } | undefined;

    constructor(data?: IEntityExtensionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["properties"]) {
                this.properties = {} as any;
                for (let key in _data["properties"]) {
                    if (_data["properties"].hasOwnProperty(key))
                        (<any>this.properties)![key] = _data["properties"][key] ? ExtensionPropertyDto.fromJS(_data["properties"][key]) : new ExtensionPropertyDto();
                }
            }
            if (_data["configuration"]) {
                this.configuration = {} as any;
                for (let key in _data["configuration"]) {
                    if (_data["configuration"].hasOwnProperty(key))
                        (<any>this.configuration)![key] = _data["configuration"][key];
                }
            }
        }
    }

    static fromJS(data: any): EntityExtensionDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntityExtensionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.properties) {
            data["properties"] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    (<any>data["properties"])[key] = this.properties[key] ? this.properties[key].toJSON() : <any>undefined;
            }
        }
        if (this.configuration) {
            data["configuration"] = {};
            for (let key in this.configuration) {
                if (this.configuration.hasOwnProperty(key))
                    (<any>data["configuration"])[key] = this.configuration[key];
            }
        }
        return data;
    }
}

export interface IEntityExtensionDto {
    properties?: { [key: string]: ExtensionPropertyDto; } | undefined;
    configuration?: { [key: string]: any; } | undefined;
}

export class ModuleExtensionDto implements IModuleExtensionDto {
    entities?: { [key: string]: EntityExtensionDto; } | undefined;
    configuration?: { [key: string]: any; } | undefined;

    constructor(data?: IModuleExtensionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["entities"]) {
                this.entities = {} as any;
                for (let key in _data["entities"]) {
                    if (_data["entities"].hasOwnProperty(key))
                        (<any>this.entities)![key] = _data["entities"][key] ? EntityExtensionDto.fromJS(_data["entities"][key]) : new EntityExtensionDto();
                }
            }
            if (_data["configuration"]) {
                this.configuration = {} as any;
                for (let key in _data["configuration"]) {
                    if (_data["configuration"].hasOwnProperty(key))
                        (<any>this.configuration)![key] = _data["configuration"][key];
                }
            }
        }
    }

    static fromJS(data: any): ModuleExtensionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ModuleExtensionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.entities) {
            data["entities"] = {};
            for (let key in this.entities) {
                if (this.entities.hasOwnProperty(key))
                    (<any>data["entities"])[key] = this.entities[key] ? this.entities[key].toJSON() : <any>undefined;
            }
        }
        if (this.configuration) {
            data["configuration"] = {};
            for (let key in this.configuration) {
                if (this.configuration.hasOwnProperty(key))
                    (<any>data["configuration"])[key] = this.configuration[key];
            }
        }
        return data;
    }
}

export interface IModuleExtensionDto {
    entities?: { [key: string]: EntityExtensionDto; } | undefined;
    configuration?: { [key: string]: any; } | undefined;
}

export class ExtensionEnumFieldDto implements IExtensionEnumFieldDto {
    name?: string | undefined;
    value?: any | undefined;

    constructor(data?: IExtensionEnumFieldDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): ExtensionEnumFieldDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExtensionEnumFieldDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface IExtensionEnumFieldDto {
    name?: string | undefined;
    value?: any | undefined;
}

export class ExtensionEnumDto implements IExtensionEnumDto {
    fields?: ExtensionEnumFieldDto[] | undefined;
    localizationResource?: string | undefined;

    constructor(data?: IExtensionEnumDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields!.push(ExtensionEnumFieldDto.fromJS(item));
            }
            this.localizationResource = _data["localizationResource"];
        }
    }

    static fromJS(data: any): ExtensionEnumDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExtensionEnumDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item.toJSON());
        }
        data["localizationResource"] = this.localizationResource;
        return data;
    }
}

export interface IExtensionEnumDto {
    fields?: ExtensionEnumFieldDto[] | undefined;
    localizationResource?: string | undefined;
}

export class ObjectExtensionsDto implements IObjectExtensionsDto {
    modules?: { [key: string]: ModuleExtensionDto; } | undefined;
    enums?: { [key: string]: ExtensionEnumDto; } | undefined;

    constructor(data?: IObjectExtensionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["modules"]) {
                this.modules = {} as any;
                for (let key in _data["modules"]) {
                    if (_data["modules"].hasOwnProperty(key))
                        (<any>this.modules)![key] = _data["modules"][key] ? ModuleExtensionDto.fromJS(_data["modules"][key]) : new ModuleExtensionDto();
                }
            }
            if (_data["enums"]) {
                this.enums = {} as any;
                for (let key in _data["enums"]) {
                    if (_data["enums"].hasOwnProperty(key))
                        (<any>this.enums)![key] = _data["enums"][key] ? ExtensionEnumDto.fromJS(_data["enums"][key]) : new ExtensionEnumDto();
                }
            }
        }
    }

    static fromJS(data: any): ObjectExtensionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ObjectExtensionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.modules) {
            data["modules"] = {};
            for (let key in this.modules) {
                if (this.modules.hasOwnProperty(key))
                    (<any>data["modules"])[key] = this.modules[key] ? this.modules[key].toJSON() : <any>undefined;
            }
        }
        if (this.enums) {
            data["enums"] = {};
            for (let key in this.enums) {
                if (this.enums.hasOwnProperty(key))
                    (<any>data["enums"])[key] = this.enums[key] ? this.enums[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }
}

export interface IObjectExtensionsDto {
    modules?: { [key: string]: ModuleExtensionDto; } | undefined;
    enums?: { [key: string]: ExtensionEnumDto; } | undefined;
}

export class ApplicationConfigurationDto implements IApplicationConfigurationDto {
    localization?: ApplicationLocalizationConfigurationDto;
    auth?: ApplicationAuthConfigurationDto;
    setting?: ApplicationSettingConfigurationDto;
    currentUser?: CurrentUserDto;
    features?: ApplicationFeatureConfigurationDto;
    multiTenancy?: MultiTenancyInfoDto;
    currentTenant?: CurrentTenantDto;
    timing?: TimingDto;
    clock?: ClockDto;
    objectExtensions?: ObjectExtensionsDto;

    constructor(data?: IApplicationConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.localization = _data["localization"] ? ApplicationLocalizationConfigurationDto.fromJS(_data["localization"]) : <any>undefined;
            this.auth = _data["auth"] ? ApplicationAuthConfigurationDto.fromJS(_data["auth"]) : <any>undefined;
            this.setting = _data["setting"] ? ApplicationSettingConfigurationDto.fromJS(_data["setting"]) : <any>undefined;
            this.currentUser = _data["currentUser"] ? CurrentUserDto.fromJS(_data["currentUser"]) : <any>undefined;
            this.features = _data["features"] ? ApplicationFeatureConfigurationDto.fromJS(_data["features"]) : <any>undefined;
            this.multiTenancy = _data["multiTenancy"] ? MultiTenancyInfoDto.fromJS(_data["multiTenancy"]) : <any>undefined;
            this.currentTenant = _data["currentTenant"] ? CurrentTenantDto.fromJS(_data["currentTenant"]) : <any>undefined;
            this.timing = _data["timing"] ? TimingDto.fromJS(_data["timing"]) : <any>undefined;
            this.clock = _data["clock"] ? ClockDto.fromJS(_data["clock"]) : <any>undefined;
            this.objectExtensions = _data["objectExtensions"] ? ObjectExtensionsDto.fromJS(_data["objectExtensions"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ApplicationConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["localization"] = this.localization ? this.localization.toJSON() : <any>undefined;
        data["auth"] = this.auth ? this.auth.toJSON() : <any>undefined;
        data["setting"] = this.setting ? this.setting.toJSON() : <any>undefined;
        data["currentUser"] = this.currentUser ? this.currentUser.toJSON() : <any>undefined;
        data["features"] = this.features ? this.features.toJSON() : <any>undefined;
        data["multiTenancy"] = this.multiTenancy ? this.multiTenancy.toJSON() : <any>undefined;
        data["currentTenant"] = this.currentTenant ? this.currentTenant.toJSON() : <any>undefined;
        data["timing"] = this.timing ? this.timing.toJSON() : <any>undefined;
        data["clock"] = this.clock ? this.clock.toJSON() : <any>undefined;
        data["objectExtensions"] = this.objectExtensions ? this.objectExtensions.toJSON() : <any>undefined;
        return data;
    }
}

export interface IApplicationConfigurationDto {
    localization?: ApplicationLocalizationConfigurationDto;
    auth?: ApplicationAuthConfigurationDto;
    setting?: ApplicationSettingConfigurationDto;
    currentUser?: CurrentUserDto;
    features?: ApplicationFeatureConfigurationDto;
    multiTenancy?: MultiTenancyInfoDto;
    currentTenant?: CurrentTenantDto;
    timing?: TimingDto;
    clock?: ClockDto;
    objectExtensions?: ObjectExtensionsDto;
}

export enum Periodicy {
    Once = "Once",
    EveryDay = "EveryDay",
    EveryWeek = "EveryWeek",
    EveryMonth = "EveryMonth",
    EveryYear = "EveryYear",
}

export class CreateUpdateActivityDto implements ICreateUpdateActivityDto {
    initDate!: Date;
    endDate?: Date | undefined;
    initHour!: string;
    endHour!: string;
    periodicy?: Periodicy;
    amount?: number;
    activityId?: number | undefined;
    primaryTypeId?: number | undefined;
    secondaryTypeId?: number | undefined;
    name!: string;
    description?: string | undefined;
    comments?: string | undefined;
    location?: string | undefined;
    professionalId?: number;
    relatedContractId?: number;
    contracts?: number[] | undefined;
    participants?: number[] | undefined;
    icon?: string | undefined;
    isRecord?: boolean;
    clientsLikesId?: number[] | undefined;
    clientTypeId?: number | undefined;
    languageId?: number | undefined;
    associatedWorkingCenterId?: number | undefined;
    ip?: string | undefined;
    admin?: number;
    isCreatedByScheduler?: boolean;

    constructor(data?: ICreateUpdateActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.initDate = _data["initDate"] ? new Date(_data["initDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.initHour = _data["initHour"];
            this.endHour = _data["endHour"];
            this.periodicy = _data["periodicy"];
            this.amount = _data["amount"];
            this.activityId = _data["activityId"];
            this.primaryTypeId = _data["primaryTypeId"];
            this.secondaryTypeId = _data["secondaryTypeId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.comments = _data["comments"];
            this.location = _data["location"];
            this.professionalId = _data["professionalId"];
            this.relatedContractId = _data["relatedContractId"];
            if (Array.isArray(_data["contracts"])) {
                this.contracts = [] as any;
                for (let item of _data["contracts"])
                    this.contracts!.push(item);
            }
            if (Array.isArray(_data["participants"])) {
                this.participants = [] as any;
                for (let item of _data["participants"])
                    this.participants!.push(item);
            }
            this.icon = _data["icon"];
            this.isRecord = _data["isRecord"];
            if (Array.isArray(_data["clientsLikesId"])) {
                this.clientsLikesId = [] as any;
                for (let item of _data["clientsLikesId"])
                    this.clientsLikesId!.push(item);
            }
            this.clientTypeId = _data["clientTypeId"];
            this.languageId = _data["languageId"];
            this.associatedWorkingCenterId = _data["associatedWorkingCenterId"];
            this.ip = _data["ip"];
            this.admin = _data["admin"];
            this.isCreatedByScheduler = _data["isCreatedByScheduler"];
        }
    }

    static fromJS(data: any): CreateUpdateActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUpdateActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["initDate"] = this.initDate ? this.initDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["initHour"] = this.initHour;
        data["endHour"] = this.endHour;
        data["periodicy"] = this.periodicy;
        data["amount"] = this.amount;
        data["activityId"] = this.activityId;
        data["primaryTypeId"] = this.primaryTypeId;
        data["secondaryTypeId"] = this.secondaryTypeId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["comments"] = this.comments;
        data["location"] = this.location;
        data["professionalId"] = this.professionalId;
        data["relatedContractId"] = this.relatedContractId;
        if (Array.isArray(this.contracts)) {
            data["contracts"] = [];
            for (let item of this.contracts)
                data["contracts"].push(item);
        }
        if (Array.isArray(this.participants)) {
            data["participants"] = [];
            for (let item of this.participants)
                data["participants"].push(item);
        }
        data["icon"] = this.icon;
        data["isRecord"] = this.isRecord;
        if (Array.isArray(this.clientsLikesId)) {
            data["clientsLikesId"] = [];
            for (let item of this.clientsLikesId)
                data["clientsLikesId"].push(item);
        }
        data["clientTypeId"] = this.clientTypeId;
        data["languageId"] = this.languageId;
        data["associatedWorkingCenterId"] = this.associatedWorkingCenterId;
        data["ip"] = this.ip;
        data["admin"] = this.admin;
        data["isCreatedByScheduler"] = this.isCreatedByScheduler;
        return data;
    }
}

export interface ICreateUpdateActivityDto {
    initDate: Date;
    endDate?: Date | undefined;
    initHour: string;
    endHour: string;
    periodicy?: Periodicy;
    amount?: number;
    activityId?: number | undefined;
    primaryTypeId?: number | undefined;
    secondaryTypeId?: number | undefined;
    name: string;
    description?: string | undefined;
    comments?: string | undefined;
    location?: string | undefined;
    professionalId?: number;
    relatedContractId?: number;
    contracts?: number[] | undefined;
    participants?: number[] | undefined;
    icon?: string | undefined;
    isRecord?: boolean;
    clientsLikesId?: number[] | undefined;
    clientTypeId?: number | undefined;
    languageId?: number | undefined;
    associatedWorkingCenterId?: number | undefined;
    ip?: string | undefined;
    admin?: number;
    isCreatedByScheduler?: boolean;
}

export class UserMinDto implements IUserMinDto {
    id?: number;
    name?: string | undefined;
    surnames?: string | undefined;
    alias?: string | undefined;
    identificationNumber?: string | undefined;

    constructor(data?: IUserMinDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surnames = _data["surnames"];
            this.alias = _data["alias"];
            this.identificationNumber = _data["identificationNumber"];
        }
    }

    static fromJS(data: any): UserMinDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserMinDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surnames"] = this.surnames;
        data["alias"] = this.alias;
        data["identificationNumber"] = this.identificationNumber;
        return data;
    }
}

export interface IUserMinDto {
    id?: number;
    name?: string | undefined;
    surnames?: string | undefined;
    alias?: string | undefined;
    identificationNumber?: string | undefined;
}

export class ContractDto implements IContractDto {
    id?: number;
    contractNumber?: string | undefined;
    initialDate?: Date;
    endDate?: Date | undefined;
    maxClient?: number;
    publicAdministration?: boolean;
    extension?: boolean;
    extensionDuration?: Date | undefined;
    contractingAuthorityId?: number;
    professionalsId?: number[] | undefined;
    usersId?: number[] | undefined;
    isParent?: boolean;
    isExpired?: boolean;
    parentContractId?: number | undefined;
    isMain?: boolean;
    isMainSomeUser?: boolean;
    isMainSomeProfessional?: boolean;
    childrenContract?: string[] | undefined;
    description?: string | undefined;

    constructor(data?: IContractDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.contractNumber = _data["contractNumber"];
            this.initialDate = _data["initialDate"] ? new Date(_data["initialDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.maxClient = _data["maxClient"];
            this.publicAdministration = _data["publicAdministration"];
            this.extension = _data["extension"];
            this.extensionDuration = _data["extensionDuration"] ? new Date(_data["extensionDuration"].toString()) : <any>undefined;
            this.contractingAuthorityId = _data["contractingAuthorityId"];
            if (Array.isArray(_data["professionalsId"])) {
                this.professionalsId = [] as any;
                for (let item of _data["professionalsId"])
                    this.professionalsId!.push(item);
            }
            if (Array.isArray(_data["usersId"])) {
                this.usersId = [] as any;
                for (let item of _data["usersId"])
                    this.usersId!.push(item);
            }
            this.isParent = _data["isParent"];
            this.isExpired = _data["isExpired"];
            this.parentContractId = _data["parentContractId"];
            this.isMain = _data["isMain"];
            this.isMainSomeUser = _data["isMainSomeUser"];
            this.isMainSomeProfessional = _data["isMainSomeProfessional"];
            if (Array.isArray(_data["childrenContract"])) {
                this.childrenContract = [] as any;
                for (let item of _data["childrenContract"])
                    this.childrenContract!.push(item);
            }
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): ContractDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContractDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["contractNumber"] = this.contractNumber;
        data["initialDate"] = this.initialDate ? this.initialDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["maxClient"] = this.maxClient;
        data["publicAdministration"] = this.publicAdministration;
        data["extension"] = this.extension;
        data["extensionDuration"] = this.extensionDuration ? this.extensionDuration.toISOString() : <any>undefined;
        data["contractingAuthorityId"] = this.contractingAuthorityId;
        if (Array.isArray(this.professionalsId)) {
            data["professionalsId"] = [];
            for (let item of this.professionalsId)
                data["professionalsId"].push(item);
        }
        if (Array.isArray(this.usersId)) {
            data["usersId"] = [];
            for (let item of this.usersId)
                data["usersId"].push(item);
        }
        data["isParent"] = this.isParent;
        data["isExpired"] = this.isExpired;
        data["parentContractId"] = this.parentContractId;
        data["isMain"] = this.isMain;
        data["isMainSomeUser"] = this.isMainSomeUser;
        data["isMainSomeProfessional"] = this.isMainSomeProfessional;
        if (Array.isArray(this.childrenContract)) {
            data["childrenContract"] = [];
            for (let item of this.childrenContract)
                data["childrenContract"].push(item);
        }
        data["description"] = this.description;
        return data;
    }
}

export interface IContractDto {
    id?: number;
    contractNumber?: string | undefined;
    initialDate?: Date;
    endDate?: Date | undefined;
    maxClient?: number;
    publicAdministration?: boolean;
    extension?: boolean;
    extensionDuration?: Date | undefined;
    contractingAuthorityId?: number;
    professionalsId?: number[] | undefined;
    usersId?: number[] | undefined;
    isParent?: boolean;
    isExpired?: boolean;
    parentContractId?: number | undefined;
    isMain?: boolean;
    isMainSomeUser?: boolean;
    isMainSomeProfessional?: boolean;
    childrenContract?: string[] | undefined;
    description?: string | undefined;
}

export class ContractDtoMin implements IContractDtoMin {
    id?: number;
    contractNumber?: string | undefined;
    description?: string | undefined;

    constructor(data?: IContractDtoMin) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.contractNumber = _data["contractNumber"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): ContractDtoMin {
        data = typeof data === 'object' ? data : {};
        let result = new ContractDtoMin();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["contractNumber"] = this.contractNumber;
        data["description"] = this.description;
        return data;
    }
}

export interface IContractDtoMin {
    id?: number;
    contractNumber?: string | undefined;
    description?: string | undefined;
}

export class ActivityDto implements IActivityDto {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    location?: string | undefined;
    comments?: string | undefined;
    icon?: string | undefined;
    isRecord?: boolean;
    primaryTypeId?: number | undefined;
    secondaryTypeId?: number | undefined;
    professional?: UserMinDto;
    startDate?: Date[] | undefined;
    status?: string | undefined;
    recursive?: string | undefined;
    relatedContract?: ContractDto;
    scheduledActivitiesId?: number[] | undefined;
    participants?: UserMinDto[] | undefined;
    contracts?: ContractDtoMin[] | undefined;
    clientsLikesId?: number[] | undefined;
    clientTypeId?: number | undefined;
    languageId?: number | undefined;
    associatedWorkingCenterId?: number | undefined;
    isDeleted?: boolean;
    primaryTypeDescription?: string | undefined;
    secondaryTypeDescription?: string | undefined;

    constructor(data?: IActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.location = _data["location"];
            this.comments = _data["comments"];
            this.icon = _data["icon"];
            this.isRecord = _data["isRecord"];
            this.primaryTypeId = _data["primaryTypeId"];
            this.secondaryTypeId = _data["secondaryTypeId"];
            this.professional = _data["professional"] ? UserMinDto.fromJS(_data["professional"]) : <any>undefined;
            if (Array.isArray(_data["startDate"])) {
                this.startDate = [] as any;
                for (let item of _data["startDate"])
                    this.startDate!.push(new Date(item));
            }
            this.status = _data["status"];
            this.recursive = _data["recursive"];
            this.relatedContract = _data["relatedContract"] ? ContractDto.fromJS(_data["relatedContract"]) : <any>undefined;
            if (Array.isArray(_data["scheduledActivitiesId"])) {
                this.scheduledActivitiesId = [] as any;
                for (let item of _data["scheduledActivitiesId"])
                    this.scheduledActivitiesId!.push(item);
            }
            if (Array.isArray(_data["participants"])) {
                this.participants = [] as any;
                for (let item of _data["participants"])
                    this.participants!.push(UserMinDto.fromJS(item));
            }
            if (Array.isArray(_data["contracts"])) {
                this.contracts = [] as any;
                for (let item of _data["contracts"])
                    this.contracts!.push(ContractDtoMin.fromJS(item));
            }
            if (Array.isArray(_data["clientsLikesId"])) {
                this.clientsLikesId = [] as any;
                for (let item of _data["clientsLikesId"])
                    this.clientsLikesId!.push(item);
            }
            this.clientTypeId = _data["clientTypeId"];
            this.languageId = _data["languageId"];
            this.associatedWorkingCenterId = _data["associatedWorkingCenterId"];
            this.isDeleted = _data["isDeleted"];
            this.primaryTypeDescription = _data["primaryTypeDescription"];
            this.secondaryTypeDescription = _data["secondaryTypeDescription"];
        }
    }

    static fromJS(data: any): ActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["location"] = this.location;
        data["comments"] = this.comments;
        data["icon"] = this.icon;
        data["isRecord"] = this.isRecord;
        data["primaryTypeId"] = this.primaryTypeId;
        data["secondaryTypeId"] = this.secondaryTypeId;
        data["professional"] = this.professional ? this.professional.toJSON() : <any>undefined;
        if (Array.isArray(this.startDate)) {
            data["startDate"] = [];
            for (let item of this.startDate)
                data["startDate"].push(item.toISOString());
        }
        data["status"] = this.status;
        data["recursive"] = this.recursive;
        data["relatedContract"] = this.relatedContract ? this.relatedContract.toJSON() : <any>undefined;
        if (Array.isArray(this.scheduledActivitiesId)) {
            data["scheduledActivitiesId"] = [];
            for (let item of this.scheduledActivitiesId)
                data["scheduledActivitiesId"].push(item);
        }
        if (Array.isArray(this.participants)) {
            data["participants"] = [];
            for (let item of this.participants)
                data["participants"].push(item.toJSON());
        }
        if (Array.isArray(this.contracts)) {
            data["contracts"] = [];
            for (let item of this.contracts)
                data["contracts"].push(item.toJSON());
        }
        if (Array.isArray(this.clientsLikesId)) {
            data["clientsLikesId"] = [];
            for (let item of this.clientsLikesId)
                data["clientsLikesId"].push(item);
        }
        data["clientTypeId"] = this.clientTypeId;
        data["languageId"] = this.languageId;
        data["associatedWorkingCenterId"] = this.associatedWorkingCenterId;
        data["isDeleted"] = this.isDeleted;
        data["primaryTypeDescription"] = this.primaryTypeDescription;
        data["secondaryTypeDescription"] = this.secondaryTypeDescription;
        return data;
    }
}

export interface IActivityDto {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    location?: string | undefined;
    comments?: string | undefined;
    icon?: string | undefined;
    isRecord?: boolean;
    primaryTypeId?: number | undefined;
    secondaryTypeId?: number | undefined;
    professional?: UserMinDto;
    startDate?: Date[] | undefined;
    status?: string | undefined;
    recursive?: string | undefined;
    relatedContract?: ContractDto;
    scheduledActivitiesId?: number[] | undefined;
    participants?: UserMinDto[] | undefined;
    contracts?: ContractDtoMin[] | undefined;
    clientsLikesId?: number[] | undefined;
    clientTypeId?: number | undefined;
    languageId?: number | undefined;
    associatedWorkingCenterId?: number | undefined;
    isDeleted?: boolean;
    primaryTypeDescription?: string | undefined;
    secondaryTypeDescription?: string | undefined;
}

export class ActivityQueryDto implements IActivityQueryDto {
    pageNumber?: number;
    pageSize?: number;
    readonly skipElments?: number;
    orderField?: string | undefined;
    orderAsc?: boolean;
    id?: number | undefined;
    clientId?: number | undefined;
    contractingAuthorityId?: number | undefined;
    profesionalId?: number | undefined;
    adminId?: number | undefined;
    name?: string | undefined;
    includeDeleted?: boolean;
    primaryType?: number | undefined;
    secondaryType?: number | undefined;
    primaryTypeList?: number[] | undefined;
    secondaryTypeList?: number[] | undefined;
    contractId?: number | undefined;
    icon?: string | undefined;
    isRecord?: boolean | undefined;
    isDeleted?: string | undefined;
    includeUsers?: boolean;
    description?: string | undefined;
    languageId?: number | undefined;
    clientTypeId?: number | undefined;
    associatedWorkingCenterId?: number | undefined;
    therapeuticalProfileIds?: number[] | undefined;
    clientsLikesId?: number[] | undefined;
    filteredForInput?: boolean;
    maxDaysSearch?: number;
    date?: Date | undefined;
    endDate?: Date | undefined;

    constructor(data?: IActivityQueryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            (<any>this).skipElments = _data["skipElments"];
            this.orderField = _data["orderField"];
            this.orderAsc = _data["orderAsc"];
            this.id = _data["id"];
            this.clientId = _data["clientId"];
            this.contractingAuthorityId = _data["contractingAuthorityId"];
            this.profesionalId = _data["profesionalId"];
            this.adminId = _data["adminId"];
            this.name = _data["name"];
            this.includeDeleted = _data["includeDeleted"];
            this.primaryType = _data["primaryType"];
            this.secondaryType = _data["secondaryType"];
            if (Array.isArray(_data["primaryTypeList"])) {
                this.primaryTypeList = [] as any;
                for (let item of _data["primaryTypeList"])
                    this.primaryTypeList!.push(item);
            }
            if (Array.isArray(_data["secondaryTypeList"])) {
                this.secondaryTypeList = [] as any;
                for (let item of _data["secondaryTypeList"])
                    this.secondaryTypeList!.push(item);
            }
            this.contractId = _data["contractId"];
            this.icon = _data["icon"];
            this.isRecord = _data["isRecord"];
            this.isDeleted = _data["isDeleted"];
            this.includeUsers = _data["includeUsers"];
            this.description = _data["description"];
            this.languageId = _data["languageId"];
            this.clientTypeId = _data["clientTypeId"];
            this.associatedWorkingCenterId = _data["associatedWorkingCenterId"];
            if (Array.isArray(_data["therapeuticalProfileIds"])) {
                this.therapeuticalProfileIds = [] as any;
                for (let item of _data["therapeuticalProfileIds"])
                    this.therapeuticalProfileIds!.push(item);
            }
            if (Array.isArray(_data["clientsLikesId"])) {
                this.clientsLikesId = [] as any;
                for (let item of _data["clientsLikesId"])
                    this.clientsLikesId!.push(item);
            }
            this.filteredForInput = _data["filteredForInput"];
            this.maxDaysSearch = _data["maxDaysSearch"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ActivityQueryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityQueryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["skipElments"] = this.skipElments;
        data["orderField"] = this.orderField;
        data["orderAsc"] = this.orderAsc;
        data["id"] = this.id;
        data["clientId"] = this.clientId;
        data["contractingAuthorityId"] = this.contractingAuthorityId;
        data["profesionalId"] = this.profesionalId;
        data["adminId"] = this.adminId;
        data["name"] = this.name;
        data["includeDeleted"] = this.includeDeleted;
        data["primaryType"] = this.primaryType;
        data["secondaryType"] = this.secondaryType;
        if (Array.isArray(this.primaryTypeList)) {
            data["primaryTypeList"] = [];
            for (let item of this.primaryTypeList)
                data["primaryTypeList"].push(item);
        }
        if (Array.isArray(this.secondaryTypeList)) {
            data["secondaryTypeList"] = [];
            for (let item of this.secondaryTypeList)
                data["secondaryTypeList"].push(item);
        }
        data["contractId"] = this.contractId;
        data["icon"] = this.icon;
        data["isRecord"] = this.isRecord;
        data["isDeleted"] = this.isDeleted;
        data["includeUsers"] = this.includeUsers;
        data["description"] = this.description;
        data["languageId"] = this.languageId;
        data["clientTypeId"] = this.clientTypeId;
        data["associatedWorkingCenterId"] = this.associatedWorkingCenterId;
        if (Array.isArray(this.therapeuticalProfileIds)) {
            data["therapeuticalProfileIds"] = [];
            for (let item of this.therapeuticalProfileIds)
                data["therapeuticalProfileIds"].push(item);
        }
        if (Array.isArray(this.clientsLikesId)) {
            data["clientsLikesId"] = [];
            for (let item of this.clientsLikesId)
                data["clientsLikesId"].push(item);
        }
        data["filteredForInput"] = this.filteredForInput;
        data["maxDaysSearch"] = this.maxDaysSearch;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IActivityQueryDto {
    pageNumber?: number;
    pageSize?: number;
    skipElments?: number;
    orderField?: string | undefined;
    orderAsc?: boolean;
    id?: number | undefined;
    clientId?: number | undefined;
    contractingAuthorityId?: number | undefined;
    profesionalId?: number | undefined;
    adminId?: number | undefined;
    name?: string | undefined;
    includeDeleted?: boolean;
    primaryType?: number | undefined;
    secondaryType?: number | undefined;
    primaryTypeList?: number[] | undefined;
    secondaryTypeList?: number[] | undefined;
    contractId?: number | undefined;
    icon?: string | undefined;
    isRecord?: boolean | undefined;
    isDeleted?: string | undefined;
    includeUsers?: boolean;
    description?: string | undefined;
    languageId?: number | undefined;
    clientTypeId?: number | undefined;
    associatedWorkingCenterId?: number | undefined;
    therapeuticalProfileIds?: number[] | undefined;
    clientsLikesId?: number[] | undefined;
    filteredForInput?: boolean;
    maxDaysSearch?: number;
    date?: Date | undefined;
    endDate?: Date | undefined;
}

export class PagedResultDto_1OfOfActivityDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null implements IPagedResultDto_1OfOfActivityDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    elements?: ActivityDto[] | undefined;
    total?: number;
    pageNumber?: number;

    constructor(data?: IPagedResultDto_1OfOfActivityDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["elements"])) {
                this.elements = [] as any;
                for (let item of _data["elements"])
                    this.elements!.push(ActivityDto.fromJS(item));
            }
            this.total = _data["total"];
            this.pageNumber = _data["pageNumber"];
        }
    }

    static fromJS(data: any): PagedResultDto_1OfOfActivityDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDto_1OfOfActivityDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.elements)) {
            data["elements"] = [];
            for (let item of this.elements)
                data["elements"].push(item.toJSON());
        }
        data["total"] = this.total;
        data["pageNumber"] = this.pageNumber;
        return data;
    }
}

export interface IPagedResultDto_1OfOfActivityDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    elements?: ActivityDto[] | undefined;
    total?: number;
    pageNumber?: number;
}

export class SleepSummaryQueryDto implements ISleepSummaryQueryDto {
    fromDate?: string | undefined;
    toDate?: string | undefined;
    groupId?: string | undefined;

    constructor(data?: ISleepSummaryQueryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fromDate = _data["fromDate"];
            this.toDate = _data["toDate"];
            this.groupId = _data["groupId"];
        }
    }

    static fromJS(data: any): SleepSummaryQueryDto {
        data = typeof data === 'object' ? data : {};
        let result = new SleepSummaryQueryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fromDate"] = this.fromDate;
        data["toDate"] = this.toDate;
        data["groupId"] = this.groupId;
        return data;
    }
}

export interface ISleepSummaryQueryDto {
    fromDate?: string | undefined;
    toDate?: string | undefined;
    groupId?: string | undefined;
}

export class RangeValue implements IRangeValue {
    value?: string | undefined;
    rangeLow?: string | undefined;
    rangeHigh?: string | undefined;

    constructor(data?: IRangeValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.rangeLow = _data["rangeLow"];
            this.rangeHigh = _data["rangeHigh"];
        }
    }

    static fromJS(data: any): RangeValue {
        data = typeof data === 'object' ? data : {};
        let result = new RangeValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["rangeLow"] = this.rangeLow;
        data["rangeHigh"] = this.rangeHigh;
        return data;
    }
}

export interface IRangeValue {
    value?: string | undefined;
    rangeLow?: string | undefined;
    rangeHigh?: string | undefined;
}

export class Summary implements ISummary {
    timestamp?: string | undefined;
    bedTime?: RangeValue;
    wakeUpTime?: RangeValue;
    sleepDuration?: RangeValue;
    nbInterruptions?: RangeValue;
    interruptions?: string[][] | undefined;

    constructor(data?: ISummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timestamp = _data["timestamp"];
            this.bedTime = _data["bedTime"] ? RangeValue.fromJS(_data["bedTime"]) : <any>undefined;
            this.wakeUpTime = _data["wakeUpTime"] ? RangeValue.fromJS(_data["wakeUpTime"]) : <any>undefined;
            this.sleepDuration = _data["sleepDuration"] ? RangeValue.fromJS(_data["sleepDuration"]) : <any>undefined;
            this.nbInterruptions = _data["nbInterruptions"] ? RangeValue.fromJS(_data["nbInterruptions"]) : <any>undefined;
            if (Array.isArray(_data["interruptions"])) {
                this.interruptions = [] as any;
                for (let item of _data["interruptions"])
                    this.interruptions!.push(item);
            }
        }
    }

    static fromJS(data: any): Summary {
        data = typeof data === 'object' ? data : {};
        let result = new Summary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timestamp"] = this.timestamp;
        data["bedTime"] = this.bedTime ? this.bedTime.toJSON() : <any>undefined;
        data["wakeUpTime"] = this.wakeUpTime ? this.wakeUpTime.toJSON() : <any>undefined;
        data["sleepDuration"] = this.sleepDuration ? this.sleepDuration.toJSON() : <any>undefined;
        data["nbInterruptions"] = this.nbInterruptions ? this.nbInterruptions.toJSON() : <any>undefined;
        if (Array.isArray(this.interruptions)) {
            data["interruptions"] = [];
            for (let item of this.interruptions)
                data["interruptions"].push(item);
        }
        return data;
    }
}

export interface ISummary {
    timestamp?: string | undefined;
    bedTime?: RangeValue;
    wakeUpTime?: RangeValue;
    sleepDuration?: RangeValue;
    nbInterruptions?: RangeValue;
    interruptions?: string[][] | undefined;
}

export class SleepOrInterrupt implements ISleepOrInterrupt {
    type?: number;
    time?: number;
    startDate?: Date;
    endDate?: Date;

    constructor(data?: ISleepOrInterrupt) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.time = _data["time"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SleepOrInterrupt {
        data = typeof data === 'object' ? data : {};
        let result = new SleepOrInterrupt();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["time"] = this.time;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ISleepOrInterrupt {
    type?: number;
    time?: number;
    startDate?: Date;
    endDate?: Date;
}

export class SleepSummaryProcessedDto implements ISleepSummaryProcessedDto {
    summaries?: Summary[] | undefined;
    sleepOrInterrupt?: SleepOrInterrupt[][] | undefined;

    constructor(data?: ISleepSummaryProcessedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["summaries"])) {
                this.summaries = [] as any;
                for (let item of _data["summaries"])
                    this.summaries!.push(Summary.fromJS(item));
            }
            if (Array.isArray(_data["sleepOrInterrupt"])) {
                this.sleepOrInterrupt = [] as any;
                for (let item of _data["sleepOrInterrupt"])
                    this.sleepOrInterrupt!.push(item);
            }
        }
    }

    static fromJS(data: any): SleepSummaryProcessedDto {
        data = typeof data === 'object' ? data : {};
        let result = new SleepSummaryProcessedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.summaries)) {
            data["summaries"] = [];
            for (let item of this.summaries)
                data["summaries"].push(item.toJSON());
        }
        if (Array.isArray(this.sleepOrInterrupt)) {
            data["sleepOrInterrupt"] = [];
            for (let item of this.sleepOrInterrupt)
                data["sleepOrInterrupt"].push(item);
        }
        return data;
    }
}

export interface ISleepSummaryProcessedDto {
    summaries?: Summary[] | undefined;
    sleepOrInterrupt?: SleepOrInterrupt[][] | undefined;
}

export class MotionQueryDto implements IMotionQueryDto {
    fromDate?: string | undefined;
    toDate?: string | undefined;
    groupId?: string | undefined;

    constructor(data?: IMotionQueryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fromDate = _data["fromDate"];
            this.toDate = _data["toDate"];
            this.groupId = _data["groupId"];
        }
    }

    static fromJS(data: any): MotionQueryDto {
        data = typeof data === 'object' ? data : {};
        let result = new MotionQueryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fromDate"] = this.fromDate;
        data["toDate"] = this.toDate;
        data["groupId"] = this.groupId;
        return data;
    }
}

export interface IMotionQueryDto {
    fromDate?: string | undefined;
    toDate?: string | undefined;
    groupId?: string | undefined;
}

export class Location implements ILocation {
    sourceId?: string | undefined;
    score?: string | undefined;
    isNearby?: boolean | undefined;

    constructor(data?: ILocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceId = _data["sourceId"];
            this.score = _data["score"];
            this.isNearby = _data["isNearby"];
        }
    }

    static fromJS(data: any): Location {
        data = typeof data === 'object' ? data : {};
        let result = new Location();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceId"] = this.sourceId;
        data["score"] = this.score;
        data["isNearby"] = this.isNearby;
        return data;
    }
}

export interface ILocation {
    sourceId?: string | undefined;
    score?: string | undefined;
    isNearby?: boolean | undefined;
}

export class WinnerLocation implements IWinnerLocation {
    locations?: Location[] | undefined;

    constructor(data?: IWinnerLocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["locations"])) {
                this.locations = [] as any;
                for (let item of _data["locations"])
                    this.locations!.push(Location.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WinnerLocation {
        data = typeof data === 'object' ? data : {};
        let result = new WinnerLocation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.locations)) {
            data["locations"] = [];
            for (let item of this.locations)
                data["locations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IWinnerLocation {
    locations?: Location[] | undefined;
}

export class MotionResponseDto implements IMotionResponseDto {
    location?: WinnerLocation;

    constructor(data?: IMotionResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.location = _data["location"] ? WinnerLocation.fromJS(_data["location"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MotionResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new MotionResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMotionResponseDto {
    location?: WinnerLocation;
}

export class ActivitySummaryQueryDto implements IActivitySummaryQueryDto {
    fromDate?: string | undefined;
    toDate?: string | undefined;
    groupId?: string | undefined;
    period?: string | undefined;

    constructor(data?: IActivitySummaryQueryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fromDate = _data["fromDate"];
            this.toDate = _data["toDate"];
            this.groupId = _data["groupId"];
            this.period = _data["period"];
        }
    }

    static fromJS(data: any): ActivitySummaryQueryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivitySummaryQueryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fromDate"] = this.fromDate;
        data["toDate"] = this.toDate;
        data["groupId"] = this.groupId;
        data["period"] = this.period;
        return data;
    }
}

export interface IActivitySummaryQueryDto {
    fromDate?: string | undefined;
    toDate?: string | undefined;
    groupId?: string | undefined;
    period?: string | undefined;
}

export class ActivitySummary implements IActivitySummary {
    timestamp?: string | undefined;
    nbMinutes?: RangeValue;
    valid?: boolean;

    constructor(data?: IActivitySummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timestamp = _data["timestamp"];
            this.nbMinutes = _data["nbMinutes"] ? RangeValue.fromJS(_data["nbMinutes"]) : <any>undefined;
            this.valid = _data["valid"];
        }
    }

    static fromJS(data: any): ActivitySummary {
        data = typeof data === 'object' ? data : {};
        let result = new ActivitySummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timestamp"] = this.timestamp;
        data["nbMinutes"] = this.nbMinutes ? this.nbMinutes.toJSON() : <any>undefined;
        data["valid"] = this.valid;
        return data;
    }
}

export interface IActivitySummary {
    timestamp?: string | undefined;
    nbMinutes?: RangeValue;
    valid?: boolean;
}

export class ActivityResponseDto implements IActivityResponseDto {
    summaries?: ActivitySummary[] | undefined;

    constructor(data?: IActivityResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["summaries"])) {
                this.summaries = [] as any;
                for (let item of _data["summaries"])
                    this.summaries!.push(ActivitySummary.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ActivityResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.summaries)) {
            data["summaries"] = [];
            for (let item of this.summaries)
                data["summaries"].push(item.toJSON());
        }
        return data;
    }
}

export interface IActivityResponseDto {
    summaries?: ActivitySummary[] | undefined;
}

export class ActivityPredictionQueryDto implements IActivityPredictionQueryDto {
    fromDate?: string | undefined;
    toDate?: string | undefined;
    groupId?: string | undefined;
    period?: string | undefined;

    constructor(data?: IActivityPredictionQueryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fromDate = _data["fromDate"];
            this.toDate = _data["toDate"];
            this.groupId = _data["groupId"];
            this.period = _data["period"];
        }
    }

    static fromJS(data: any): ActivityPredictionQueryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityPredictionQueryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fromDate"] = this.fromDate;
        data["toDate"] = this.toDate;
        data["groupId"] = this.groupId;
        data["period"] = this.period;
        return data;
    }
}

export interface IActivityPredictionQueryDto {
    fromDate?: string | undefined;
    toDate?: string | undefined;
    groupId?: string | undefined;
    period?: string | undefined;
}

export class NbMinutes implements INbMinutes {
    value?: number | undefined;
    rangeLow?: number | undefined;
    rangeHigh?: number | undefined;

    constructor(data?: INbMinutes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.rangeLow = _data["rangeLow"];
            this.rangeHigh = _data["rangeHigh"];
        }
    }

    static fromJS(data: any): NbMinutes {
        data = typeof data === 'object' ? data : {};
        let result = new NbMinutes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["rangeLow"] = this.rangeLow;
        data["rangeHigh"] = this.rangeHigh;
        return data;
    }
}

export interface INbMinutes {
    value?: number | undefined;
    rangeLow?: number | undefined;
    rangeHigh?: number | undefined;
}

export class Prediction implements IPrediction {
    timestamp?: string | undefined;
    nbMinutes?: NbMinutes;
    valid?: boolean;

    constructor(data?: IPrediction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timestamp = _data["timestamp"];
            this.nbMinutes = _data["nbMinutes"] ? NbMinutes.fromJS(_data["nbMinutes"]) : <any>undefined;
            this.valid = _data["valid"];
        }
    }

    static fromJS(data: any): Prediction {
        data = typeof data === 'object' ? data : {};
        let result = new Prediction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timestamp"] = this.timestamp;
        data["nbMinutes"] = this.nbMinutes ? this.nbMinutes.toJSON() : <any>undefined;
        data["valid"] = this.valid;
        return data;
    }
}

export interface IPrediction {
    timestamp?: string | undefined;
    nbMinutes?: NbMinutes;
    valid?: boolean;
}

export class ActivityPredictionResponseDto implements IActivityPredictionResponseDto {
    type?: string | undefined;
    code?: number;
    period?: string | undefined;
    predictions?: Prediction[] | undefined;

    constructor(data?: IActivityPredictionResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.code = _data["code"];
            this.period = _data["period"];
            if (Array.isArray(_data["predictions"])) {
                this.predictions = [] as any;
                for (let item of _data["predictions"])
                    this.predictions!.push(Prediction.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ActivityPredictionResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityPredictionResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["code"] = this.code;
        data["period"] = this.period;
        if (Array.isArray(this.predictions)) {
            data["predictions"] = [];
            for (let item of this.predictions)
                data["predictions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IActivityPredictionResponseDto {
    type?: string | undefined;
    code?: number;
    period?: string | undefined;
    predictions?: Prediction[] | undefined;
}

export class SleepPredictionQueryDto implements ISleepPredictionQueryDto {
    fromDate?: string | undefined;
    toDate?: string | undefined;
    groupId?: string | undefined;
    period?: string | undefined;

    constructor(data?: ISleepPredictionQueryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fromDate = _data["fromDate"];
            this.toDate = _data["toDate"];
            this.groupId = _data["groupId"];
            this.period = _data["period"];
        }
    }

    static fromJS(data: any): SleepPredictionQueryDto {
        data = typeof data === 'object' ? data : {};
        let result = new SleepPredictionQueryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fromDate"] = this.fromDate;
        data["toDate"] = this.toDate;
        data["groupId"] = this.groupId;
        data["period"] = this.period;
        return data;
    }
}

export interface ISleepPredictionQueryDto {
    fromDate?: string | undefined;
    toDate?: string | undefined;
    groupId?: string | undefined;
    period?: string | undefined;
}

export class TimeRange implements ITimeRange {
    value?: Date | undefined;
    rangeLow?: Date | undefined;
    rangeHigh?: Date | undefined;

    constructor(data?: ITimeRange) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] ? new Date(_data["value"].toString()) : <any>undefined;
            this.rangeLow = _data["rangeLow"] ? new Date(_data["rangeLow"].toString()) : <any>undefined;
            this.rangeHigh = _data["rangeHigh"] ? new Date(_data["rangeHigh"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TimeRange {
        data = typeof data === 'object' ? data : {};
        let result = new TimeRange();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toISOString() : <any>undefined;
        data["rangeLow"] = this.rangeLow ? this.rangeLow.toISOString() : <any>undefined;
        data["rangeHigh"] = this.rangeHigh ? this.rangeHigh.toISOString() : <any>undefined;
        return data;
    }
}

export interface ITimeRange {
    value?: Date | undefined;
    rangeLow?: Date | undefined;
    rangeHigh?: Date | undefined;
}

export class NumericRange implements INumericRange {
    value?: number | undefined;
    rangeLow?: number | undefined;
    rangeHigh?: number | undefined;

    constructor(data?: INumericRange) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.rangeLow = _data["rangeLow"];
            this.rangeHigh = _data["rangeHigh"];
        }
    }

    static fromJS(data: any): NumericRange {
        data = typeof data === 'object' ? data : {};
        let result = new NumericRange();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["rangeLow"] = this.rangeLow;
        data["rangeHigh"] = this.rangeHigh;
        return data;
    }
}

export interface INumericRange {
    value?: number | undefined;
    rangeLow?: number | undefined;
    rangeHigh?: number | undefined;
}

export class SleepPrediction implements ISleepPrediction {
    timestamp?: string | undefined;
    valid?: boolean;
    bedTime?: TimeRange;
    wakeUpTime?: TimeRange;
    sleepDuration?: NumericRange;
    nbInterruptions?: NumericRange;

    constructor(data?: ISleepPrediction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timestamp = _data["timestamp"];
            this.valid = _data["valid"];
            this.bedTime = _data["bedTime"] ? TimeRange.fromJS(_data["bedTime"]) : <any>undefined;
            this.wakeUpTime = _data["wakeUpTime"] ? TimeRange.fromJS(_data["wakeUpTime"]) : <any>undefined;
            this.sleepDuration = _data["sleepDuration"] ? NumericRange.fromJS(_data["sleepDuration"]) : <any>undefined;
            this.nbInterruptions = _data["nbInterruptions"] ? NumericRange.fromJS(_data["nbInterruptions"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SleepPrediction {
        data = typeof data === 'object' ? data : {};
        let result = new SleepPrediction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timestamp"] = this.timestamp;
        data["valid"] = this.valid;
        data["bedTime"] = this.bedTime ? this.bedTime.toJSON() : <any>undefined;
        data["wakeUpTime"] = this.wakeUpTime ? this.wakeUpTime.toJSON() : <any>undefined;
        data["sleepDuration"] = this.sleepDuration ? this.sleepDuration.toJSON() : <any>undefined;
        data["nbInterruptions"] = this.nbInterruptions ? this.nbInterruptions.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISleepPrediction {
    timestamp?: string | undefined;
    valid?: boolean;
    bedTime?: TimeRange;
    wakeUpTime?: TimeRange;
    sleepDuration?: NumericRange;
    nbInterruptions?: NumericRange;
}

export class SleepPredictionResponseDto implements ISleepPredictionResponseDto {
    type?: string | undefined;
    code?: number;
    period?: string | undefined;
    predictions?: SleepPrediction[] | undefined;

    constructor(data?: ISleepPredictionResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.code = _data["code"];
            this.period = _data["period"];
            if (Array.isArray(_data["predictions"])) {
                this.predictions = [] as any;
                for (let item of _data["predictions"])
                    this.predictions!.push(SleepPrediction.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SleepPredictionResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new SleepPredictionResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["code"] = this.code;
        data["period"] = this.period;
        if (Array.isArray(this.predictions)) {
            data["predictions"] = [];
            for (let item of this.predictions)
                data["predictions"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISleepPredictionResponseDto {
    type?: string | undefined;
    code?: number;
    period?: string | undefined;
    predictions?: SleepPrediction[] | undefined;
}

export class SourceMetaDto implements ISourceMetaDto {
    floor?: number;
    location?: string | undefined;
    locationCustom?: string | undefined;
    name?: string | undefined;
    deviceType?: string | undefined;
    timezone?: string | undefined;

    constructor(data?: ISourceMetaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.floor = _data["floor"];
            this.location = _data["location"];
            this.locationCustom = _data["locationCustom"];
            this.name = _data["name"];
            this.deviceType = _data["deviceType"];
            this.timezone = _data["timezone"];
        }
    }

    static fromJS(data: any): SourceMetaDto {
        data = typeof data === 'object' ? data : {};
        let result = new SourceMetaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["floor"] = this.floor;
        data["location"] = this.location;
        data["locationCustom"] = this.locationCustom;
        data["name"] = this.name;
        data["deviceType"] = this.deviceType;
        data["timezone"] = this.timezone;
        return data;
    }
}

export interface ISourceMetaDto {
    floor?: number;
    location?: string | undefined;
    locationCustom?: string | undefined;
    name?: string | undefined;
    deviceType?: string | undefined;
    timezone?: string | undefined;
}

export class SourceDto implements ISourceDto {
    serial?: string | undefined;
    humanMotionDetected?: boolean;
    motionDetected?: boolean;
    sourceId?: string | undefined;
    meta?: SourceMetaDto;

    constructor(data?: ISourceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serial = _data["serial"];
            this.humanMotionDetected = _data["humanMotionDetected"];
            this.motionDetected = _data["motionDetected"];
            this.sourceId = _data["sourceId"];
            this.meta = _data["meta"] ? SourceMetaDto.fromJS(_data["meta"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SourceDto {
        data = typeof data === 'object' ? data : {};
        let result = new SourceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serial"] = this.serial;
        data["humanMotionDetected"] = this.humanMotionDetected;
        data["motionDetected"] = this.motionDetected;
        data["sourceId"] = this.sourceId;
        data["meta"] = this.meta ? this.meta.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISourceDto {
    serial?: string | undefined;
    humanMotionDetected?: boolean;
    motionDetected?: boolean;
    sourceId?: string | undefined;
    meta?: SourceMetaDto;
}

export class LocationDto implements ILocationDto {
    sourceId?: string | undefined;
    score?: number;
    isNearby?: boolean;

    constructor(data?: ILocationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceId = _data["sourceId"];
            this.score = _data["score"];
            this.isNearby = _data["isNearby"];
        }
    }

    static fromJS(data: any): LocationDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceId"] = this.sourceId;
        data["score"] = this.score;
        data["isNearby"] = this.isNearby;
        return data;
    }
}

export interface ILocationDto {
    sourceId?: string | undefined;
    score?: number;
    isNearby?: boolean;
}

export class LocationStatusDto implements ILocationStatusDto {
    location?: LocationDto[] | undefined;
    status?: string | undefined;
    statusMessage?: string | undefined;
    key?: string | undefined;
    wifiOpMode?: string | undefined;

    constructor(data?: ILocationStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["location"])) {
                this.location = [] as any;
                for (let item of _data["location"])
                    this.location!.push(LocationDto.fromJS(item));
            }
            this.status = _data["status"];
            this.statusMessage = _data["statusMessage"];
            this.key = _data["key"];
            this.wifiOpMode = _data["wifiOpMode"];
        }
    }

    static fromJS(data: any): LocationStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocationStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.location)) {
            data["location"] = [];
            for (let item of this.location)
                data["location"].push(item.toJSON());
        }
        data["status"] = this.status;
        data["statusMessage"] = this.statusMessage;
        data["key"] = this.key;
        data["wifiOpMode"] = this.wifiOpMode;
        return data;
    }
}

export interface ILocationStatusDto {
    location?: LocationDto[] | undefined;
    status?: string | undefined;
    statusMessage?: string | undefined;
    key?: string | undefined;
    wifiOpMode?: string | undefined;
}

export class GroupMotionStatusResponseDto implements IGroupMotionStatusResponseDto {
    code?: number | undefined;
    type?: string | undefined;
    timestamp?: Date | undefined;
    activityLevel?: number | undefined;
    humanMotionDetected?: boolean | undefined;
    motionDetected?: boolean | undefined;
    sources?: SourceDto[] | undefined;
    locations?: LocationStatusDto[] | undefined;

    constructor(data?: IGroupMotionStatusResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.type = _data["type"];
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : <any>undefined;
            this.activityLevel = _data["activityLevel"];
            this.humanMotionDetected = _data["humanMotionDetected"];
            this.motionDetected = _data["motionDetected"];
            if (Array.isArray(_data["sources"])) {
                this.sources = [] as any;
                for (let item of _data["sources"])
                    this.sources!.push(SourceDto.fromJS(item));
            }
            if (Array.isArray(_data["locations"])) {
                this.locations = [] as any;
                for (let item of _data["locations"])
                    this.locations!.push(LocationStatusDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GroupMotionStatusResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GroupMotionStatusResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["type"] = this.type;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        data["activityLevel"] = this.activityLevel;
        data["humanMotionDetected"] = this.humanMotionDetected;
        data["motionDetected"] = this.motionDetected;
        if (Array.isArray(this.sources)) {
            data["sources"] = [];
            for (let item of this.sources)
                data["sources"].push(item.toJSON());
        }
        if (Array.isArray(this.locations)) {
            data["locations"] = [];
            for (let item of this.locations)
                data["locations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGroupMotionStatusResponseDto {
    code?: number | undefined;
    type?: string | undefined;
    timestamp?: Date | undefined;
    activityLevel?: number | undefined;
    humanMotionDetected?: boolean | undefined;
    motionDetected?: boolean | undefined;
    sources?: SourceDto[] | undefined;
    locations?: LocationStatusDto[] | undefined;
}

export class ThingMotionStatusResponseDto implements IThingMotionStatusResponseDto {
    code?: number;
    type?: string | undefined;
    timestamp?: Date;
    activityLevel?: number;
    operationalState?: string | undefined;
    motionDetectionEnabled?: boolean | undefined;
    humanMotionDetected?: boolean | undefined;
    motionDetected?: boolean | undefined;

    constructor(data?: IThingMotionStatusResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.type = _data["type"];
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : <any>undefined;
            this.activityLevel = _data["activityLevel"];
            this.operationalState = _data["operationalState"];
            this.motionDetectionEnabled = _data["motionDetectionEnabled"];
            this.humanMotionDetected = _data["humanMotionDetected"];
            this.motionDetected = _data["motionDetected"];
        }
    }

    static fromJS(data: any): ThingMotionStatusResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThingMotionStatusResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["type"] = this.type;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        data["activityLevel"] = this.activityLevel;
        data["operationalState"] = this.operationalState;
        data["motionDetectionEnabled"] = this.motionDetectionEnabled;
        data["humanMotionDetected"] = this.humanMotionDetected;
        data["motionDetected"] = this.motionDetected;
        return data;
    }
}

export interface IThingMotionStatusResponseDto {
    code?: number;
    type?: string | undefined;
    timestamp?: Date;
    activityLevel?: number;
    operationalState?: string | undefined;
    motionDetectionEnabled?: boolean | undefined;
    humanMotionDetected?: boolean | undefined;
    motionDetected?: boolean | undefined;
}

export class SignalStrengthDto implements ISignalStrengthDto {
    rangeAbsoluteMax?: number | undefined;
    rangeAbsoluteMin?: number | undefined;
    rangeAcceptableMax?: number | undefined;
    rangeAcceptableMin?: number | undefined;
    statusMessage?: string | undefined;
    value?: number | undefined;

    constructor(data?: ISignalStrengthDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rangeAbsoluteMax = _data["rangeAbsoluteMax"];
            this.rangeAbsoluteMin = _data["rangeAbsoluteMin"];
            this.rangeAcceptableMax = _data["rangeAcceptableMax"];
            this.rangeAcceptableMin = _data["rangeAcceptableMin"];
            this.statusMessage = _data["statusMessage"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): SignalStrengthDto {
        data = typeof data === 'object' ? data : {};
        let result = new SignalStrengthDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rangeAbsoluteMax"] = this.rangeAbsoluteMax;
        data["rangeAbsoluteMin"] = this.rangeAbsoluteMin;
        data["rangeAcceptableMax"] = this.rangeAcceptableMax;
        data["rangeAcceptableMin"] = this.rangeAcceptableMin;
        data["statusMessage"] = this.statusMessage;
        data["value"] = this.value;
        return data;
    }
}

export interface ISignalStrengthDto {
    rangeAbsoluteMax?: number | undefined;
    rangeAbsoluteMin?: number | undefined;
    rangeAcceptableMax?: number | undefined;
    rangeAcceptableMin?: number | undefined;
    statusMessage?: string | undefined;
    value?: number | undefined;
}

export class SignalQualityDto implements ISignalQualityDto {
    rangeAbsoluteMax?: number | undefined;
    rangeAbsoluteMin?: number | undefined;
    rangeAcceptableMax?: number | undefined;
    rangeAcceptableMin?: number | undefined;
    statusMessage?: string | undefined;
    value?: number | undefined;

    constructor(data?: ISignalQualityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rangeAbsoluteMax = _data["rangeAbsoluteMax"];
            this.rangeAbsoluteMin = _data["rangeAbsoluteMin"];
            this.rangeAcceptableMax = _data["rangeAcceptableMax"];
            this.rangeAcceptableMin = _data["rangeAcceptableMin"];
            this.statusMessage = _data["statusMessage"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): SignalQualityDto {
        data = typeof data === 'object' ? data : {};
        let result = new SignalQualityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rangeAbsoluteMax"] = this.rangeAbsoluteMax;
        data["rangeAbsoluteMin"] = this.rangeAbsoluteMin;
        data["rangeAcceptableMax"] = this.rangeAcceptableMax;
        data["rangeAcceptableMin"] = this.rangeAcceptableMin;
        data["statusMessage"] = this.statusMessage;
        data["value"] = this.value;
        return data;
    }
}

export interface ISignalQualityDto {
    rangeAbsoluteMax?: number | undefined;
    rangeAbsoluteMin?: number | undefined;
    rangeAcceptableMax?: number | undefined;
    rangeAcceptableMin?: number | undefined;
    statusMessage?: string | undefined;
    value?: number | undefined;
}

export class SignalDto implements ISignalDto {
    strength?: SignalStrengthDto;
    quality?: SignalQualityDto;
    wifiClients?: { [key: string]: any; } | undefined;
    wifiStation?: { [key: string]: any; } | undefined;

    constructor(data?: ISignalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.strength = _data["strength"] ? SignalStrengthDto.fromJS(_data["strength"]) : <any>undefined;
            this.quality = _data["quality"] ? SignalQualityDto.fromJS(_data["quality"]) : <any>undefined;
            if (_data["wifiClients"]) {
                this.wifiClients = {} as any;
                for (let key in _data["wifiClients"]) {
                    if (_data["wifiClients"].hasOwnProperty(key))
                        (<any>this.wifiClients)![key] = _data["wifiClients"][key];
                }
            }
            if (_data["wifiStation"]) {
                this.wifiStation = {} as any;
                for (let key in _data["wifiStation"]) {
                    if (_data["wifiStation"].hasOwnProperty(key))
                        (<any>this.wifiStation)![key] = _data["wifiStation"][key];
                }
            }
        }
    }

    static fromJS(data: any): SignalDto {
        data = typeof data === 'object' ? data : {};
        let result = new SignalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["strength"] = this.strength ? this.strength.toJSON() : <any>undefined;
        data["quality"] = this.quality ? this.quality.toJSON() : <any>undefined;
        if (this.wifiClients) {
            data["wifiClients"] = {};
            for (let key in this.wifiClients) {
                if (this.wifiClients.hasOwnProperty(key))
                    (<any>data["wifiClients"])[key] = this.wifiClients[key];
            }
        }
        if (this.wifiStation) {
            data["wifiStation"] = {};
            for (let key in this.wifiStation) {
                if (this.wifiStation.hasOwnProperty(key))
                    (<any>data["wifiStation"])[key] = this.wifiStation[key];
            }
        }
        return data;
    }
}

export interface ISignalDto {
    strength?: SignalStrengthDto;
    quality?: SignalQualityDto;
    wifiClients?: { [key: string]: any; } | undefined;
    wifiStation?: { [key: string]: any; } | undefined;
}

export class DiagnosticResponseDto implements IDiagnosticResponseDto {
    code?: number | undefined;
    type?: string | undefined;
    connected?: boolean | undefined;
    statusMessage?: string | undefined;
    statusCode?: number | undefined;
    wifiClientsStatus?: { [key: string]: any; } | undefined;
    signal?: SignalDto;

    constructor(data?: IDiagnosticResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.type = _data["type"];
            this.connected = _data["connected"];
            this.statusMessage = _data["statusMessage"];
            this.statusCode = _data["statusCode"];
            if (_data["wifiClientsStatus"]) {
                this.wifiClientsStatus = {} as any;
                for (let key in _data["wifiClientsStatus"]) {
                    if (_data["wifiClientsStatus"].hasOwnProperty(key))
                        (<any>this.wifiClientsStatus)![key] = _data["wifiClientsStatus"][key];
                }
            }
            this.signal = _data["signal"] ? SignalDto.fromJS(_data["signal"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DiagnosticResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new DiagnosticResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["type"] = this.type;
        data["connected"] = this.connected;
        data["statusMessage"] = this.statusMessage;
        data["statusCode"] = this.statusCode;
        if (this.wifiClientsStatus) {
            data["wifiClientsStatus"] = {};
            for (let key in this.wifiClientsStatus) {
                if (this.wifiClientsStatus.hasOwnProperty(key))
                    (<any>data["wifiClientsStatus"])[key] = this.wifiClientsStatus[key];
            }
        }
        data["signal"] = this.signal ? this.signal.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDiagnosticResponseDto {
    code?: number | undefined;
    type?: string | undefined;
    connected?: boolean | undefined;
    statusMessage?: string | undefined;
    statusCode?: number | undefined;
    wifiClientsStatus?: { [key: string]: any; } | undefined;
    signal?: SignalDto;
}

export class ImageAttachment implements IImageAttachment {
    title?: string | undefined;
    src?: string | undefined;

    constructor(data?: IImageAttachment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.src = _data["src"];
        }
    }

    static fromJS(data: any): ImageAttachment {
        data = typeof data === 'object' ? data : {};
        let result = new ImageAttachment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["src"] = this.src;
        return data;
    }
}

export interface IImageAttachment {
    title?: string | undefined;
    src?: string | undefined;
}

export class MinClientDto implements IMinClientDto {
    id?: number;
    name?: string | undefined;
    surnames?: string | undefined;
    identificationNumber?: string | undefined;

    constructor(data?: IMinClientDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surnames = _data["surnames"];
            this.identificationNumber = _data["identificationNumber"];
        }
    }

    static fromJS(data: any): MinClientDto {
        data = typeof data === 'object' ? data : {};
        let result = new MinClientDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surnames"] = this.surnames;
        data["identificationNumber"] = this.identificationNumber;
        return data;
    }
}

export interface IMinClientDto {
    id?: number;
    name?: string | undefined;
    surnames?: string | undefined;
    identificationNumber?: string | undefined;
}

export class AndroidDeviceDto implements IAndroidDeviceDto {
    code?: string | undefined;
    installationDate?: Date | undefined;
    purchaseDate?: Date | undefined;
    associatedWorkingCenterId?: number | undefined;
    associatedCameraId?: number | undefined;
    associatedContractId?: number | undefined;
    returned?: boolean;
    associatedFirmwareModelId?: number | undefined;
    associatedTvBoxModelId?: number | undefined;
    id!: number;
    isFailed?: boolean;
    failDetail?: string | undefined;
    relatedUser?: MinClientDto;

    constructor(data?: IAndroidDeviceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.installationDate = _data["installationDate"] ? new Date(_data["installationDate"].toString()) : <any>undefined;
            this.purchaseDate = _data["purchaseDate"] ? new Date(_data["purchaseDate"].toString()) : <any>undefined;
            this.associatedWorkingCenterId = _data["associatedWorkingCenterId"];
            this.associatedCameraId = _data["associatedCameraId"];
            this.associatedContractId = _data["associatedContractId"];
            this.returned = _data["returned"];
            this.associatedFirmwareModelId = _data["associatedFirmwareModelId"];
            this.associatedTvBoxModelId = _data["associatedTvBoxModelId"];
            this.id = _data["id"];
            this.isFailed = _data["isFailed"];
            this.failDetail = _data["failDetail"];
            this.relatedUser = _data["relatedUser"] ? MinClientDto.fromJS(_data["relatedUser"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AndroidDeviceDto {
        data = typeof data === 'object' ? data : {};
        let result = new AndroidDeviceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["installationDate"] = this.installationDate ? this.installationDate.toISOString() : <any>undefined;
        data["purchaseDate"] = this.purchaseDate ? this.purchaseDate.toISOString() : <any>undefined;
        data["associatedWorkingCenterId"] = this.associatedWorkingCenterId;
        data["associatedCameraId"] = this.associatedCameraId;
        data["associatedContractId"] = this.associatedContractId;
        data["returned"] = this.returned;
        data["associatedFirmwareModelId"] = this.associatedFirmwareModelId;
        data["associatedTvBoxModelId"] = this.associatedTvBoxModelId;
        data["id"] = this.id;
        data["isFailed"] = this.isFailed;
        data["failDetail"] = this.failDetail;
        data["relatedUser"] = this.relatedUser ? this.relatedUser.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAndroidDeviceDto {
    code?: string | undefined;
    installationDate?: Date | undefined;
    purchaseDate?: Date | undefined;
    associatedWorkingCenterId?: number | undefined;
    associatedCameraId?: number | undefined;
    associatedContractId?: number | undefined;
    returned?: boolean;
    associatedFirmwareModelId?: number | undefined;
    associatedTvBoxModelId?: number | undefined;
    id: number;
    isFailed?: boolean;
    failDetail?: string | undefined;
    relatedUser?: MinClientDto;
}

export class CommunicationDeviceDto implements ICommunicationDeviceDto {
    code!: string;
    installationDate?: Date | undefined;
    communicationTypeId?: number | undefined;
    companyPhone?: string | undefined;
    companyContract?: string | undefined;
    contractCode?: string | undefined;
    purchaseDate?: Date | undefined;
    associatedWorkingCenterId?: number | undefined;
    associatedAndroidDeviceId?: number | undefined;
    routerModelId?: number | undefined;
    cameraModelId?: number | undefined;
    routerLineStatusId?: number | undefined;
    id!: number;
    isFailed?: boolean;
    failDetail?: string | undefined;
    relatedUser?: MinClientDto;
    androidDevice?: AndroidDeviceDto;

    constructor(data?: ICommunicationDeviceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.installationDate = _data["installationDate"] ? new Date(_data["installationDate"].toString()) : <any>undefined;
            this.communicationTypeId = _data["communicationTypeId"];
            this.companyPhone = _data["companyPhone"];
            this.companyContract = _data["companyContract"];
            this.contractCode = _data["contractCode"];
            this.purchaseDate = _data["purchaseDate"] ? new Date(_data["purchaseDate"].toString()) : <any>undefined;
            this.associatedWorkingCenterId = _data["associatedWorkingCenterId"];
            this.associatedAndroidDeviceId = _data["associatedAndroidDeviceId"];
            this.routerModelId = _data["routerModelId"];
            this.cameraModelId = _data["cameraModelId"];
            this.routerLineStatusId = _data["routerLineStatusId"];
            this.id = _data["id"];
            this.isFailed = _data["isFailed"];
            this.failDetail = _data["failDetail"];
            this.relatedUser = _data["relatedUser"] ? MinClientDto.fromJS(_data["relatedUser"]) : <any>undefined;
            this.androidDevice = _data["androidDevice"] ? AndroidDeviceDto.fromJS(_data["androidDevice"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CommunicationDeviceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommunicationDeviceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["installationDate"] = this.installationDate ? this.installationDate.toISOString() : <any>undefined;
        data["communicationTypeId"] = this.communicationTypeId;
        data["companyPhone"] = this.companyPhone;
        data["companyContract"] = this.companyContract;
        data["contractCode"] = this.contractCode;
        data["purchaseDate"] = this.purchaseDate ? this.purchaseDate.toISOString() : <any>undefined;
        data["associatedWorkingCenterId"] = this.associatedWorkingCenterId;
        data["associatedAndroidDeviceId"] = this.associatedAndroidDeviceId;
        data["routerModelId"] = this.routerModelId;
        data["cameraModelId"] = this.cameraModelId;
        data["routerLineStatusId"] = this.routerLineStatusId;
        data["id"] = this.id;
        data["isFailed"] = this.isFailed;
        data["failDetail"] = this.failDetail;
        data["relatedUser"] = this.relatedUser ? this.relatedUser.toJSON() : <any>undefined;
        data["androidDevice"] = this.androidDevice ? this.androidDevice.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICommunicationDeviceDto {
    code: string;
    installationDate?: Date | undefined;
    communicationTypeId?: number | undefined;
    companyPhone?: string | undefined;
    companyContract?: string | undefined;
    contractCode?: string | undefined;
    purchaseDate?: Date | undefined;
    associatedWorkingCenterId?: number | undefined;
    associatedAndroidDeviceId?: number | undefined;
    routerModelId?: number | undefined;
    cameraModelId?: number | undefined;
    routerLineStatusId?: number | undefined;
    id: number;
    isFailed?: boolean;
    failDetail?: string | undefined;
    relatedUser?: MinClientDto;
    androidDevice?: AndroidDeviceDto;
}

export class ClientDtoBase implements IClientDtoBase {
    id?: number | undefined;
    email?: string | undefined;
    identificationNumber!: string;
    name!: string;
    surnames!: string;
    cellPhone?: string | undefined;
    homePhone?: string | undefined;
    countryId?: number | undefined;
    provinceId?: number | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    address?: string | undefined;
    address2?: string | undefined;
    townId?: number | undefined;
    postCodeId?: number | undefined;
    languages?: number[] | undefined;
    contractLogoId?: number | undefined;
    clientTypeId?: number | undefined;
    clientLikes?: number[] | undefined;
    therapeuticalProfiles?: number[] | undefined;
    associatedWorkingCenterId?: number | undefined;
    picture?: ImageAttachment;
    alias?: string | undefined;

    constructor(data?: IClientDtoBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
            this.identificationNumber = _data["identificationNumber"];
            this.name = _data["name"];
            this.surnames = _data["surnames"];
            this.cellPhone = _data["cellPhone"];
            this.homePhone = _data["homePhone"];
            this.countryId = _data["countryId"];
            this.provinceId = _data["provinceId"];
            this.city = _data["city"];
            this.postalCode = _data["postalCode"];
            this.address = _data["address"];
            this.address2 = _data["address2"];
            this.townId = _data["townId"];
            this.postCodeId = _data["postCodeId"];
            if (Array.isArray(_data["languages"])) {
                this.languages = [] as any;
                for (let item of _data["languages"])
                    this.languages!.push(item);
            }
            this.contractLogoId = _data["contractLogoId"];
            this.clientTypeId = _data["clientTypeId"];
            if (Array.isArray(_data["clientLikes"])) {
                this.clientLikes = [] as any;
                for (let item of _data["clientLikes"])
                    this.clientLikes!.push(item);
            }
            if (Array.isArray(_data["therapeuticalProfiles"])) {
                this.therapeuticalProfiles = [] as any;
                for (let item of _data["therapeuticalProfiles"])
                    this.therapeuticalProfiles!.push(item);
            }
            this.associatedWorkingCenterId = _data["associatedWorkingCenterId"];
            this.picture = _data["picture"] ? ImageAttachment.fromJS(_data["picture"]) : <any>undefined;
            this.alias = _data["alias"];
        }
    }

    static fromJS(data: any): ClientDtoBase {
        data = typeof data === 'object' ? data : {};
        let result = new ClientDtoBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        data["identificationNumber"] = this.identificationNumber;
        data["name"] = this.name;
        data["surnames"] = this.surnames;
        data["cellPhone"] = this.cellPhone;
        data["homePhone"] = this.homePhone;
        data["countryId"] = this.countryId;
        data["provinceId"] = this.provinceId;
        data["city"] = this.city;
        data["postalCode"] = this.postalCode;
        data["address"] = this.address;
        data["address2"] = this.address2;
        data["townId"] = this.townId;
        data["postCodeId"] = this.postCodeId;
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item);
        }
        data["contractLogoId"] = this.contractLogoId;
        data["clientTypeId"] = this.clientTypeId;
        if (Array.isArray(this.clientLikes)) {
            data["clientLikes"] = [];
            for (let item of this.clientLikes)
                data["clientLikes"].push(item);
        }
        if (Array.isArray(this.therapeuticalProfiles)) {
            data["therapeuticalProfiles"] = [];
            for (let item of this.therapeuticalProfiles)
                data["therapeuticalProfiles"].push(item);
        }
        data["associatedWorkingCenterId"] = this.associatedWorkingCenterId;
        data["picture"] = this.picture ? this.picture.toJSON() : <any>undefined;
        data["alias"] = this.alias;
        return data;
    }
}

export interface IClientDtoBase {
    id?: number | undefined;
    email?: string | undefined;
    identificationNumber: string;
    name: string;
    surnames: string;
    cellPhone?: string | undefined;
    homePhone?: string | undefined;
    countryId?: number | undefined;
    provinceId?: number | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    address?: string | undefined;
    address2?: string | undefined;
    townId?: number | undefined;
    postCodeId?: number | undefined;
    languages?: number[] | undefined;
    contractLogoId?: number | undefined;
    clientTypeId?: number | undefined;
    clientLikes?: number[] | undefined;
    therapeuticalProfiles?: number[] | undefined;
    associatedWorkingCenterId?: number | undefined;
    picture?: ImageAttachment;
    alias?: string | undefined;
}

export class ClientExternalPartnersDto implements IClientExternalPartnersDto {
    id?: number;
    client?: ClientDtoBase;
    aerialGroupId?: string | undefined;
    residentName?: string | undefined;
    groupIdAndResidentName?: string | undefined;
    baseportMac?: string | undefined;
    baseportLocationId?: number | undefined;
    baseportModelId?: number | undefined;
    baseportLocationCustom?: string | undefined;
    thing1Mac?: string | undefined;
    thing1Serial?: string | undefined;
    thing1Sensibility?: number;
    thing1LocationId?: number | undefined;
    thing1ModelId?: number | undefined;
    thing1LocationCustom?: string | undefined;
    thing2Mac?: string | undefined;
    thing2Serial?: string | undefined;
    thing2Sensibility?: number;
    thing2LocationId?: number | undefined;
    thing2ModelId?: number | undefined;
    thing2LocationCustom?: string | undefined;
    thing3Mac?: string | undefined;
    thing3Serial?: string | undefined;
    thing3Sensibility?: number;
    thing3LocationId?: number | undefined;
    thing3ModelId?: number | undefined;
    thing3LocationCustom?: string | undefined;
    isInstalled?: boolean;
    installationDate?: Date | undefined;
    isDeleted?: boolean;

    constructor(data?: IClientExternalPartnersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.client = _data["client"] ? ClientDtoBase.fromJS(_data["client"]) : <any>undefined;
            this.aerialGroupId = _data["aerialGroupId"];
            this.residentName = _data["residentName"];
            this.groupIdAndResidentName = _data["groupIdAndResidentName"];
            this.baseportMac = _data["baseportMac"];
            this.baseportLocationId = _data["baseportLocationId"];
            this.baseportModelId = _data["baseportModelId"];
            this.baseportLocationCustom = _data["baseportLocationCustom"];
            this.thing1Mac = _data["thing1Mac"];
            this.thing1Serial = _data["thing1Serial"];
            this.thing1Sensibility = _data["thing1Sensibility"];
            this.thing1LocationId = _data["thing1LocationId"];
            this.thing1ModelId = _data["thing1ModelId"];
            this.thing1LocationCustom = _data["thing1LocationCustom"];
            this.thing2Mac = _data["thing2Mac"];
            this.thing2Serial = _data["thing2Serial"];
            this.thing2Sensibility = _data["thing2Sensibility"];
            this.thing2LocationId = _data["thing2LocationId"];
            this.thing2ModelId = _data["thing2ModelId"];
            this.thing2LocationCustom = _data["thing2LocationCustom"];
            this.thing3Mac = _data["thing3Mac"];
            this.thing3Serial = _data["thing3Serial"];
            this.thing3Sensibility = _data["thing3Sensibility"];
            this.thing3LocationId = _data["thing3LocationId"];
            this.thing3ModelId = _data["thing3ModelId"];
            this.thing3LocationCustom = _data["thing3LocationCustom"];
            this.isInstalled = _data["isInstalled"];
            this.installationDate = _data["installationDate"] ? new Date(_data["installationDate"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): ClientExternalPartnersDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientExternalPartnersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["client"] = this.client ? this.client.toJSON() : <any>undefined;
        data["aerialGroupId"] = this.aerialGroupId;
        data["residentName"] = this.residentName;
        data["groupIdAndResidentName"] = this.groupIdAndResidentName;
        data["baseportMac"] = this.baseportMac;
        data["baseportLocationId"] = this.baseportLocationId;
        data["baseportModelId"] = this.baseportModelId;
        data["baseportLocationCustom"] = this.baseportLocationCustom;
        data["thing1Mac"] = this.thing1Mac;
        data["thing1Serial"] = this.thing1Serial;
        data["thing1Sensibility"] = this.thing1Sensibility;
        data["thing1LocationId"] = this.thing1LocationId;
        data["thing1ModelId"] = this.thing1ModelId;
        data["thing1LocationCustom"] = this.thing1LocationCustom;
        data["thing2Mac"] = this.thing2Mac;
        data["thing2Serial"] = this.thing2Serial;
        data["thing2Sensibility"] = this.thing2Sensibility;
        data["thing2LocationId"] = this.thing2LocationId;
        data["thing2ModelId"] = this.thing2ModelId;
        data["thing2LocationCustom"] = this.thing2LocationCustom;
        data["thing3Mac"] = this.thing3Mac;
        data["thing3Serial"] = this.thing3Serial;
        data["thing3Sensibility"] = this.thing3Sensibility;
        data["thing3LocationId"] = this.thing3LocationId;
        data["thing3ModelId"] = this.thing3ModelId;
        data["thing3LocationCustom"] = this.thing3LocationCustom;
        data["isInstalled"] = this.isInstalled;
        data["installationDate"] = this.installationDate ? this.installationDate.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface IClientExternalPartnersDto {
    id?: number;
    client?: ClientDtoBase;
    aerialGroupId?: string | undefined;
    residentName?: string | undefined;
    groupIdAndResidentName?: string | undefined;
    baseportMac?: string | undefined;
    baseportLocationId?: number | undefined;
    baseportModelId?: number | undefined;
    baseportLocationCustom?: string | undefined;
    thing1Mac?: string | undefined;
    thing1Serial?: string | undefined;
    thing1Sensibility?: number;
    thing1LocationId?: number | undefined;
    thing1ModelId?: number | undefined;
    thing1LocationCustom?: string | undefined;
    thing2Mac?: string | undefined;
    thing2Serial?: string | undefined;
    thing2Sensibility?: number;
    thing2LocationId?: number | undefined;
    thing2ModelId?: number | undefined;
    thing2LocationCustom?: string | undefined;
    thing3Mac?: string | undefined;
    thing3Serial?: string | undefined;
    thing3Sensibility?: number;
    thing3LocationId?: number | undefined;
    thing3ModelId?: number | undefined;
    thing3LocationCustom?: string | undefined;
    isInstalled?: boolean;
    installationDate?: Date | undefined;
    isDeleted?: boolean;
}

export class ServicePackageDto implements IServicePackageDto {
    id?: number;
    name?: string | undefined;
    serviceTypeId?: number | undefined;
    activityTypeId?: number | undefined;
    subtypeActivityId?: number | undefined;
    serviceTypeName?: string | undefined;
    activityTypeName?: string | undefined;
    subtypeActivityName?: string | undefined;
    numberOfSessions?: number;
    isDeleted?: boolean;

    constructor(data?: IServicePackageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.serviceTypeId = _data["serviceTypeId"];
            this.activityTypeId = _data["activityTypeId"];
            this.subtypeActivityId = _data["subtypeActivityId"];
            this.serviceTypeName = _data["serviceTypeName"];
            this.activityTypeName = _data["activityTypeName"];
            this.subtypeActivityName = _data["subtypeActivityName"];
            this.numberOfSessions = _data["numberOfSessions"];
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): ServicePackageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServicePackageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["serviceTypeId"] = this.serviceTypeId;
        data["activityTypeId"] = this.activityTypeId;
        data["subtypeActivityId"] = this.subtypeActivityId;
        data["serviceTypeName"] = this.serviceTypeName;
        data["activityTypeName"] = this.activityTypeName;
        data["subtypeActivityName"] = this.subtypeActivityName;
        data["numberOfSessions"] = this.numberOfSessions;
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface IServicePackageDto {
    id?: number;
    name?: string | undefined;
    serviceTypeId?: number | undefined;
    activityTypeId?: number | undefined;
    subtypeActivityId?: number | undefined;
    serviceTypeName?: string | undefined;
    activityTypeName?: string | undefined;
    subtypeActivityName?: string | undefined;
    numberOfSessions?: number;
    isDeleted?: boolean;
}

export class ClientDto implements IClientDto {
    id?: number | undefined;
    email?: string | undefined;
    identificationNumber!: string;
    name!: string;
    surnames!: string;
    cellPhone?: string | undefined;
    homePhone?: string | undefined;
    countryId?: number | undefined;
    provinceId?: number | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    address?: string | undefined;
    address2?: string | undefined;
    townId?: number | undefined;
    postCodeId?: number | undefined;
    languages?: number[] | undefined;
    contractLogoId?: number | undefined;
    clientTypeId?: number | undefined;
    clientLikes?: number[] | undefined;
    therapeuticalProfiles?: number[] | undefined;
    associatedWorkingCenterId?: number | undefined;
    picture?: ImageAttachment;
    alias?: string | undefined;
    sharepointFolder?: string | undefined;
    supportProfessional?: UserMinDto;
    referenceSocialWorker?: UserMinDto;
    androidDevice?: AndroidDeviceDto;
    communicationDevice?: CommunicationDeviceDto;
    contracts?: ContractDto[] | undefined;
    viewPassword?: boolean;
    age?: number | undefined;
    birthDate?: Date | undefined;
    activeDate?: Date | undefined;
    leavingDate?: Date | undefined;
    inactivityDate?: Date | undefined;
    setupDate?: Date | undefined;
    veraAppVersionDate?: Date | undefined;
    veraAppVersion?: string | undefined;
    genderId?: number | undefined;
    genderIdentity?: string | undefined;
    dependencyDegreeId?: number | undefined;
    technologicalIndependenceId?: number | undefined;
    usesTechHelpId?: number | undefined;
    whichOnesTechHelp?: string | undefined;
    active?: string | undefined;
    clientExternalPartners?: ClientExternalPartnersDto;
    isUsingAerial?: boolean;
    civilStatusId?: number | undefined;
    professionId?: number | undefined;
    mainContractId?: number | undefined;
    levelOfEducationId?: number | undefined;
    typeOfStudiesId?: number | undefined;
    culturalLevelId?: number | undefined;
    serviceModalityId?: number | undefined;
    levelOfLonelinessId?: number | undefined;
    sociodemographicEnvironmentId?: number | undefined;
    causeOfWithdrawalId?: number | undefined;
    levelOfSocializationId?: number | undefined;
    serviceModalityName?: string | undefined;
    levelOfLonelinessName?: string | undefined;
    sociodemographicEnvironmentName?: string | undefined;
    causeOfWithdrawalName?: string | undefined;
    levelOfSocializationName?: string | undefined;
    municipalityPEVSId?: number | undefined;
    municipalityPEVSName?: string | undefined;
    dateOfFirstVisit?: Date | undefined;
    contractSigningDate?: Date | undefined;
    contractExpirationDate?: Date | undefined;
    cohabitantId?: number | undefined;
    cohabitantName?: string | undefined;
    cognitiveDeclineId?: number | undefined;
    cognitiveDeclineName?: string | undefined;
    servicePackages?: ServicePackageDto[] | undefined;

    constructor(data?: IClientDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
            this.identificationNumber = _data["identificationNumber"];
            this.name = _data["name"];
            this.surnames = _data["surnames"];
            this.cellPhone = _data["cellPhone"];
            this.homePhone = _data["homePhone"];
            this.countryId = _data["countryId"];
            this.provinceId = _data["provinceId"];
            this.city = _data["city"];
            this.postalCode = _data["postalCode"];
            this.address = _data["address"];
            this.address2 = _data["address2"];
            this.townId = _data["townId"];
            this.postCodeId = _data["postCodeId"];
            if (Array.isArray(_data["languages"])) {
                this.languages = [] as any;
                for (let item of _data["languages"])
                    this.languages!.push(item);
            }
            this.contractLogoId = _data["contractLogoId"];
            this.clientTypeId = _data["clientTypeId"];
            if (Array.isArray(_data["clientLikes"])) {
                this.clientLikes = [] as any;
                for (let item of _data["clientLikes"])
                    this.clientLikes!.push(item);
            }
            if (Array.isArray(_data["therapeuticalProfiles"])) {
                this.therapeuticalProfiles = [] as any;
                for (let item of _data["therapeuticalProfiles"])
                    this.therapeuticalProfiles!.push(item);
            }
            this.associatedWorkingCenterId = _data["associatedWorkingCenterId"];
            this.picture = _data["picture"] ? ImageAttachment.fromJS(_data["picture"]) : <any>undefined;
            this.alias = _data["alias"];
            this.sharepointFolder = _data["sharepointFolder"];
            this.supportProfessional = _data["supportProfessional"] ? UserMinDto.fromJS(_data["supportProfessional"]) : <any>undefined;
            this.referenceSocialWorker = _data["referenceSocialWorker"] ? UserMinDto.fromJS(_data["referenceSocialWorker"]) : <any>undefined;
            this.androidDevice = _data["androidDevice"] ? AndroidDeviceDto.fromJS(_data["androidDevice"]) : <any>undefined;
            this.communicationDevice = _data["communicationDevice"] ? CommunicationDeviceDto.fromJS(_data["communicationDevice"]) : <any>undefined;
            if (Array.isArray(_data["contracts"])) {
                this.contracts = [] as any;
                for (let item of _data["contracts"])
                    this.contracts!.push(ContractDto.fromJS(item));
            }
            this.viewPassword = _data["viewPassword"];
            this.age = _data["age"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.activeDate = _data["activeDate"] ? new Date(_data["activeDate"].toString()) : <any>undefined;
            this.leavingDate = _data["leavingDate"] ? new Date(_data["leavingDate"].toString()) : <any>undefined;
            this.inactivityDate = _data["inactivityDate"] ? new Date(_data["inactivityDate"].toString()) : <any>undefined;
            this.setupDate = _data["setupDate"] ? new Date(_data["setupDate"].toString()) : <any>undefined;
            this.veraAppVersionDate = _data["veraAppVersionDate"] ? new Date(_data["veraAppVersionDate"].toString()) : <any>undefined;
            this.veraAppVersion = _data["veraAppVersion"];
            this.genderId = _data["genderId"];
            this.genderIdentity = _data["genderIdentity"];
            this.dependencyDegreeId = _data["dependencyDegreeId"];
            this.technologicalIndependenceId = _data["technologicalIndependenceId"];
            this.usesTechHelpId = _data["usesTechHelpId"];
            this.whichOnesTechHelp = _data["whichOnesTechHelp"];
            this.active = _data["active"];
            this.clientExternalPartners = _data["clientExternalPartners"] ? ClientExternalPartnersDto.fromJS(_data["clientExternalPartners"]) : <any>undefined;
            this.isUsingAerial = _data["isUsingAerial"];
            this.civilStatusId = _data["civilStatusId"];
            this.professionId = _data["professionId"];
            this.mainContractId = _data["mainContractId"];
            this.levelOfEducationId = _data["levelOfEducationId"];
            this.typeOfStudiesId = _data["typeOfStudiesId"];
            this.culturalLevelId = _data["culturalLevelId"];
            this.serviceModalityId = _data["serviceModalityId"];
            this.levelOfLonelinessId = _data["levelOfLonelinessId"];
            this.sociodemographicEnvironmentId = _data["sociodemographicEnvironmentId"];
            this.causeOfWithdrawalId = _data["causeOfWithdrawalId"];
            this.levelOfSocializationId = _data["levelOfSocializationId"];
            this.serviceModalityName = _data["serviceModalityName"];
            this.levelOfLonelinessName = _data["levelOfLonelinessName"];
            this.sociodemographicEnvironmentName = _data["sociodemographicEnvironmentName"];
            this.causeOfWithdrawalName = _data["causeOfWithdrawalName"];
            this.levelOfSocializationName = _data["levelOfSocializationName"];
            this.municipalityPEVSId = _data["municipalityPEVSId"];
            this.municipalityPEVSName = _data["municipalityPEVSName"];
            this.dateOfFirstVisit = _data["dateOfFirstVisit"] ? new Date(_data["dateOfFirstVisit"].toString()) : <any>undefined;
            this.contractSigningDate = _data["contractSigningDate"] ? new Date(_data["contractSigningDate"].toString()) : <any>undefined;
            this.contractExpirationDate = _data["contractExpirationDate"] ? new Date(_data["contractExpirationDate"].toString()) : <any>undefined;
            this.cohabitantId = _data["cohabitantId"];
            this.cohabitantName = _data["cohabitantName"];
            this.cognitiveDeclineId = _data["cognitiveDeclineId"];
            this.cognitiveDeclineName = _data["cognitiveDeclineName"];
            if (Array.isArray(_data["servicePackages"])) {
                this.servicePackages = [] as any;
                for (let item of _data["servicePackages"])
                    this.servicePackages!.push(ServicePackageDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ClientDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        data["identificationNumber"] = this.identificationNumber;
        data["name"] = this.name;
        data["surnames"] = this.surnames;
        data["cellPhone"] = this.cellPhone;
        data["homePhone"] = this.homePhone;
        data["countryId"] = this.countryId;
        data["provinceId"] = this.provinceId;
        data["city"] = this.city;
        data["postalCode"] = this.postalCode;
        data["address"] = this.address;
        data["address2"] = this.address2;
        data["townId"] = this.townId;
        data["postCodeId"] = this.postCodeId;
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item);
        }
        data["contractLogoId"] = this.contractLogoId;
        data["clientTypeId"] = this.clientTypeId;
        if (Array.isArray(this.clientLikes)) {
            data["clientLikes"] = [];
            for (let item of this.clientLikes)
                data["clientLikes"].push(item);
        }
        if (Array.isArray(this.therapeuticalProfiles)) {
            data["therapeuticalProfiles"] = [];
            for (let item of this.therapeuticalProfiles)
                data["therapeuticalProfiles"].push(item);
        }
        data["associatedWorkingCenterId"] = this.associatedWorkingCenterId;
        data["picture"] = this.picture ? this.picture.toJSON() : <any>undefined;
        data["alias"] = this.alias;
        data["sharepointFolder"] = this.sharepointFolder;
        data["supportProfessional"] = this.supportProfessional ? this.supportProfessional.toJSON() : <any>undefined;
        data["referenceSocialWorker"] = this.referenceSocialWorker ? this.referenceSocialWorker.toJSON() : <any>undefined;
        data["androidDevice"] = this.androidDevice ? this.androidDevice.toJSON() : <any>undefined;
        data["communicationDevice"] = this.communicationDevice ? this.communicationDevice.toJSON() : <any>undefined;
        if (Array.isArray(this.contracts)) {
            data["contracts"] = [];
            for (let item of this.contracts)
                data["contracts"].push(item.toJSON());
        }
        data["viewPassword"] = this.viewPassword;
        data["age"] = this.age;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["activeDate"] = this.activeDate ? this.activeDate.toISOString() : <any>undefined;
        data["leavingDate"] = this.leavingDate ? this.leavingDate.toISOString() : <any>undefined;
        data["inactivityDate"] = this.inactivityDate ? this.inactivityDate.toISOString() : <any>undefined;
        data["setupDate"] = this.setupDate ? this.setupDate.toISOString() : <any>undefined;
        data["veraAppVersionDate"] = this.veraAppVersionDate ? this.veraAppVersionDate.toISOString() : <any>undefined;
        data["veraAppVersion"] = this.veraAppVersion;
        data["genderId"] = this.genderId;
        data["genderIdentity"] = this.genderIdentity;
        data["dependencyDegreeId"] = this.dependencyDegreeId;
        data["technologicalIndependenceId"] = this.technologicalIndependenceId;
        data["usesTechHelpId"] = this.usesTechHelpId;
        data["whichOnesTechHelp"] = this.whichOnesTechHelp;
        data["active"] = this.active;
        data["clientExternalPartners"] = this.clientExternalPartners ? this.clientExternalPartners.toJSON() : <any>undefined;
        data["isUsingAerial"] = this.isUsingAerial;
        data["civilStatusId"] = this.civilStatusId;
        data["professionId"] = this.professionId;
        data["mainContractId"] = this.mainContractId;
        data["levelOfEducationId"] = this.levelOfEducationId;
        data["typeOfStudiesId"] = this.typeOfStudiesId;
        data["culturalLevelId"] = this.culturalLevelId;
        data["serviceModalityId"] = this.serviceModalityId;
        data["levelOfLonelinessId"] = this.levelOfLonelinessId;
        data["sociodemographicEnvironmentId"] = this.sociodemographicEnvironmentId;
        data["causeOfWithdrawalId"] = this.causeOfWithdrawalId;
        data["levelOfSocializationId"] = this.levelOfSocializationId;
        data["serviceModalityName"] = this.serviceModalityName;
        data["levelOfLonelinessName"] = this.levelOfLonelinessName;
        data["sociodemographicEnvironmentName"] = this.sociodemographicEnvironmentName;
        data["causeOfWithdrawalName"] = this.causeOfWithdrawalName;
        data["levelOfSocializationName"] = this.levelOfSocializationName;
        data["municipalityPEVSId"] = this.municipalityPEVSId;
        data["municipalityPEVSName"] = this.municipalityPEVSName;
        data["dateOfFirstVisit"] = this.dateOfFirstVisit ? this.dateOfFirstVisit.toISOString() : <any>undefined;
        data["contractSigningDate"] = this.contractSigningDate ? this.contractSigningDate.toISOString() : <any>undefined;
        data["contractExpirationDate"] = this.contractExpirationDate ? this.contractExpirationDate.toISOString() : <any>undefined;
        data["cohabitantId"] = this.cohabitantId;
        data["cohabitantName"] = this.cohabitantName;
        data["cognitiveDeclineId"] = this.cognitiveDeclineId;
        data["cognitiveDeclineName"] = this.cognitiveDeclineName;
        if (Array.isArray(this.servicePackages)) {
            data["servicePackages"] = [];
            for (let item of this.servicePackages)
                data["servicePackages"].push(item.toJSON());
        }
        return data;
    }
}

export interface IClientDto {
    id?: number | undefined;
    email?: string | undefined;
    identificationNumber: string;
    name: string;
    surnames: string;
    cellPhone?: string | undefined;
    homePhone?: string | undefined;
    countryId?: number | undefined;
    provinceId?: number | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    address?: string | undefined;
    address2?: string | undefined;
    townId?: number | undefined;
    postCodeId?: number | undefined;
    languages?: number[] | undefined;
    contractLogoId?: number | undefined;
    clientTypeId?: number | undefined;
    clientLikes?: number[] | undefined;
    therapeuticalProfiles?: number[] | undefined;
    associatedWorkingCenterId?: number | undefined;
    picture?: ImageAttachment;
    alias?: string | undefined;
    sharepointFolder?: string | undefined;
    supportProfessional?: UserMinDto;
    referenceSocialWorker?: UserMinDto;
    androidDevice?: AndroidDeviceDto;
    communicationDevice?: CommunicationDeviceDto;
    contracts?: ContractDto[] | undefined;
    viewPassword?: boolean;
    age?: number | undefined;
    birthDate?: Date | undefined;
    activeDate?: Date | undefined;
    leavingDate?: Date | undefined;
    inactivityDate?: Date | undefined;
    setupDate?: Date | undefined;
    veraAppVersionDate?: Date | undefined;
    veraAppVersion?: string | undefined;
    genderId?: number | undefined;
    genderIdentity?: string | undefined;
    dependencyDegreeId?: number | undefined;
    technologicalIndependenceId?: number | undefined;
    usesTechHelpId?: number | undefined;
    whichOnesTechHelp?: string | undefined;
    active?: string | undefined;
    clientExternalPartners?: ClientExternalPartnersDto;
    isUsingAerial?: boolean;
    civilStatusId?: number | undefined;
    professionId?: number | undefined;
    mainContractId?: number | undefined;
    levelOfEducationId?: number | undefined;
    typeOfStudiesId?: number | undefined;
    culturalLevelId?: number | undefined;
    serviceModalityId?: number | undefined;
    levelOfLonelinessId?: number | undefined;
    sociodemographicEnvironmentId?: number | undefined;
    causeOfWithdrawalId?: number | undefined;
    levelOfSocializationId?: number | undefined;
    serviceModalityName?: string | undefined;
    levelOfLonelinessName?: string | undefined;
    sociodemographicEnvironmentName?: string | undefined;
    causeOfWithdrawalName?: string | undefined;
    levelOfSocializationName?: string | undefined;
    municipalityPEVSId?: number | undefined;
    municipalityPEVSName?: string | undefined;
    dateOfFirstVisit?: Date | undefined;
    contractSigningDate?: Date | undefined;
    contractExpirationDate?: Date | undefined;
    cohabitantId?: number | undefined;
    cohabitantName?: string | undefined;
    cognitiveDeclineId?: number | undefined;
    cognitiveDeclineName?: string | undefined;
    servicePackages?: ServicePackageDto[] | undefined;
}

export class GroupMetaDto implements IGroupMetaDto {
    residenceFloorsNbr?: number | undefined;
    residentLiveAlone?: boolean | undefined;
    residentHavePet?: boolean | undefined;
    residenceIsEldercareHome?: boolean | undefined;
    residentPetSizeId?: number | undefined;
    residentPetSize?: string | undefined;
    residenceTypeId?: number | undefined;
    residenceType?: string | undefined;
    residentName?: string | undefined;
    analyticsActivityEnabled?: boolean | undefined;
    analyticsSleepEnabled?: boolean | undefined;
    timezone?: string | undefined;
    typicalWakeUpTime?: string | undefined;
    typicalBedTime?: string | undefined;

    constructor(data?: IGroupMetaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.residenceFloorsNbr = _data["residenceFloorsNbr"];
            this.residentLiveAlone = _data["residentLiveAlone"];
            this.residentHavePet = _data["residentHavePet"];
            this.residenceIsEldercareHome = _data["residenceIsEldercareHome"];
            this.residentPetSizeId = _data["residentPetSizeId"];
            this.residentPetSize = _data["residentPetSize"];
            this.residenceTypeId = _data["residenceTypeId"];
            this.residenceType = _data["residenceType"];
            this.residentName = _data["residentName"];
            this.analyticsActivityEnabled = _data["analyticsActivityEnabled"];
            this.analyticsSleepEnabled = _data["analyticsSleepEnabled"];
            this.timezone = _data["timezone"];
            this.typicalWakeUpTime = _data["typicalWakeUpTime"];
            this.typicalBedTime = _data["typicalBedTime"];
        }
    }

    static fromJS(data: any): GroupMetaDto {
        data = typeof data === 'object' ? data : {};
        let result = new GroupMetaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["residenceFloorsNbr"] = this.residenceFloorsNbr;
        data["residentLiveAlone"] = this.residentLiveAlone;
        data["residentHavePet"] = this.residentHavePet;
        data["residenceIsEldercareHome"] = this.residenceIsEldercareHome;
        data["residentPetSizeId"] = this.residentPetSizeId;
        data["residentPetSize"] = this.residentPetSize;
        data["residenceTypeId"] = this.residenceTypeId;
        data["residenceType"] = this.residenceType;
        data["residentName"] = this.residentName;
        data["analyticsActivityEnabled"] = this.analyticsActivityEnabled;
        data["analyticsSleepEnabled"] = this.analyticsSleepEnabled;
        data["timezone"] = this.timezone;
        data["typicalWakeUpTime"] = this.typicalWakeUpTime;
        data["typicalBedTime"] = this.typicalBedTime;
        return data;
    }
}

export interface IGroupMetaDto {
    residenceFloorsNbr?: number | undefined;
    residentLiveAlone?: boolean | undefined;
    residentHavePet?: boolean | undefined;
    residenceIsEldercareHome?: boolean | undefined;
    residentPetSizeId?: number | undefined;
    residentPetSize?: string | undefined;
    residenceTypeId?: number | undefined;
    residenceType?: string | undefined;
    residentName?: string | undefined;
    analyticsActivityEnabled?: boolean | undefined;
    analyticsSleepEnabled?: boolean | undefined;
    timezone?: string | undefined;
    typicalWakeUpTime?: string | undefined;
    typicalBedTime?: string | undefined;
}

export class ThingMetaDto implements IThingMetaDto {
    serial?: string | undefined;
    mac?: string | undefined;
    sensibility?: number;
    floor?: number | undefined;
    locationId?: number | undefined;
    location?: string | undefined;
    locationCustom?: string | undefined;
    name?: string | undefined;
    deviceTypeId?: number | undefined;
    deviceType?: string | undefined;
    timezone?: string | undefined;

    constructor(data?: IThingMetaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serial = _data["serial"];
            this.mac = _data["mac"];
            this.sensibility = _data["sensibility"];
            this.floor = _data["floor"];
            this.locationId = _data["locationId"];
            this.location = _data["location"];
            this.locationCustom = _data["locationCustom"];
            this.name = _data["name"];
            this.deviceTypeId = _data["deviceTypeId"];
            this.deviceType = _data["deviceType"];
            this.timezone = _data["timezone"];
        }
    }

    static fromJS(data: any): ThingMetaDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThingMetaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serial"] = this.serial;
        data["mac"] = this.mac;
        data["sensibility"] = this.sensibility;
        data["floor"] = this.floor;
        data["locationId"] = this.locationId;
        data["location"] = this.location;
        data["locationCustom"] = this.locationCustom;
        data["name"] = this.name;
        data["deviceTypeId"] = this.deviceTypeId;
        data["deviceType"] = this.deviceType;
        data["timezone"] = this.timezone;
        return data;
    }
}

export interface IThingMetaDto {
    serial?: string | undefined;
    mac?: string | undefined;
    sensibility?: number;
    floor?: number | undefined;
    locationId?: number | undefined;
    location?: string | undefined;
    locationCustom?: string | undefined;
    name?: string | undefined;
    deviceTypeId?: number | undefined;
    deviceType?: string | undefined;
    timezone?: string | undefined;
}

export class GroupCreateUpdateDto implements IGroupCreateUpdateDto {
    id?: number;
    clientExternalPartners?: ClientExternalPartnersDto;
    groupMeta?: GroupMetaDto;
    things?: ThingMetaDto[] | undefined;
    clientId?: number | undefined;
    groupId?: string | undefined;

    constructor(data?: IGroupCreateUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.clientExternalPartners = _data["clientExternalPartners"] ? ClientExternalPartnersDto.fromJS(_data["clientExternalPartners"]) : <any>undefined;
            this.groupMeta = _data["groupMeta"] ? GroupMetaDto.fromJS(_data["groupMeta"]) : <any>undefined;
            if (Array.isArray(_data["things"])) {
                this.things = [] as any;
                for (let item of _data["things"])
                    this.things!.push(ThingMetaDto.fromJS(item));
            }
            this.clientId = _data["clientId"];
            this.groupId = _data["groupId"];
        }
    }

    static fromJS(data: any): GroupCreateUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new GroupCreateUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["clientExternalPartners"] = this.clientExternalPartners ? this.clientExternalPartners.toJSON() : <any>undefined;
        data["groupMeta"] = this.groupMeta ? this.groupMeta.toJSON() : <any>undefined;
        if (Array.isArray(this.things)) {
            data["things"] = [];
            for (let item of this.things)
                data["things"].push(item.toJSON());
        }
        data["clientId"] = this.clientId;
        data["groupId"] = this.groupId;
        return data;
    }
}

export interface IGroupCreateUpdateDto {
    id?: number;
    clientExternalPartners?: ClientExternalPartnersDto;
    groupMeta?: GroupMetaDto;
    things?: ThingMetaDto[] | undefined;
    clientId?: number | undefined;
    groupId?: string | undefined;
}

export class ThingStateDto implements IThingStateDto {
    connected?: boolean;
    engineVersion?: string | undefined;
    agentVersion?: string | undefined;
    lastActiveMin?: number;

    constructor(data?: IThingStateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.connected = _data["connected"];
            this.engineVersion = _data["engineVersion"];
            this.agentVersion = _data["agentVersion"];
            this.lastActiveMin = _data["lastActiveMin"];
        }
    }

    static fromJS(data: any): ThingStateDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThingStateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["connected"] = this.connected;
        data["engineVersion"] = this.engineVersion;
        data["agentVersion"] = this.agentVersion;
        data["lastActiveMin"] = this.lastActiveMin;
        return data;
    }
}

export interface IThingStateDto {
    connected?: boolean;
    engineVersion?: string | undefined;
    agentVersion?: string | undefined;
    lastActiveMin?: number;
}

export class ThingDto implements IThingDto {
    serial?: string | undefined;
    tags?: { [key: string]: any; } | undefined;
    state?: ThingStateDto;

    constructor(data?: IThingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serial = _data["serial"];
            if (_data["tags"]) {
                this.tags = {} as any;
                for (let key in _data["tags"]) {
                    if (_data["tags"].hasOwnProperty(key))
                        (<any>this.tags)![key] = _data["tags"][key];
                }
            }
            this.state = _data["state"] ? ThingStateDto.fromJS(_data["state"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ThingDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serial"] = this.serial;
        if (this.tags) {
            data["tags"] = {};
            for (let key in this.tags) {
                if (this.tags.hasOwnProperty(key))
                    (<any>data["tags"])[key] = this.tags[key];
            }
        }
        data["state"] = this.state ? this.state.toJSON() : <any>undefined;
        return data;
    }
}

export interface IThingDto {
    serial?: string | undefined;
    tags?: { [key: string]: any; } | undefined;
    state?: ThingStateDto;
}

export class ThingResponseDto implements IThingResponseDto {
    code?: number;
    type?: string | undefined;
    things?: ThingDto[] | undefined;

    constructor(data?: IThingResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.type = _data["type"];
            if (Array.isArray(_data["things"])) {
                this.things = [] as any;
                for (let item of _data["things"])
                    this.things!.push(ThingDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ThingResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThingResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["type"] = this.type;
        if (Array.isArray(this.things)) {
            data["things"] = [];
            for (let item of this.things)
                data["things"].push(item.toJSON());
        }
        return data;
    }
}

export interface IThingResponseDto {
    code?: number;
    type?: string | undefined;
    things?: ThingDto[] | undefined;
}

export class ClientMacDto implements IClientMacDto {
    mac?: string | undefined;

    constructor(data?: IClientMacDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mac = _data["mac"];
        }
    }

    static fromJS(data: any): ClientMacDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientMacDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mac"] = this.mac;
        return data;
    }
}

export interface IClientMacDto {
    mac?: string | undefined;
}

export class ConnectedClientsResponseDto implements IConnectedClientsResponseDto {
    code?: number;
    type?: string | undefined;
    clients?: ClientMacDto[] | undefined;

    constructor(data?: IConnectedClientsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.type = _data["type"];
            if (Array.isArray(_data["clients"])) {
                this.clients = [] as any;
                for (let item of _data["clients"])
                    this.clients!.push(ClientMacDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ConnectedClientsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConnectedClientsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["type"] = this.type;
        if (Array.isArray(this.clients)) {
            data["clients"] = [];
            for (let item of this.clients)
                data["clients"].push(item.toJSON());
        }
        return data;
    }
}

export interface IConnectedClientsResponseDto {
    code?: number;
    type?: string | undefined;
    clients?: ClientMacDto[] | undefined;
}

export class ClientAffinityQueryDto implements IClientAffinityQueryDto {
    pageNumber?: number;
    pageSize?: number;
    readonly skipElments?: number;
    orderField?: string | undefined;
    orderAsc?: boolean;
    id?: number | undefined;
    clientAId?: number | undefined;
    clientBId?: number | undefined;
    scheduledActivityId?: number | undefined;
    affinityId?: number | undefined;

    constructor(data?: IClientAffinityQueryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            (<any>this).skipElments = _data["skipElments"];
            this.orderField = _data["orderField"];
            this.orderAsc = _data["orderAsc"];
            this.id = _data["id"];
            this.clientAId = _data["clientAId"];
            this.clientBId = _data["clientBId"];
            this.scheduledActivityId = _data["scheduledActivityId"];
            this.affinityId = _data["affinityId"];
        }
    }

    static fromJS(data: any): ClientAffinityQueryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientAffinityQueryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["skipElments"] = this.skipElments;
        data["orderField"] = this.orderField;
        data["orderAsc"] = this.orderAsc;
        data["id"] = this.id;
        data["clientAId"] = this.clientAId;
        data["clientBId"] = this.clientBId;
        data["scheduledActivityId"] = this.scheduledActivityId;
        data["affinityId"] = this.affinityId;
        return data;
    }
}

export interface IClientAffinityQueryDto {
    pageNumber?: number;
    pageSize?: number;
    skipElments?: number;
    orderField?: string | undefined;
    orderAsc?: boolean;
    id?: number | undefined;
    clientAId?: number | undefined;
    clientBId?: number | undefined;
    scheduledActivityId?: number | undefined;
    affinityId?: number | undefined;
}

export class ClientAffinityDto implements IClientAffinityDto {
    id?: number;
    clientAId?: number;
    clientBId?: number;
    scheduledActivityId?: number | undefined;
    affinityId?: number;
    affinityScore?: number;
    creationDate?: Date;
    isDeleted?: boolean;

    constructor(data?: IClientAffinityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.clientAId = _data["clientAId"];
            this.clientBId = _data["clientBId"];
            this.scheduledActivityId = _data["scheduledActivityId"];
            this.affinityId = _data["affinityId"];
            this.affinityScore = _data["affinityScore"];
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): ClientAffinityDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientAffinityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["clientAId"] = this.clientAId;
        data["clientBId"] = this.clientBId;
        data["scheduledActivityId"] = this.scheduledActivityId;
        data["affinityId"] = this.affinityId;
        data["affinityScore"] = this.affinityScore;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface IClientAffinityDto {
    id?: number;
    clientAId?: number;
    clientBId?: number;
    scheduledActivityId?: number | undefined;
    affinityId?: number;
    affinityScore?: number;
    creationDate?: Date;
    isDeleted?: boolean;
}

export class PagedResultDto_1OfOfClientAffinityDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null implements IPagedResultDto_1OfOfClientAffinityDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    elements?: ClientAffinityDto[] | undefined;
    total?: number;
    pageNumber?: number;

    constructor(data?: IPagedResultDto_1OfOfClientAffinityDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["elements"])) {
                this.elements = [] as any;
                for (let item of _data["elements"])
                    this.elements!.push(ClientAffinityDto.fromJS(item));
            }
            this.total = _data["total"];
            this.pageNumber = _data["pageNumber"];
        }
    }

    static fromJS(data: any): PagedResultDto_1OfOfClientAffinityDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDto_1OfOfClientAffinityDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.elements)) {
            data["elements"] = [];
            for (let item of this.elements)
                data["elements"].push(item.toJSON());
        }
        data["total"] = this.total;
        data["pageNumber"] = this.pageNumber;
        return data;
    }
}

export interface IPagedResultDto_1OfOfClientAffinityDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    elements?: ClientAffinityDto[] | undefined;
    total?: number;
    pageNumber?: number;
}

export class CreateUpdateClientAffinityDto implements ICreateUpdateClientAffinityDto {
    scheduledActivityId?: number;
    clientAffinities?: ClientAffinityDto[] | undefined;

    constructor(data?: ICreateUpdateClientAffinityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scheduledActivityId = _data["scheduledActivityId"];
            if (Array.isArray(_data["clientAffinities"])) {
                this.clientAffinities = [] as any;
                for (let item of _data["clientAffinities"])
                    this.clientAffinities!.push(ClientAffinityDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateUpdateClientAffinityDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUpdateClientAffinityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scheduledActivityId"] = this.scheduledActivityId;
        if (Array.isArray(this.clientAffinities)) {
            data["clientAffinities"] = [];
            for (let item of this.clientAffinities)
                data["clientAffinities"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateUpdateClientAffinityDto {
    scheduledActivityId?: number;
    clientAffinities?: ClientAffinityDto[] | undefined;
}

export class AffinityDto implements IAffinityDto {
    id?: number;
    clientAName?: string | undefined;
    clientAId?: number;
    clientBName?: string | undefined;
    clientBId?: number;
    affinityScore?: number;

    constructor(data?: IAffinityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.clientAName = _data["clientAName"];
            this.clientAId = _data["clientAId"];
            this.clientBName = _data["clientBName"];
            this.clientBId = _data["clientBId"];
            this.affinityScore = _data["affinityScore"];
        }
    }

    static fromJS(data: any): AffinityDto {
        data = typeof data === 'object' ? data : {};
        let result = new AffinityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["clientAName"] = this.clientAName;
        data["clientAId"] = this.clientAId;
        data["clientBName"] = this.clientBName;
        data["clientBId"] = this.clientBId;
        data["affinityScore"] = this.affinityScore;
        return data;
    }
}

export interface IAffinityDto {
    id?: number;
    clientAName?: string | undefined;
    clientAId?: number;
    clientBName?: string | undefined;
    clientBId?: number;
    affinityScore?: number;
}

export class AndroidDeviceQueryDto implements IAndroidDeviceQueryDto {
    pageNumber?: number;
    pageSize?: number;
    readonly skipElments?: number;
    orderField?: string | undefined;
    orderAsc?: boolean;
    code?: string | undefined;
    unassigned?: boolean;
    assigned?: boolean;
    isFailed?: boolean | undefined;
    identificationNumber?: string | undefined;
    purchaseDateTo?: Date | undefined;
    purchaseDateFrom?: Date | undefined;
    associatedWorkingCenterId?: number | undefined;

    constructor(data?: IAndroidDeviceQueryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            (<any>this).skipElments = _data["skipElments"];
            this.orderField = _data["orderField"];
            this.orderAsc = _data["orderAsc"];
            this.code = _data["code"];
            this.unassigned = _data["unassigned"];
            this.assigned = _data["assigned"];
            this.isFailed = _data["isFailed"];
            this.identificationNumber = _data["identificationNumber"];
            this.purchaseDateTo = _data["purchaseDateTo"] ? new Date(_data["purchaseDateTo"].toString()) : <any>undefined;
            this.purchaseDateFrom = _data["purchaseDateFrom"] ? new Date(_data["purchaseDateFrom"].toString()) : <any>undefined;
            this.associatedWorkingCenterId = _data["associatedWorkingCenterId"];
        }
    }

    static fromJS(data: any): AndroidDeviceQueryDto {
        data = typeof data === 'object' ? data : {};
        let result = new AndroidDeviceQueryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["skipElments"] = this.skipElments;
        data["orderField"] = this.orderField;
        data["orderAsc"] = this.orderAsc;
        data["code"] = this.code;
        data["unassigned"] = this.unassigned;
        data["assigned"] = this.assigned;
        data["isFailed"] = this.isFailed;
        data["identificationNumber"] = this.identificationNumber;
        data["purchaseDateTo"] = this.purchaseDateTo ? this.purchaseDateTo.toISOString() : <any>undefined;
        data["purchaseDateFrom"] = this.purchaseDateFrom ? this.purchaseDateFrom.toISOString() : <any>undefined;
        data["associatedWorkingCenterId"] = this.associatedWorkingCenterId;
        return data;
    }
}

export interface IAndroidDeviceQueryDto {
    pageNumber?: number;
    pageSize?: number;
    skipElments?: number;
    orderField?: string | undefined;
    orderAsc?: boolean;
    code?: string | undefined;
    unassigned?: boolean;
    assigned?: boolean;
    isFailed?: boolean | undefined;
    identificationNumber?: string | undefined;
    purchaseDateTo?: Date | undefined;
    purchaseDateFrom?: Date | undefined;
    associatedWorkingCenterId?: number | undefined;
}

export class PagedResultDto_1OfOfAndroidDeviceDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null implements IPagedResultDto_1OfOfAndroidDeviceDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    elements?: AndroidDeviceDto[] | undefined;
    total?: number;
    pageNumber?: number;

    constructor(data?: IPagedResultDto_1OfOfAndroidDeviceDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["elements"])) {
                this.elements = [] as any;
                for (let item of _data["elements"])
                    this.elements!.push(AndroidDeviceDto.fromJS(item));
            }
            this.total = _data["total"];
            this.pageNumber = _data["pageNumber"];
        }
    }

    static fromJS(data: any): PagedResultDto_1OfOfAndroidDeviceDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDto_1OfOfAndroidDeviceDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.elements)) {
            data["elements"] = [];
            for (let item of this.elements)
                data["elements"].push(item.toJSON());
        }
        data["total"] = this.total;
        data["pageNumber"] = this.pageNumber;
        return data;
    }
}

export interface IPagedResultDto_1OfOfAndroidDeviceDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    elements?: AndroidDeviceDto[] | undefined;
    total?: number;
    pageNumber?: number;
}

export class CreateUpdateClientDto implements ICreateUpdateClientDto {
    id?: number | undefined;
    email?: string | undefined;
    identificationNumber!: string;
    name!: string;
    surnames!: string;
    cellPhone?: string | undefined;
    homePhone?: string | undefined;
    countryId?: number | undefined;
    provinceId?: number | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    address?: string | undefined;
    address2?: string | undefined;
    townId?: number | undefined;
    postCodeId?: number | undefined;
    languages?: number[] | undefined;
    contractLogoId?: number | undefined;
    clientTypeId?: number | undefined;
    clientLikes?: number[] | undefined;
    therapeuticalProfiles?: number[] | undefined;
    associatedWorkingCenterId?: number | undefined;
    picture?: ImageAttachment;
    alias?: string | undefined;
    isActive?: boolean;
    password?: string | undefined;
    referenceSocialWorkerProfessionalId?: number;
    supportProfessionalId?: number;
    androidDeviceID?: number | undefined;
    communicationDeviceID?: number | undefined;
    contracts?: number[] | undefined;
    birthDate?: Date | undefined;
    activeDate?: Date | undefined;
    leavingDate?: Date | undefined;
    inactivityDate?: Date | undefined;
    setupDate?: Date | undefined;
    genderID?: number | undefined;
    dependencyDegreeID?: number | undefined;
    technologicalIndependenceId?: number | undefined;
    usesTechHelpId?: number | undefined;
    whichOnesTechHelp?: string | undefined;
    ip?: string | undefined;
    admin?: number;
    clientExternalPartnersId?: number | undefined;
    isUsingAerial?: boolean;
    civilStatusID?: number | undefined;
    professionID?: number | undefined;
    mainContractId?: number | undefined;
    levelOfEducationId?: number | undefined;
    typeOfStudiesId?: number | undefined;
    culturalLevelId?: number | undefined;
    serviceModalityId?: number | undefined;
    levelOfLonelinessId?: number | undefined;
    sociodemographicEnvironmentId?: number | undefined;
    causeOfWithdrawalId?: number | undefined;
    levelOfSocializationId?: number | undefined;
    municipalityPEVSId?: number | undefined;
    dateOfFirstVisit?: Date | undefined;
    contractSigningDate?: Date | undefined;
    contractExpirationDate?: Date | undefined;
    cohabitantId?: number | undefined;
    cognitiveDeclineId?: number | undefined;
    servicePackages?: number[] | undefined;

    constructor(data?: ICreateUpdateClientDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
            this.identificationNumber = _data["identificationNumber"];
            this.name = _data["name"];
            this.surnames = _data["surnames"];
            this.cellPhone = _data["cellPhone"];
            this.homePhone = _data["homePhone"];
            this.countryId = _data["countryId"];
            this.provinceId = _data["provinceId"];
            this.city = _data["city"];
            this.postalCode = _data["postalCode"];
            this.address = _data["address"];
            this.address2 = _data["address2"];
            this.townId = _data["townId"];
            this.postCodeId = _data["postCodeId"];
            if (Array.isArray(_data["languages"])) {
                this.languages = [] as any;
                for (let item of _data["languages"])
                    this.languages!.push(item);
            }
            this.contractLogoId = _data["contractLogoId"];
            this.clientTypeId = _data["clientTypeId"];
            if (Array.isArray(_data["clientLikes"])) {
                this.clientLikes = [] as any;
                for (let item of _data["clientLikes"])
                    this.clientLikes!.push(item);
            }
            if (Array.isArray(_data["therapeuticalProfiles"])) {
                this.therapeuticalProfiles = [] as any;
                for (let item of _data["therapeuticalProfiles"])
                    this.therapeuticalProfiles!.push(item);
            }
            this.associatedWorkingCenterId = _data["associatedWorkingCenterId"];
            this.picture = _data["picture"] ? ImageAttachment.fromJS(_data["picture"]) : <any>undefined;
            this.alias = _data["alias"];
            this.isActive = _data["isActive"];
            this.password = _data["password"];
            this.referenceSocialWorkerProfessionalId = _data["referenceSocialWorkerProfessionalId"];
            this.supportProfessionalId = _data["supportProfessionalId"];
            this.androidDeviceID = _data["androidDeviceID"];
            this.communicationDeviceID = _data["communicationDeviceID"];
            if (Array.isArray(_data["contracts"])) {
                this.contracts = [] as any;
                for (let item of _data["contracts"])
                    this.contracts!.push(item);
            }
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.activeDate = _data["activeDate"] ? new Date(_data["activeDate"].toString()) : <any>undefined;
            this.leavingDate = _data["leavingDate"] ? new Date(_data["leavingDate"].toString()) : <any>undefined;
            this.inactivityDate = _data["inactivityDate"] ? new Date(_data["inactivityDate"].toString()) : <any>undefined;
            this.setupDate = _data["setupDate"] ? new Date(_data["setupDate"].toString()) : <any>undefined;
            this.genderID = _data["genderID"];
            this.dependencyDegreeID = _data["dependencyDegreeID"];
            this.technologicalIndependenceId = _data["technologicalIndependenceId"];
            this.usesTechHelpId = _data["usesTechHelpId"];
            this.whichOnesTechHelp = _data["whichOnesTechHelp"];
            this.ip = _data["ip"];
            this.admin = _data["admin"];
            this.clientExternalPartnersId = _data["clientExternalPartnersId"];
            this.isUsingAerial = _data["isUsingAerial"];
            this.civilStatusID = _data["civilStatusID"];
            this.professionID = _data["professionID"];
            this.mainContractId = _data["mainContractId"];
            this.levelOfEducationId = _data["levelOfEducationId"];
            this.typeOfStudiesId = _data["typeOfStudiesId"];
            this.culturalLevelId = _data["culturalLevelId"];
            this.serviceModalityId = _data["serviceModalityId"];
            this.levelOfLonelinessId = _data["levelOfLonelinessId"];
            this.sociodemographicEnvironmentId = _data["sociodemographicEnvironmentId"];
            this.causeOfWithdrawalId = _data["causeOfWithdrawalId"];
            this.levelOfSocializationId = _data["levelOfSocializationId"];
            this.municipalityPEVSId = _data["municipalityPEVSId"];
            this.dateOfFirstVisit = _data["dateOfFirstVisit"] ? new Date(_data["dateOfFirstVisit"].toString()) : <any>undefined;
            this.contractSigningDate = _data["contractSigningDate"] ? new Date(_data["contractSigningDate"].toString()) : <any>undefined;
            this.contractExpirationDate = _data["contractExpirationDate"] ? new Date(_data["contractExpirationDate"].toString()) : <any>undefined;
            this.cohabitantId = _data["cohabitantId"];
            this.cognitiveDeclineId = _data["cognitiveDeclineId"];
            if (Array.isArray(_data["servicePackages"])) {
                this.servicePackages = [] as any;
                for (let item of _data["servicePackages"])
                    this.servicePackages!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateUpdateClientDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUpdateClientDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        data["identificationNumber"] = this.identificationNumber;
        data["name"] = this.name;
        data["surnames"] = this.surnames;
        data["cellPhone"] = this.cellPhone;
        data["homePhone"] = this.homePhone;
        data["countryId"] = this.countryId;
        data["provinceId"] = this.provinceId;
        data["city"] = this.city;
        data["postalCode"] = this.postalCode;
        data["address"] = this.address;
        data["address2"] = this.address2;
        data["townId"] = this.townId;
        data["postCodeId"] = this.postCodeId;
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item);
        }
        data["contractLogoId"] = this.contractLogoId;
        data["clientTypeId"] = this.clientTypeId;
        if (Array.isArray(this.clientLikes)) {
            data["clientLikes"] = [];
            for (let item of this.clientLikes)
                data["clientLikes"].push(item);
        }
        if (Array.isArray(this.therapeuticalProfiles)) {
            data["therapeuticalProfiles"] = [];
            for (let item of this.therapeuticalProfiles)
                data["therapeuticalProfiles"].push(item);
        }
        data["associatedWorkingCenterId"] = this.associatedWorkingCenterId;
        data["picture"] = this.picture ? this.picture.toJSON() : <any>undefined;
        data["alias"] = this.alias;
        data["isActive"] = this.isActive;
        data["password"] = this.password;
        data["referenceSocialWorkerProfessionalId"] = this.referenceSocialWorkerProfessionalId;
        data["supportProfessionalId"] = this.supportProfessionalId;
        data["androidDeviceID"] = this.androidDeviceID;
        data["communicationDeviceID"] = this.communicationDeviceID;
        if (Array.isArray(this.contracts)) {
            data["contracts"] = [];
            for (let item of this.contracts)
                data["contracts"].push(item);
        }
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["activeDate"] = this.activeDate ? this.activeDate.toISOString() : <any>undefined;
        data["leavingDate"] = this.leavingDate ? this.leavingDate.toISOString() : <any>undefined;
        data["inactivityDate"] = this.inactivityDate ? this.inactivityDate.toISOString() : <any>undefined;
        data["setupDate"] = this.setupDate ? this.setupDate.toISOString() : <any>undefined;
        data["genderID"] = this.genderID;
        data["dependencyDegreeID"] = this.dependencyDegreeID;
        data["technologicalIndependenceId"] = this.technologicalIndependenceId;
        data["usesTechHelpId"] = this.usesTechHelpId;
        data["whichOnesTechHelp"] = this.whichOnesTechHelp;
        data["ip"] = this.ip;
        data["admin"] = this.admin;
        data["clientExternalPartnersId"] = this.clientExternalPartnersId;
        data["isUsingAerial"] = this.isUsingAerial;
        data["civilStatusID"] = this.civilStatusID;
        data["professionID"] = this.professionID;
        data["mainContractId"] = this.mainContractId;
        data["levelOfEducationId"] = this.levelOfEducationId;
        data["typeOfStudiesId"] = this.typeOfStudiesId;
        data["culturalLevelId"] = this.culturalLevelId;
        data["serviceModalityId"] = this.serviceModalityId;
        data["levelOfLonelinessId"] = this.levelOfLonelinessId;
        data["sociodemographicEnvironmentId"] = this.sociodemographicEnvironmentId;
        data["causeOfWithdrawalId"] = this.causeOfWithdrawalId;
        data["levelOfSocializationId"] = this.levelOfSocializationId;
        data["municipalityPEVSId"] = this.municipalityPEVSId;
        data["dateOfFirstVisit"] = this.dateOfFirstVisit ? this.dateOfFirstVisit.toISOString() : <any>undefined;
        data["contractSigningDate"] = this.contractSigningDate ? this.contractSigningDate.toISOString() : <any>undefined;
        data["contractExpirationDate"] = this.contractExpirationDate ? this.contractExpirationDate.toISOString() : <any>undefined;
        data["cohabitantId"] = this.cohabitantId;
        data["cognitiveDeclineId"] = this.cognitiveDeclineId;
        if (Array.isArray(this.servicePackages)) {
            data["servicePackages"] = [];
            for (let item of this.servicePackages)
                data["servicePackages"].push(item);
        }
        return data;
    }
}

export interface ICreateUpdateClientDto {
    id?: number | undefined;
    email?: string | undefined;
    identificationNumber: string;
    name: string;
    surnames: string;
    cellPhone?: string | undefined;
    homePhone?: string | undefined;
    countryId?: number | undefined;
    provinceId?: number | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    address?: string | undefined;
    address2?: string | undefined;
    townId?: number | undefined;
    postCodeId?: number | undefined;
    languages?: number[] | undefined;
    contractLogoId?: number | undefined;
    clientTypeId?: number | undefined;
    clientLikes?: number[] | undefined;
    therapeuticalProfiles?: number[] | undefined;
    associatedWorkingCenterId?: number | undefined;
    picture?: ImageAttachment;
    alias?: string | undefined;
    isActive?: boolean;
    password?: string | undefined;
    referenceSocialWorkerProfessionalId?: number;
    supportProfessionalId?: number;
    androidDeviceID?: number | undefined;
    communicationDeviceID?: number | undefined;
    contracts?: number[] | undefined;
    birthDate?: Date | undefined;
    activeDate?: Date | undefined;
    leavingDate?: Date | undefined;
    inactivityDate?: Date | undefined;
    setupDate?: Date | undefined;
    genderID?: number | undefined;
    dependencyDegreeID?: number | undefined;
    technologicalIndependenceId?: number | undefined;
    usesTechHelpId?: number | undefined;
    whichOnesTechHelp?: string | undefined;
    ip?: string | undefined;
    admin?: number;
    clientExternalPartnersId?: number | undefined;
    isUsingAerial?: boolean;
    civilStatusID?: number | undefined;
    professionID?: number | undefined;
    mainContractId?: number | undefined;
    levelOfEducationId?: number | undefined;
    typeOfStudiesId?: number | undefined;
    culturalLevelId?: number | undefined;
    serviceModalityId?: number | undefined;
    levelOfLonelinessId?: number | undefined;
    sociodemographicEnvironmentId?: number | undefined;
    causeOfWithdrawalId?: number | undefined;
    levelOfSocializationId?: number | undefined;
    municipalityPEVSId?: number | undefined;
    dateOfFirstVisit?: Date | undefined;
    contractSigningDate?: Date | undefined;
    contractExpirationDate?: Date | undefined;
    cohabitantId?: number | undefined;
    cognitiveDeclineId?: number | undefined;
    servicePackages?: number[] | undefined;
}

export class SeePasswordDto implements ISeePasswordDto {
    password?: string | undefined;

    constructor(data?: ISeePasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): SeePasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new SeePasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["password"] = this.password;
        return data;
    }
}

export interface ISeePasswordDto {
    password?: string | undefined;
}

export class ClientQueryDto implements IClientQueryDto {
    pageNumber?: number;
    pageSize?: number;
    readonly skipElments?: number;
    orderField?: string | undefined;
    orderAsc?: boolean;
    id?: number | undefined;
    contractMainId?: number | undefined;
    contractId?: number | undefined;
    contractIds?: number[] | undefined;
    contractingAuthorityId?: number | undefined;
    email?: string | undefined;
    identificationNumber?: string | undefined;
    nameINumber?: string | undefined;
    name?: string | undefined;
    cellPhone?: string | undefined;
    homePhone?: string | undefined;
    countryId?: number | undefined;
    provinceId?: number | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    address?: string | undefined;
    languages?: number[] | undefined;
    clientTypeId?: number | undefined;
    clientLikesId?: number[] | undefined;
    referenceSocialWorkerProfessionalId?: number | undefined;
    supportProfessionalId?: number | undefined;
    associatedWorkingCenterId?: number | undefined;
    hasAssociatedInstallation?: boolean | undefined;
    adminId?: number | undefined;
    active?: string | undefined;
    professionalId?: number | undefined;
    includeAssignedId?: number | undefined;
    dependencyDegreeId?: number | undefined;
    therapeuticalProfilesId?: number[] | undefined;
    activeDate?: Date | undefined;
    leavingDate?: Date | undefined;
    isMain?: boolean | undefined;
    notInContract?: boolean;
    isMapperAll?: boolean;

    constructor(data?: IClientQueryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            (<any>this).skipElments = _data["skipElments"];
            this.orderField = _data["orderField"];
            this.orderAsc = _data["orderAsc"];
            this.id = _data["id"];
            this.contractMainId = _data["contractMainId"];
            this.contractId = _data["contractId"];
            if (Array.isArray(_data["contractIds"])) {
                this.contractIds = [] as any;
                for (let item of _data["contractIds"])
                    this.contractIds!.push(item);
            }
            this.contractingAuthorityId = _data["contractingAuthorityId"];
            this.email = _data["email"];
            this.identificationNumber = _data["identificationNumber"];
            this.nameINumber = _data["nameINumber"];
            this.name = _data["name"];
            this.cellPhone = _data["cellPhone"];
            this.homePhone = _data["homePhone"];
            this.countryId = _data["countryId"];
            this.provinceId = _data["provinceId"];
            this.city = _data["city"];
            this.postalCode = _data["postalCode"];
            this.address = _data["address"];
            if (Array.isArray(_data["languages"])) {
                this.languages = [] as any;
                for (let item of _data["languages"])
                    this.languages!.push(item);
            }
            this.clientTypeId = _data["clientTypeId"];
            if (Array.isArray(_data["clientLikesId"])) {
                this.clientLikesId = [] as any;
                for (let item of _data["clientLikesId"])
                    this.clientLikesId!.push(item);
            }
            this.referenceSocialWorkerProfessionalId = _data["referenceSocialWorkerProfessionalId"];
            this.supportProfessionalId = _data["supportProfessionalId"];
            this.associatedWorkingCenterId = _data["associatedWorkingCenterId"];
            this.hasAssociatedInstallation = _data["hasAssociatedInstallation"];
            this.adminId = _data["adminId"];
            this.active = _data["active"];
            this.professionalId = _data["professionalId"];
            this.includeAssignedId = _data["includeAssignedId"];
            this.dependencyDegreeId = _data["dependencyDegreeId"];
            if (Array.isArray(_data["therapeuticalProfilesId"])) {
                this.therapeuticalProfilesId = [] as any;
                for (let item of _data["therapeuticalProfilesId"])
                    this.therapeuticalProfilesId!.push(item);
            }
            this.activeDate = _data["activeDate"] ? new Date(_data["activeDate"].toString()) : <any>undefined;
            this.leavingDate = _data["leavingDate"] ? new Date(_data["leavingDate"].toString()) : <any>undefined;
            this.isMain = _data["isMain"];
            this.notInContract = _data["notInContract"];
            this.isMapperAll = _data["isMapperAll"];
        }
    }

    static fromJS(data: any): ClientQueryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientQueryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["skipElments"] = this.skipElments;
        data["orderField"] = this.orderField;
        data["orderAsc"] = this.orderAsc;
        data["id"] = this.id;
        data["contractMainId"] = this.contractMainId;
        data["contractId"] = this.contractId;
        if (Array.isArray(this.contractIds)) {
            data["contractIds"] = [];
            for (let item of this.contractIds)
                data["contractIds"].push(item);
        }
        data["contractingAuthorityId"] = this.contractingAuthorityId;
        data["email"] = this.email;
        data["identificationNumber"] = this.identificationNumber;
        data["nameINumber"] = this.nameINumber;
        data["name"] = this.name;
        data["cellPhone"] = this.cellPhone;
        data["homePhone"] = this.homePhone;
        data["countryId"] = this.countryId;
        data["provinceId"] = this.provinceId;
        data["city"] = this.city;
        data["postalCode"] = this.postalCode;
        data["address"] = this.address;
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item);
        }
        data["clientTypeId"] = this.clientTypeId;
        if (Array.isArray(this.clientLikesId)) {
            data["clientLikesId"] = [];
            for (let item of this.clientLikesId)
                data["clientLikesId"].push(item);
        }
        data["referenceSocialWorkerProfessionalId"] = this.referenceSocialWorkerProfessionalId;
        data["supportProfessionalId"] = this.supportProfessionalId;
        data["associatedWorkingCenterId"] = this.associatedWorkingCenterId;
        data["hasAssociatedInstallation"] = this.hasAssociatedInstallation;
        data["adminId"] = this.adminId;
        data["active"] = this.active;
        data["professionalId"] = this.professionalId;
        data["includeAssignedId"] = this.includeAssignedId;
        data["dependencyDegreeId"] = this.dependencyDegreeId;
        if (Array.isArray(this.therapeuticalProfilesId)) {
            data["therapeuticalProfilesId"] = [];
            for (let item of this.therapeuticalProfilesId)
                data["therapeuticalProfilesId"].push(item);
        }
        data["activeDate"] = this.activeDate ? this.activeDate.toISOString() : <any>undefined;
        data["leavingDate"] = this.leavingDate ? this.leavingDate.toISOString() : <any>undefined;
        data["isMain"] = this.isMain;
        data["notInContract"] = this.notInContract;
        data["isMapperAll"] = this.isMapperAll;
        return data;
    }
}

export interface IClientQueryDto {
    pageNumber?: number;
    pageSize?: number;
    skipElments?: number;
    orderField?: string | undefined;
    orderAsc?: boolean;
    id?: number | undefined;
    contractMainId?: number | undefined;
    contractId?: number | undefined;
    contractIds?: number[] | undefined;
    contractingAuthorityId?: number | undefined;
    email?: string | undefined;
    identificationNumber?: string | undefined;
    nameINumber?: string | undefined;
    name?: string | undefined;
    cellPhone?: string | undefined;
    homePhone?: string | undefined;
    countryId?: number | undefined;
    provinceId?: number | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    address?: string | undefined;
    languages?: number[] | undefined;
    clientTypeId?: number | undefined;
    clientLikesId?: number[] | undefined;
    referenceSocialWorkerProfessionalId?: number | undefined;
    supportProfessionalId?: number | undefined;
    associatedWorkingCenterId?: number | undefined;
    hasAssociatedInstallation?: boolean | undefined;
    adminId?: number | undefined;
    active?: string | undefined;
    professionalId?: number | undefined;
    includeAssignedId?: number | undefined;
    dependencyDegreeId?: number | undefined;
    therapeuticalProfilesId?: number[] | undefined;
    activeDate?: Date | undefined;
    leavingDate?: Date | undefined;
    isMain?: boolean | undefined;
    notInContract?: boolean;
    isMapperAll?: boolean;
}

export class PagedResultDto_1OfOfClientDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null implements IPagedResultDto_1OfOfClientDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    elements?: ClientDto[] | undefined;
    total?: number;
    pageNumber?: number;

    constructor(data?: IPagedResultDto_1OfOfClientDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["elements"])) {
                this.elements = [] as any;
                for (let item of _data["elements"])
                    this.elements!.push(ClientDto.fromJS(item));
            }
            this.total = _data["total"];
            this.pageNumber = _data["pageNumber"];
        }
    }

    static fromJS(data: any): PagedResultDto_1OfOfClientDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDto_1OfOfClientDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.elements)) {
            data["elements"] = [];
            for (let item of this.elements)
                data["elements"].push(item.toJSON());
        }
        data["total"] = this.total;
        data["pageNumber"] = this.pageNumber;
        return data;
    }
}

export interface IPagedResultDto_1OfOfClientDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    elements?: ClientDto[] | undefined;
    total?: number;
    pageNumber?: number;
}

export class DropdownDto implements IDropdownDto {
    id?: number;
    description?: string | undefined;

    constructor(data?: IDropdownDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): DropdownDto {
        data = typeof data === 'object' ? data : {};
        let result = new DropdownDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        return data;
    }
}

export interface IDropdownDto {
    id?: number;
    description?: string | undefined;
}

export class ClientExternalPartnersQueryDto implements IClientExternalPartnersQueryDto {
    pageNumber?: number;
    pageSize?: number;
    readonly skipElments?: number;
    orderField?: string | undefined;
    orderAsc?: boolean;
    id?: number | undefined;
    anyGroupId?: string | undefined;
    aerialGroupId?: string | undefined;
    hasUserAssigned?: boolean | undefined;
    isInstalled?: boolean | undefined;
    installationDate?: Date | undefined;
    baseportMac?: string | undefined;
    baseportLocation?: number | undefined;
    thing1Mac?: string | undefined;
    serial?: string | undefined;
    clientId?: number | undefined;
    identificationNumber?: string | undefined;
    name?: string | undefined;

    constructor(data?: IClientExternalPartnersQueryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            (<any>this).skipElments = _data["skipElments"];
            this.orderField = _data["orderField"];
            this.orderAsc = _data["orderAsc"];
            this.id = _data["id"];
            this.anyGroupId = _data["anyGroupId"];
            this.aerialGroupId = _data["aerialGroupId"];
            this.hasUserAssigned = _data["hasUserAssigned"];
            this.isInstalled = _data["isInstalled"];
            this.installationDate = _data["installationDate"] ? new Date(_data["installationDate"].toString()) : <any>undefined;
            this.baseportMac = _data["baseportMac"];
            this.baseportLocation = _data["baseportLocation"];
            this.thing1Mac = _data["thing1Mac"];
            this.serial = _data["serial"];
            this.clientId = _data["clientId"];
            this.identificationNumber = _data["identificationNumber"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ClientExternalPartnersQueryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientExternalPartnersQueryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["skipElments"] = this.skipElments;
        data["orderField"] = this.orderField;
        data["orderAsc"] = this.orderAsc;
        data["id"] = this.id;
        data["anyGroupId"] = this.anyGroupId;
        data["aerialGroupId"] = this.aerialGroupId;
        data["hasUserAssigned"] = this.hasUserAssigned;
        data["isInstalled"] = this.isInstalled;
        data["installationDate"] = this.installationDate ? this.installationDate.toISOString() : <any>undefined;
        data["baseportMac"] = this.baseportMac;
        data["baseportLocation"] = this.baseportLocation;
        data["thing1Mac"] = this.thing1Mac;
        data["serial"] = this.serial;
        data["clientId"] = this.clientId;
        data["identificationNumber"] = this.identificationNumber;
        data["name"] = this.name;
        return data;
    }
}

export interface IClientExternalPartnersQueryDto {
    pageNumber?: number;
    pageSize?: number;
    skipElments?: number;
    orderField?: string | undefined;
    orderAsc?: boolean;
    id?: number | undefined;
    anyGroupId?: string | undefined;
    aerialGroupId?: string | undefined;
    hasUserAssigned?: boolean | undefined;
    isInstalled?: boolean | undefined;
    installationDate?: Date | undefined;
    baseportMac?: string | undefined;
    baseportLocation?: number | undefined;
    thing1Mac?: string | undefined;
    serial?: string | undefined;
    clientId?: number | undefined;
    identificationNumber?: string | undefined;
    name?: string | undefined;
}

export class PagedResultDto_1OfOfClientExternalPartnersDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null implements IPagedResultDto_1OfOfClientExternalPartnersDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    elements?: ClientExternalPartnersDto[] | undefined;
    total?: number;
    pageNumber?: number;

    constructor(data?: IPagedResultDto_1OfOfClientExternalPartnersDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["elements"])) {
                this.elements = [] as any;
                for (let item of _data["elements"])
                    this.elements!.push(ClientExternalPartnersDto.fromJS(item));
            }
            this.total = _data["total"];
            this.pageNumber = _data["pageNumber"];
        }
    }

    static fromJS(data: any): PagedResultDto_1OfOfClientExternalPartnersDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDto_1OfOfClientExternalPartnersDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.elements)) {
            data["elements"] = [];
            for (let item of this.elements)
                data["elements"].push(item.toJSON());
        }
        data["total"] = this.total;
        data["pageNumber"] = this.pageNumber;
        return data;
    }
}

export interface IPagedResultDto_1OfOfClientExternalPartnersDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    elements?: ClientExternalPartnersDto[] | undefined;
    total?: number;
    pageNumber?: number;
}

export class CustomCommunicationDeviceDto implements ICustomCommunicationDeviceDto {
    code!: string;
    installationDate?: Date | undefined;
    communicationTypeId?: number | undefined;
    companyPhone?: string | undefined;
    companyContract?: string | undefined;
    contractCode?: string | undefined;
    purchaseDate?: Date | undefined;
    associatedWorkingCenterId?: number | undefined;
    associatedAndroidDeviceId?: number | undefined;
    routerModelId?: number | undefined;
    cameraModelId?: number | undefined;
    routerLineStatusId?: number | undefined;
    id!: number;
    isFailed?: boolean;
    failDetail?: string | undefined;
    relatedUser?: MinClientDto;
    androidDeviceCode?: string | undefined;

    constructor(data?: ICustomCommunicationDeviceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.installationDate = _data["installationDate"] ? new Date(_data["installationDate"].toString()) : <any>undefined;
            this.communicationTypeId = _data["communicationTypeId"];
            this.companyPhone = _data["companyPhone"];
            this.companyContract = _data["companyContract"];
            this.contractCode = _data["contractCode"];
            this.purchaseDate = _data["purchaseDate"] ? new Date(_data["purchaseDate"].toString()) : <any>undefined;
            this.associatedWorkingCenterId = _data["associatedWorkingCenterId"];
            this.associatedAndroidDeviceId = _data["associatedAndroidDeviceId"];
            this.routerModelId = _data["routerModelId"];
            this.cameraModelId = _data["cameraModelId"];
            this.routerLineStatusId = _data["routerLineStatusId"];
            this.id = _data["id"];
            this.isFailed = _data["isFailed"];
            this.failDetail = _data["failDetail"];
            this.relatedUser = _data["relatedUser"] ? MinClientDto.fromJS(_data["relatedUser"]) : <any>undefined;
            this.androidDeviceCode = _data["androidDeviceCode"];
        }
    }

    static fromJS(data: any): CustomCommunicationDeviceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomCommunicationDeviceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["installationDate"] = this.installationDate ? this.installationDate.toISOString() : <any>undefined;
        data["communicationTypeId"] = this.communicationTypeId;
        data["companyPhone"] = this.companyPhone;
        data["companyContract"] = this.companyContract;
        data["contractCode"] = this.contractCode;
        data["purchaseDate"] = this.purchaseDate ? this.purchaseDate.toISOString() : <any>undefined;
        data["associatedWorkingCenterId"] = this.associatedWorkingCenterId;
        data["associatedAndroidDeviceId"] = this.associatedAndroidDeviceId;
        data["routerModelId"] = this.routerModelId;
        data["cameraModelId"] = this.cameraModelId;
        data["routerLineStatusId"] = this.routerLineStatusId;
        data["id"] = this.id;
        data["isFailed"] = this.isFailed;
        data["failDetail"] = this.failDetail;
        data["relatedUser"] = this.relatedUser ? this.relatedUser.toJSON() : <any>undefined;
        data["androidDeviceCode"] = this.androidDeviceCode;
        return data;
    }
}

export interface ICustomCommunicationDeviceDto {
    code: string;
    installationDate?: Date | undefined;
    communicationTypeId?: number | undefined;
    companyPhone?: string | undefined;
    companyContract?: string | undefined;
    contractCode?: string | undefined;
    purchaseDate?: Date | undefined;
    associatedWorkingCenterId?: number | undefined;
    associatedAndroidDeviceId?: number | undefined;
    routerModelId?: number | undefined;
    cameraModelId?: number | undefined;
    routerLineStatusId?: number | undefined;
    id: number;
    isFailed?: boolean;
    failDetail?: string | undefined;
    relatedUser?: MinClientDto;
    androidDeviceCode?: string | undefined;
}

export class CommunicationDeviceQueryDto implements ICommunicationDeviceQueryDto {
    pageNumber?: number;
    pageSize?: number;
    readonly skipElments?: number;
    orderField?: string | undefined;
    orderAsc?: boolean;
    code?: string | undefined;
    unassigned?: boolean;
    assigned?: boolean;
    isFailed?: boolean | undefined;
    isAvailable?: boolean | undefined;
    identificationNumber?: string | undefined;
    purchaseDateTo?: Date | undefined;
    purchaseDateFrom?: Date | undefined;
    associatedWorkingCenterId?: number | undefined;
    communicationDeviceTypeId?: number | undefined;
    communicationDeviceTypeValue?: string | undefined;

    constructor(data?: ICommunicationDeviceQueryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            (<any>this).skipElments = _data["skipElments"];
            this.orderField = _data["orderField"];
            this.orderAsc = _data["orderAsc"];
            this.code = _data["code"];
            this.unassigned = _data["unassigned"];
            this.assigned = _data["assigned"];
            this.isFailed = _data["isFailed"];
            this.isAvailable = _data["isAvailable"];
            this.identificationNumber = _data["identificationNumber"];
            this.purchaseDateTo = _data["purchaseDateTo"] ? new Date(_data["purchaseDateTo"].toString()) : <any>undefined;
            this.purchaseDateFrom = _data["purchaseDateFrom"] ? new Date(_data["purchaseDateFrom"].toString()) : <any>undefined;
            this.associatedWorkingCenterId = _data["associatedWorkingCenterId"];
            this.communicationDeviceTypeId = _data["communicationDeviceTypeId"];
            this.communicationDeviceTypeValue = _data["communicationDeviceTypeValue"];
        }
    }

    static fromJS(data: any): CommunicationDeviceQueryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommunicationDeviceQueryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["skipElments"] = this.skipElments;
        data["orderField"] = this.orderField;
        data["orderAsc"] = this.orderAsc;
        data["code"] = this.code;
        data["unassigned"] = this.unassigned;
        data["assigned"] = this.assigned;
        data["isFailed"] = this.isFailed;
        data["isAvailable"] = this.isAvailable;
        data["identificationNumber"] = this.identificationNumber;
        data["purchaseDateTo"] = this.purchaseDateTo ? this.purchaseDateTo.toISOString() : <any>undefined;
        data["purchaseDateFrom"] = this.purchaseDateFrom ? this.purchaseDateFrom.toISOString() : <any>undefined;
        data["associatedWorkingCenterId"] = this.associatedWorkingCenterId;
        data["communicationDeviceTypeId"] = this.communicationDeviceTypeId;
        data["communicationDeviceTypeValue"] = this.communicationDeviceTypeValue;
        return data;
    }
}

export interface ICommunicationDeviceQueryDto {
    pageNumber?: number;
    pageSize?: number;
    skipElments?: number;
    orderField?: string | undefined;
    orderAsc?: boolean;
    code?: string | undefined;
    unassigned?: boolean;
    assigned?: boolean;
    isFailed?: boolean | undefined;
    isAvailable?: boolean | undefined;
    identificationNumber?: string | undefined;
    purchaseDateTo?: Date | undefined;
    purchaseDateFrom?: Date | undefined;
    associatedWorkingCenterId?: number | undefined;
    communicationDeviceTypeId?: number | undefined;
    communicationDeviceTypeValue?: string | undefined;
}

export class PagedResultDto_1OfOfCommunicationDeviceDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null implements IPagedResultDto_1OfOfCommunicationDeviceDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    elements?: CommunicationDeviceDto[] | undefined;
    total?: number;
    pageNumber?: number;

    constructor(data?: IPagedResultDto_1OfOfCommunicationDeviceDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["elements"])) {
                this.elements = [] as any;
                for (let item of _data["elements"])
                    this.elements!.push(CommunicationDeviceDto.fromJS(item));
            }
            this.total = _data["total"];
            this.pageNumber = _data["pageNumber"];
        }
    }

    static fromJS(data: any): PagedResultDto_1OfOfCommunicationDeviceDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDto_1OfOfCommunicationDeviceDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.elements)) {
            data["elements"] = [];
            for (let item of this.elements)
                data["elements"].push(item.toJSON());
        }
        data["total"] = this.total;
        data["pageNumber"] = this.pageNumber;
        return data;
    }
}

export interface IPagedResultDto_1OfOfCommunicationDeviceDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    elements?: CommunicationDeviceDto[] | undefined;
    total?: number;
    pageNumber?: number;
}

export class RoleDto implements IRoleDto {
    id?: number;
    name?: string | undefined;

    constructor(data?: IRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): RoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IRoleDto {
    id?: number;
    name?: string | undefined;
}

export class CreateContactDto implements ICreateContactDto {
    name?: string | undefined;
    email?: string | undefined;
    identificationNumber?: string | undefined;
    surnames?: string | undefined;
    phone1?: string | undefined;
    phone2?: string | undefined;
    typeId?: number;
    role?: RoleDto;
    canUseAppFamiliares?: boolean;
    contactRelativesIds?: number[] | undefined;
    contactRelatives?: number[] | undefined;
    clientId?: number;

    constructor(data?: ICreateContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.email = _data["email"];
            this.identificationNumber = _data["identificationNumber"];
            this.surnames = _data["surnames"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.typeId = _data["typeId"];
            this.role = _data["role"] ? RoleDto.fromJS(_data["role"]) : <any>undefined;
            this.canUseAppFamiliares = _data["canUseAppFamiliares"];
            if (Array.isArray(_data["contactRelativesIds"])) {
                this.contactRelativesIds = [] as any;
                for (let item of _data["contactRelativesIds"])
                    this.contactRelativesIds!.push(item);
            }
            if (Array.isArray(_data["contactRelatives"])) {
                this.contactRelatives = [] as any;
                for (let item of _data["contactRelatives"])
                    this.contactRelatives!.push(item);
            }
            this.clientId = _data["clientId"];
        }
    }

    static fromJS(data: any): CreateContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["email"] = this.email;
        data["identificationNumber"] = this.identificationNumber;
        data["surnames"] = this.surnames;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["typeId"] = this.typeId;
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        data["canUseAppFamiliares"] = this.canUseAppFamiliares;
        if (Array.isArray(this.contactRelativesIds)) {
            data["contactRelativesIds"] = [];
            for (let item of this.contactRelativesIds)
                data["contactRelativesIds"].push(item);
        }
        if (Array.isArray(this.contactRelatives)) {
            data["contactRelatives"] = [];
            for (let item of this.contactRelatives)
                data["contactRelatives"].push(item);
        }
        data["clientId"] = this.clientId;
        return data;
    }
}

export interface ICreateContactDto {
    name?: string | undefined;
    email?: string | undefined;
    identificationNumber?: string | undefined;
    surnames?: string | undefined;
    phone1?: string | undefined;
    phone2?: string | undefined;
    typeId?: number;
    role?: RoleDto;
    canUseAppFamiliares?: boolean;
    contactRelativesIds?: number[] | undefined;
    contactRelatives?: number[] | undefined;
    clientId?: number;
}

export class ContactDto implements IContactDto {
    name?: string | undefined;
    email?: string | undefined;
    identificationNumber?: string | undefined;
    surnames?: string | undefined;
    phone1?: string | undefined;
    phone2?: string | undefined;
    typeId?: number;
    role?: RoleDto;
    canUseAppFamiliares?: boolean;
    contactRelativesIds?: number[] | undefined;
    contactRelatives?: number[] | undefined;
    id?: number;

    constructor(data?: IContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.email = _data["email"];
            this.identificationNumber = _data["identificationNumber"];
            this.surnames = _data["surnames"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.typeId = _data["typeId"];
            this.role = _data["role"] ? RoleDto.fromJS(_data["role"]) : <any>undefined;
            this.canUseAppFamiliares = _data["canUseAppFamiliares"];
            if (Array.isArray(_data["contactRelativesIds"])) {
                this.contactRelativesIds = [] as any;
                for (let item of _data["contactRelativesIds"])
                    this.contactRelativesIds!.push(item);
            }
            if (Array.isArray(_data["contactRelatives"])) {
                this.contactRelatives = [] as any;
                for (let item of _data["contactRelatives"])
                    this.contactRelatives!.push(item);
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["email"] = this.email;
        data["identificationNumber"] = this.identificationNumber;
        data["surnames"] = this.surnames;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["typeId"] = this.typeId;
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        data["canUseAppFamiliares"] = this.canUseAppFamiliares;
        if (Array.isArray(this.contactRelativesIds)) {
            data["contactRelativesIds"] = [];
            for (let item of this.contactRelativesIds)
                data["contactRelativesIds"].push(item);
        }
        if (Array.isArray(this.contactRelatives)) {
            data["contactRelatives"] = [];
            for (let item of this.contactRelatives)
                data["contactRelatives"].push(item);
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IContactDto {
    name?: string | undefined;
    email?: string | undefined;
    identificationNumber?: string | undefined;
    surnames?: string | undefined;
    phone1?: string | undefined;
    phone2?: string | undefined;
    typeId?: number;
    role?: RoleDto;
    canUseAppFamiliares?: boolean;
    contactRelativesIds?: number[] | undefined;
    contactRelatives?: number[] | undefined;
    id?: number;
}

export class UpdateContactDto implements IUpdateContactDto {
    name?: string | undefined;
    email?: string | undefined;
    identificationNumber?: string | undefined;
    surnames?: string | undefined;
    phone1?: string | undefined;
    phone2?: string | undefined;
    typeId?: number;
    role?: RoleDto;
    canUseAppFamiliares?: boolean;
    contactRelativesIds?: number[] | undefined;
    contactRelatives?: number[] | undefined;
    id?: number;
    userId?: number;

    constructor(data?: IUpdateContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.email = _data["email"];
            this.identificationNumber = _data["identificationNumber"];
            this.surnames = _data["surnames"];
            this.phone1 = _data["phone1"];
            this.phone2 = _data["phone2"];
            this.typeId = _data["typeId"];
            this.role = _data["role"] ? RoleDto.fromJS(_data["role"]) : <any>undefined;
            this.canUseAppFamiliares = _data["canUseAppFamiliares"];
            if (Array.isArray(_data["contactRelativesIds"])) {
                this.contactRelativesIds = [] as any;
                for (let item of _data["contactRelativesIds"])
                    this.contactRelativesIds!.push(item);
            }
            if (Array.isArray(_data["contactRelatives"])) {
                this.contactRelatives = [] as any;
                for (let item of _data["contactRelatives"])
                    this.contactRelatives!.push(item);
            }
            this.id = _data["id"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): UpdateContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["email"] = this.email;
        data["identificationNumber"] = this.identificationNumber;
        data["surnames"] = this.surnames;
        data["phone1"] = this.phone1;
        data["phone2"] = this.phone2;
        data["typeId"] = this.typeId;
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        data["canUseAppFamiliares"] = this.canUseAppFamiliares;
        if (Array.isArray(this.contactRelativesIds)) {
            data["contactRelativesIds"] = [];
            for (let item of this.contactRelativesIds)
                data["contactRelativesIds"].push(item);
        }
        if (Array.isArray(this.contactRelatives)) {
            data["contactRelatives"] = [];
            for (let item of this.contactRelatives)
                data["contactRelatives"].push(item);
        }
        data["id"] = this.id;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IUpdateContactDto {
    name?: string | undefined;
    email?: string | undefined;
    identificationNumber?: string | undefined;
    surnames?: string | undefined;
    phone1?: string | undefined;
    phone2?: string | undefined;
    typeId?: number;
    role?: RoleDto;
    canUseAppFamiliares?: boolean;
    contactRelativesIds?: number[] | undefined;
    contactRelatives?: number[] | undefined;
    id?: number;
    userId?: number;
}

export class CreateUpdateContractDto implements ICreateUpdateContractDto {
    id?: number | undefined;
    contractNumber?: string | undefined;
    initialDate?: Date;
    endDate?: Date | undefined;
    maxClient?: number;
    contractingAuthorityId?: number;
    publicAdministration?: boolean;
    extension?: boolean;
    isParent?: boolean;
    parentContractId?: number | undefined;
    extensionDurationMonths?: number;
    ip?: string | undefined;
    admin?: number;
    description?: string | undefined;

    constructor(data?: ICreateUpdateContractDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.contractNumber = _data["contractNumber"];
            this.initialDate = _data["initialDate"] ? new Date(_data["initialDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.maxClient = _data["maxClient"];
            this.contractingAuthorityId = _data["contractingAuthorityId"];
            this.publicAdministration = _data["publicAdministration"];
            this.extension = _data["extension"];
            this.isParent = _data["isParent"];
            this.parentContractId = _data["parentContractId"];
            this.extensionDurationMonths = _data["extensionDurationMonths"];
            this.ip = _data["ip"];
            this.admin = _data["admin"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): CreateUpdateContractDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUpdateContractDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["contractNumber"] = this.contractNumber;
        data["initialDate"] = this.initialDate ? this.initialDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["maxClient"] = this.maxClient;
        data["contractingAuthorityId"] = this.contractingAuthorityId;
        data["publicAdministration"] = this.publicAdministration;
        data["extension"] = this.extension;
        data["isParent"] = this.isParent;
        data["parentContractId"] = this.parentContractId;
        data["extensionDurationMonths"] = this.extensionDurationMonths;
        data["ip"] = this.ip;
        data["admin"] = this.admin;
        data["description"] = this.description;
        return data;
    }
}

export interface ICreateUpdateContractDto {
    id?: number | undefined;
    contractNumber?: string | undefined;
    initialDate?: Date;
    endDate?: Date | undefined;
    maxClient?: number;
    contractingAuthorityId?: number;
    publicAdministration?: boolean;
    extension?: boolean;
    isParent?: boolean;
    parentContractId?: number | undefined;
    extensionDurationMonths?: number;
    ip?: string | undefined;
    admin?: number;
    description?: string | undefined;
}

export class ContractLogoDto implements IContractLogoDto {
    id?: number;
    contractId?: number;

    constructor(data?: IContractLogoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.contractId = _data["contractId"];
        }
    }

    static fromJS(data: any): ContractLogoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContractLogoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["contractId"] = this.contractId;
        return data;
    }
}

export interface IContractLogoDto {
    id?: number;
    contractId?: number;
}

export class LogoFooterDto implements ILogoFooterDto {
    panelIzquierda?: ContractLogoDto[] | undefined;
    panelDerecha?: ContractLogoDto[] | undefined;
    logoPrimaryText?: string | undefined;
    logoSecondaryText?: string | undefined;
    logoMoreInfoText?: string | undefined;
    contratId?: number;

    constructor(data?: ILogoFooterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["panelIzquierda"])) {
                this.panelIzquierda = [] as any;
                for (let item of _data["panelIzquierda"])
                    this.panelIzquierda!.push(ContractLogoDto.fromJS(item));
            }
            if (Array.isArray(_data["panelDerecha"])) {
                this.panelDerecha = [] as any;
                for (let item of _data["panelDerecha"])
                    this.panelDerecha!.push(ContractLogoDto.fromJS(item));
            }
            this.logoPrimaryText = _data["logoPrimaryText"];
            this.logoSecondaryText = _data["logoSecondaryText"];
            this.logoMoreInfoText = _data["logoMoreInfoText"];
            this.contratId = _data["contratId"];
        }
    }

    static fromJS(data: any): LogoFooterDto {
        data = typeof data === 'object' ? data : {};
        let result = new LogoFooterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.panelIzquierda)) {
            data["panelIzquierda"] = [];
            for (let item of this.panelIzquierda)
                data["panelIzquierda"].push(item.toJSON());
        }
        if (Array.isArray(this.panelDerecha)) {
            data["panelDerecha"] = [];
            for (let item of this.panelDerecha)
                data["panelDerecha"].push(item.toJSON());
        }
        data["logoPrimaryText"] = this.logoPrimaryText;
        data["logoSecondaryText"] = this.logoSecondaryText;
        data["logoMoreInfoText"] = this.logoMoreInfoText;
        data["contratId"] = this.contratId;
        return data;
    }
}

export interface ILogoFooterDto {
    panelIzquierda?: ContractLogoDto[] | undefined;
    panelDerecha?: ContractLogoDto[] | undefined;
    logoPrimaryText?: string | undefined;
    logoSecondaryText?: string | undefined;
    logoMoreInfoText?: string | undefined;
    contratId?: number;
}

export class UserAndProfessionalContractDto implements IUserAndProfessionalContractDto {
    id?: number;
    professionalsId?: number[] | undefined;
    usersId?: number[] | undefined;
    isProfessional?: boolean;

    constructor(data?: IUserAndProfessionalContractDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["professionalsId"])) {
                this.professionalsId = [] as any;
                for (let item of _data["professionalsId"])
                    this.professionalsId!.push(item);
            }
            if (Array.isArray(_data["usersId"])) {
                this.usersId = [] as any;
                for (let item of _data["usersId"])
                    this.usersId!.push(item);
            }
            this.isProfessional = _data["isProfessional"];
        }
    }

    static fromJS(data: any): UserAndProfessionalContractDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserAndProfessionalContractDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.professionalsId)) {
            data["professionalsId"] = [];
            for (let item of this.professionalsId)
                data["professionalsId"].push(item);
        }
        if (Array.isArray(this.usersId)) {
            data["usersId"] = [];
            for (let item of this.usersId)
                data["usersId"].push(item);
        }
        data["isProfessional"] = this.isProfessional;
        return data;
    }
}

export interface IUserAndProfessionalContractDto {
    id?: number;
    professionalsId?: number[] | undefined;
    usersId?: number[] | undefined;
    isProfessional?: boolean;
}

export class ContractQueryDto implements IContractQueryDto {
    pageNumber?: number;
    pageSize?: number;
    readonly skipElments?: number;
    orderField?: string | undefined;
    orderAsc?: boolean;
    id?: number | undefined;
    contractNumber?: string | undefined;
    initialDate?: Date | undefined;
    endDate?: Date | undefined;
    maxClients?: number | undefined;
    contractingAuthorityId?: number | undefined;
    professionalId?: number | undefined;
    professionals?: number[] | undefined;
    contractingAuthority?: number[] | undefined;
    isParent?: string | undefined;
    isExpired?: string | undefined;
    idNotInclude?: number | undefined;
    parentContractId?: number | undefined;
    isValidity?: boolean;
    isPublicAdministration?: string | undefined;
    description?: string | undefined;

    constructor(data?: IContractQueryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            (<any>this).skipElments = _data["skipElments"];
            this.orderField = _data["orderField"];
            this.orderAsc = _data["orderAsc"];
            this.id = _data["id"];
            this.contractNumber = _data["contractNumber"];
            this.initialDate = _data["initialDate"] ? new Date(_data["initialDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.maxClients = _data["maxClients"];
            this.contractingAuthorityId = _data["contractingAuthorityId"];
            this.professionalId = _data["professionalId"];
            if (Array.isArray(_data["professionals"])) {
                this.professionals = [] as any;
                for (let item of _data["professionals"])
                    this.professionals!.push(item);
            }
            if (Array.isArray(_data["contractingAuthority"])) {
                this.contractingAuthority = [] as any;
                for (let item of _data["contractingAuthority"])
                    this.contractingAuthority!.push(item);
            }
            this.isParent = _data["isParent"];
            this.isExpired = _data["isExpired"];
            this.idNotInclude = _data["idNotInclude"];
            this.parentContractId = _data["parentContractId"];
            this.isValidity = _data["isValidity"];
            this.isPublicAdministration = _data["isPublicAdministration"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): ContractQueryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContractQueryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["skipElments"] = this.skipElments;
        data["orderField"] = this.orderField;
        data["orderAsc"] = this.orderAsc;
        data["id"] = this.id;
        data["contractNumber"] = this.contractNumber;
        data["initialDate"] = this.initialDate ? this.initialDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["maxClients"] = this.maxClients;
        data["contractingAuthorityId"] = this.contractingAuthorityId;
        data["professionalId"] = this.professionalId;
        if (Array.isArray(this.professionals)) {
            data["professionals"] = [];
            for (let item of this.professionals)
                data["professionals"].push(item);
        }
        if (Array.isArray(this.contractingAuthority)) {
            data["contractingAuthority"] = [];
            for (let item of this.contractingAuthority)
                data["contractingAuthority"].push(item);
        }
        data["isParent"] = this.isParent;
        data["isExpired"] = this.isExpired;
        data["idNotInclude"] = this.idNotInclude;
        data["parentContractId"] = this.parentContractId;
        data["isValidity"] = this.isValidity;
        data["isPublicAdministration"] = this.isPublicAdministration;
        data["description"] = this.description;
        return data;
    }
}

export interface IContractQueryDto {
    pageNumber?: number;
    pageSize?: number;
    skipElments?: number;
    orderField?: string | undefined;
    orderAsc?: boolean;
    id?: number | undefined;
    contractNumber?: string | undefined;
    initialDate?: Date | undefined;
    endDate?: Date | undefined;
    maxClients?: number | undefined;
    contractingAuthorityId?: number | undefined;
    professionalId?: number | undefined;
    professionals?: number[] | undefined;
    contractingAuthority?: number[] | undefined;
    isParent?: string | undefined;
    isExpired?: string | undefined;
    idNotInclude?: number | undefined;
    parentContractId?: number | undefined;
    isValidity?: boolean;
    isPublicAdministration?: string | undefined;
    description?: string | undefined;
}

export class PagedResultDto_1OfOfContractDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null implements IPagedResultDto_1OfOfContractDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    elements?: ContractDto[] | undefined;
    total?: number;
    pageNumber?: number;

    constructor(data?: IPagedResultDto_1OfOfContractDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["elements"])) {
                this.elements = [] as any;
                for (let item of _data["elements"])
                    this.elements!.push(ContractDto.fromJS(item));
            }
            this.total = _data["total"];
            this.pageNumber = _data["pageNumber"];
        }
    }

    static fromJS(data: any): PagedResultDto_1OfOfContractDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDto_1OfOfContractDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.elements)) {
            data["elements"] = [];
            for (let item of this.elements)
                data["elements"].push(item.toJSON());
        }
        data["total"] = this.total;
        data["pageNumber"] = this.pageNumber;
        return data;
    }
}

export interface IPagedResultDto_1OfOfContractDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    elements?: ContractDto[] | undefined;
    total?: number;
    pageNumber?: number;
}

export class CreateUpdateContractingAuthorityDto implements ICreateUpdateContractingAuthorityDto {
    id?: number | undefined;
    name?: string | undefined;
    type?: string | undefined;
    contracts?: number[] | undefined;
    createTime?: Date;
    isDeleted?: boolean;
    adminId?: number;
    email?: string | undefined;
    ip?: string | undefined;
    admin?: number;

    constructor(data?: ICreateUpdateContractingAuthorityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
            if (Array.isArray(_data["contracts"])) {
                this.contracts = [] as any;
                for (let item of _data["contracts"])
                    this.contracts!.push(item);
            }
            this.createTime = _data["createTime"] ? new Date(_data["createTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.adminId = _data["adminId"];
            this.email = _data["email"];
            this.ip = _data["ip"];
            this.admin = _data["admin"];
        }
    }

    static fromJS(data: any): CreateUpdateContractingAuthorityDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUpdateContractingAuthorityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        if (Array.isArray(this.contracts)) {
            data["contracts"] = [];
            for (let item of this.contracts)
                data["contracts"].push(item);
        }
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["adminId"] = this.adminId;
        data["email"] = this.email;
        data["ip"] = this.ip;
        data["admin"] = this.admin;
        return data;
    }
}

export interface ICreateUpdateContractingAuthorityDto {
    id?: number | undefined;
    name?: string | undefined;
    type?: string | undefined;
    contracts?: number[] | undefined;
    createTime?: Date;
    isDeleted?: boolean;
    adminId?: number;
    email?: string | undefined;
    ip?: string | undefined;
    admin?: number;
}

export class ContractingAuthorityDto implements IContractingAuthorityDto {
    id?: number;
    name?: string | undefined;
    type?: string | undefined;
    createTime?: Date;
    contracts?: ContractDto[] | undefined;
    isDeleted?: boolean;
    adminId?: number | undefined;
    identificationNumber?: string | undefined;
    password?: string | undefined;
    email?: string | undefined;

    constructor(data?: IContractingAuthorityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.createTime = _data["createTime"] ? new Date(_data["createTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["contracts"])) {
                this.contracts = [] as any;
                for (let item of _data["contracts"])
                    this.contracts!.push(ContractDto.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
            this.adminId = _data["adminId"];
            this.identificationNumber = _data["identificationNumber"];
            this.password = _data["password"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): ContractingAuthorityDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContractingAuthorityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        if (Array.isArray(this.contracts)) {
            data["contracts"] = [];
            for (let item of this.contracts)
                data["contracts"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        data["adminId"] = this.adminId;
        data["identificationNumber"] = this.identificationNumber;
        data["password"] = this.password;
        data["email"] = this.email;
        return data;
    }
}

export interface IContractingAuthorityDto {
    id?: number;
    name?: string | undefined;
    type?: string | undefined;
    createTime?: Date;
    contracts?: ContractDto[] | undefined;
    isDeleted?: boolean;
    adminId?: number | undefined;
    identificationNumber?: string | undefined;
    password?: string | undefined;
    email?: string | undefined;
}

export class ContractingAuthorityQueryDto implements IContractingAuthorityQueryDto {
    pageNumber?: number;
    pageSize?: number;
    readonly skipElments?: number;
    orderField?: string | undefined;
    orderAsc?: boolean;
    id?: number | undefined;
    name?: string | undefined;
    type?: string | undefined;
    createTime?: Date | undefined;
    isDeleted?: boolean;
    adminId?: number | undefined;
    contracts?: number[] | undefined;

    constructor(data?: IContractingAuthorityQueryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            (<any>this).skipElments = _data["skipElments"];
            this.orderField = _data["orderField"];
            this.orderAsc = _data["orderAsc"];
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.createTime = _data["createTime"] ? new Date(_data["createTime"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.adminId = _data["adminId"];
            if (Array.isArray(_data["contracts"])) {
                this.contracts = [] as any;
                for (let item of _data["contracts"])
                    this.contracts!.push(item);
            }
        }
    }

    static fromJS(data: any): ContractingAuthorityQueryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContractingAuthorityQueryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["skipElments"] = this.skipElments;
        data["orderField"] = this.orderField;
        data["orderAsc"] = this.orderAsc;
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        data["createTime"] = this.createTime ? this.createTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["adminId"] = this.adminId;
        if (Array.isArray(this.contracts)) {
            data["contracts"] = [];
            for (let item of this.contracts)
                data["contracts"].push(item);
        }
        return data;
    }
}

export interface IContractingAuthorityQueryDto {
    pageNumber?: number;
    pageSize?: number;
    skipElments?: number;
    orderField?: string | undefined;
    orderAsc?: boolean;
    id?: number | undefined;
    name?: string | undefined;
    type?: string | undefined;
    createTime?: Date | undefined;
    isDeleted?: boolean;
    adminId?: number | undefined;
    contracts?: number[] | undefined;
}

export class PagedResultDto_1OfOfContractingAuthorityDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null implements IPagedResultDto_1OfOfContractingAuthorityDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    elements?: ContractingAuthorityDto[] | undefined;
    total?: number;
    pageNumber?: number;

    constructor(data?: IPagedResultDto_1OfOfContractingAuthorityDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["elements"])) {
                this.elements = [] as any;
                for (let item of _data["elements"])
                    this.elements!.push(ContractingAuthorityDto.fromJS(item));
            }
            this.total = _data["total"];
            this.pageNumber = _data["pageNumber"];
        }
    }

    static fromJS(data: any): PagedResultDto_1OfOfContractingAuthorityDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDto_1OfOfContractingAuthorityDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.elements)) {
            data["elements"] = [];
            for (let item of this.elements)
                data["elements"].push(item.toJSON());
        }
        data["total"] = this.total;
        data["pageNumber"] = this.pageNumber;
        return data;
    }
}

export interface IPagedResultDto_1OfOfContractingAuthorityDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    elements?: ContractingAuthorityDto[] | undefined;
    total?: number;
    pageNumber?: number;
}

export enum OhlConstants_TypeDocument {
    Generic = "generic",
    HousingPlan = "housingPlan",
    ContractLogo = "contractLogo",
}

export class DocumentDto implements IDocumentDto {
    name!: string;
    base64!: string;
    identificationNumber!: string;
    typeDocument?: OhlConstants_TypeDocument;

    constructor(data?: IDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.base64 = _data["base64"];
            this.identificationNumber = _data["identificationNumber"];
            this.typeDocument = _data["typeDocument"];
        }
    }

    static fromJS(data: any): DocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["base64"] = this.base64;
        data["identificationNumber"] = this.identificationNumber;
        data["typeDocument"] = this.typeDocument;
        return data;
    }
}

export interface IDocumentDto {
    name: string;
    base64: string;
    identificationNumber: string;
    typeDocument?: OhlConstants_TypeDocument;
}

export enum UserType {
    Usuario = "Usuario",
    Professional = "Professional",
    Social_worker = "Social_worker",
    ContractLogo = "ContractLogo",
}

export class DocumentAWS implements IDocumentAWS {
    id?: number;
    name?: string | undefined;
    identificationNumberUser?: string | undefined;

    constructor(data?: IDocumentAWS) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.identificationNumberUser = _data["identificationNumberUser"];
        }
    }

    static fromJS(data: any): DocumentAWS {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentAWS();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["identificationNumberUser"] = this.identificationNumberUser;
        return data;
    }
}

export interface IDocumentAWS {
    id?: number;
    name?: string | undefined;
    identificationNumberUser?: string | undefined;
}

export class DocumentListDto implements IDocumentListDto {
    documents?: DocumentAWS[] | undefined;

    constructor(data?: IDocumentListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["documents"])) {
                this.documents = [] as any;
                for (let item of _data["documents"])
                    this.documents!.push(DocumentAWS.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DocumentListDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDocumentListDto {
    documents?: DocumentAWS[] | undefined;
}

export class RecordDto implements IRecordDto {
    id?: number;
    name?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    readonly startTime?: string | undefined;
    readonly endTime?: string | undefined;

    constructor(data?: IRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            (<any>this).startTime = _data["startTime"];
            (<any>this).endTime = _data["endTime"];
        }
    }

    static fromJS(data: any): RecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new RecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["startTime"] = this.startTime;
        data["endTime"] = this.endTime;
        return data;
    }
}

export interface IRecordDto {
    id?: number;
    name?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    startTime?: string | undefined;
    endTime?: string | undefined;
}

export class PagedResultDto_1OfOfRecordDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null implements IPagedResultDto_1OfOfRecordDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    elements?: RecordDto[] | undefined;
    total?: number;
    pageNumber?: number;

    constructor(data?: IPagedResultDto_1OfOfRecordDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["elements"])) {
                this.elements = [] as any;
                for (let item of _data["elements"])
                    this.elements!.push(RecordDto.fromJS(item));
            }
            this.total = _data["total"];
            this.pageNumber = _data["pageNumber"];
        }
    }

    static fromJS(data: any): PagedResultDto_1OfOfRecordDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDto_1OfOfRecordDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.elements)) {
            data["elements"] = [];
            for (let item of this.elements)
                data["elements"].push(item.toJSON());
        }
        data["total"] = this.total;
        data["pageNumber"] = this.pageNumber;
        return data;
    }
}

export interface IPagedResultDto_1OfOfRecordDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    elements?: RecordDto[] | undefined;
    total?: number;
    pageNumber?: number;
}

export class UserHistoryDto implements IUserHistoryDto {
    dependencyStatus?: string | undefined;
    familySocialContext?: string | undefined;
    home?: string | undefined;
    diagnosticInterpretation?: string | undefined;
    other?: string | undefined;
    objectives?: string | undefined;
    client?: MinClientDto;

    constructor(data?: IUserHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dependencyStatus = _data["dependencyStatus"];
            this.familySocialContext = _data["familySocialContext"];
            this.home = _data["home"];
            this.diagnosticInterpretation = _data["diagnosticInterpretation"];
            this.other = _data["other"];
            this.objectives = _data["objectives"];
            this.client = _data["client"] ? MinClientDto.fromJS(_data["client"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dependencyStatus"] = this.dependencyStatus;
        data["familySocialContext"] = this.familySocialContext;
        data["home"] = this.home;
        data["diagnosticInterpretation"] = this.diagnosticInterpretation;
        data["other"] = this.other;
        data["objectives"] = this.objectives;
        data["client"] = this.client ? this.client.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUserHistoryDto {
    dependencyStatus?: string | undefined;
    familySocialContext?: string | undefined;
    home?: string | undefined;
    diagnosticInterpretation?: string | undefined;
    other?: string | undefined;
    objectives?: string | undefined;
    client?: MinClientDto;
}

export class UpdateUserHistoryDto implements IUpdateUserHistoryDto {
    dependencyStatus?: string | undefined;
    familySocialContext?: string | undefined;
    home?: string | undefined;
    diagnosticInterpretation?: string | undefined;
    other?: string | undefined;
    objectives?: string | undefined;
    id?: number;
    clientId?: number;

    constructor(data?: IUpdateUserHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dependencyStatus = _data["dependencyStatus"];
            this.familySocialContext = _data["familySocialContext"];
            this.home = _data["home"];
            this.diagnosticInterpretation = _data["diagnosticInterpretation"];
            this.other = _data["other"];
            this.objectives = _data["objectives"];
            this.id = _data["id"];
            this.clientId = _data["clientId"];
        }
    }

    static fromJS(data: any): UpdateUserHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dependencyStatus"] = this.dependencyStatus;
        data["familySocialContext"] = this.familySocialContext;
        data["home"] = this.home;
        data["diagnosticInterpretation"] = this.diagnosticInterpretation;
        data["other"] = this.other;
        data["objectives"] = this.objectives;
        data["id"] = this.id;
        data["clientId"] = this.clientId;
        return data;
    }
}

export interface IUpdateUserHistoryDto {
    dependencyStatus?: string | undefined;
    familySocialContext?: string | undefined;
    home?: string | undefined;
    diagnosticInterpretation?: string | undefined;
    other?: string | undefined;
    objectives?: string | undefined;
    id?: number;
    clientId?: number;
}

export class InteractionsQueryDto implements IInteractionsQueryDto {
    pageNumber?: number;
    pageSize?: number;
    readonly skipElments?: number;
    orderField?: string | undefined;
    orderAsc?: boolean;
    clientId?: number | undefined;
    professionalId?: number | undefined;
    scheduledActivityId?: number | undefined;
    toCreationDate?: Date | undefined;
    fromCreationDate?: Date | undefined;

    constructor(data?: IInteractionsQueryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            (<any>this).skipElments = _data["skipElments"];
            this.orderField = _data["orderField"];
            this.orderAsc = _data["orderAsc"];
            this.clientId = _data["clientId"];
            this.professionalId = _data["professionalId"];
            this.scheduledActivityId = _data["scheduledActivityId"];
            this.toCreationDate = _data["toCreationDate"] ? new Date(_data["toCreationDate"].toString()) : <any>undefined;
            this.fromCreationDate = _data["fromCreationDate"] ? new Date(_data["fromCreationDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): InteractionsQueryDto {
        data = typeof data === 'object' ? data : {};
        let result = new InteractionsQueryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["skipElments"] = this.skipElments;
        data["orderField"] = this.orderField;
        data["orderAsc"] = this.orderAsc;
        data["clientId"] = this.clientId;
        data["professionalId"] = this.professionalId;
        data["scheduledActivityId"] = this.scheduledActivityId;
        data["toCreationDate"] = this.toCreationDate ? this.toCreationDate.toISOString() : <any>undefined;
        data["fromCreationDate"] = this.fromCreationDate ? this.fromCreationDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IInteractionsQueryDto {
    pageNumber?: number;
    pageSize?: number;
    skipElments?: number;
    orderField?: string | undefined;
    orderAsc?: boolean;
    clientId?: number | undefined;
    professionalId?: number | undefined;
    scheduledActivityId?: number | undefined;
    toCreationDate?: Date | undefined;
    fromCreationDate?: Date | undefined;
}

export class InteractionDto implements IInteractionDto {
    comment?: string | undefined;
    technicalComment?: string | undefined;
    commentForRelative?: string | undefined;
    creationDate?: Date;
    mood?: number;
    healthCondition?: number;
    feedbackMark?: number;
    isDeleted?: boolean;
    participation?: string | undefined;
    id?: number;
    client?: UserMinDto;
    professional?: UserMinDto;
    scheduledActivityId?: number | undefined;
    activityId?: number | undefined;
    activityComment?: string | undefined;

    constructor(data?: IInteractionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.comment = _data["comment"];
            this.technicalComment = _data["technicalComment"];
            this.commentForRelative = _data["commentForRelative"];
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : <any>undefined;
            this.mood = _data["mood"];
            this.healthCondition = _data["healthCondition"];
            this.feedbackMark = _data["feedbackMark"];
            this.isDeleted = _data["isDeleted"];
            this.participation = _data["participation"];
            this.id = _data["id"];
            this.client = _data["client"] ? UserMinDto.fromJS(_data["client"]) : <any>undefined;
            this.professional = _data["professional"] ? UserMinDto.fromJS(_data["professional"]) : <any>undefined;
            this.scheduledActivityId = _data["scheduledActivityId"];
            this.activityId = _data["activityId"];
            this.activityComment = _data["activityComment"];
        }
    }

    static fromJS(data: any): InteractionDto {
        data = typeof data === 'object' ? data : {};
        let result = new InteractionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["comment"] = this.comment;
        data["technicalComment"] = this.technicalComment;
        data["commentForRelative"] = this.commentForRelative;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>undefined;
        data["mood"] = this.mood;
        data["healthCondition"] = this.healthCondition;
        data["feedbackMark"] = this.feedbackMark;
        data["isDeleted"] = this.isDeleted;
        data["participation"] = this.participation;
        data["id"] = this.id;
        data["client"] = this.client ? this.client.toJSON() : <any>undefined;
        data["professional"] = this.professional ? this.professional.toJSON() : <any>undefined;
        data["scheduledActivityId"] = this.scheduledActivityId;
        data["activityId"] = this.activityId;
        data["activityComment"] = this.activityComment;
        return data;
    }
}

export interface IInteractionDto {
    comment?: string | undefined;
    technicalComment?: string | undefined;
    commentForRelative?: string | undefined;
    creationDate?: Date;
    mood?: number;
    healthCondition?: number;
    feedbackMark?: number;
    isDeleted?: boolean;
    participation?: string | undefined;
    id?: number;
    client?: UserMinDto;
    professional?: UserMinDto;
    scheduledActivityId?: number | undefined;
    activityId?: number | undefined;
    activityComment?: string | undefined;
}

export class PagedResultDto_1OfOfInteractionDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null implements IPagedResultDto_1OfOfInteractionDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    elements?: InteractionDto[] | undefined;
    total?: number;
    pageNumber?: number;

    constructor(data?: IPagedResultDto_1OfOfInteractionDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["elements"])) {
                this.elements = [] as any;
                for (let item of _data["elements"])
                    this.elements!.push(InteractionDto.fromJS(item));
            }
            this.total = _data["total"];
            this.pageNumber = _data["pageNumber"];
        }
    }

    static fromJS(data: any): PagedResultDto_1OfOfInteractionDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDto_1OfOfInteractionDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.elements)) {
            data["elements"] = [];
            for (let item of this.elements)
                data["elements"].push(item.toJSON());
        }
        data["total"] = this.total;
        data["pageNumber"] = this.pageNumber;
        return data;
    }
}

export interface IPagedResultDto_1OfOfInteractionDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    elements?: InteractionDto[] | undefined;
    total?: number;
    pageNumber?: number;
}

export class CreateInteractionDto implements ICreateInteractionDto {
    comment?: string | undefined;
    technicalComment?: string | undefined;
    commentForRelative?: string | undefined;
    creationDate?: Date;
    mood?: number;
    healthCondition?: number;
    feedbackMark?: number;
    isDeleted?: boolean;
    participation?: string | undefined;
    professionalId?: number;
    clientId?: number;
    scheduledActivityId?: number | undefined;
    isActivityAssociated?: boolean;

    constructor(data?: ICreateInteractionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.comment = _data["comment"];
            this.technicalComment = _data["technicalComment"];
            this.commentForRelative = _data["commentForRelative"];
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : <any>undefined;
            this.mood = _data["mood"];
            this.healthCondition = _data["healthCondition"];
            this.feedbackMark = _data["feedbackMark"];
            this.isDeleted = _data["isDeleted"];
            this.participation = _data["participation"];
            this.professionalId = _data["professionalId"];
            this.clientId = _data["clientId"];
            this.scheduledActivityId = _data["scheduledActivityId"];
            this.isActivityAssociated = _data["isActivityAssociated"];
        }
    }

    static fromJS(data: any): CreateInteractionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateInteractionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["comment"] = this.comment;
        data["technicalComment"] = this.technicalComment;
        data["commentForRelative"] = this.commentForRelative;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>undefined;
        data["mood"] = this.mood;
        data["healthCondition"] = this.healthCondition;
        data["feedbackMark"] = this.feedbackMark;
        data["isDeleted"] = this.isDeleted;
        data["participation"] = this.participation;
        data["professionalId"] = this.professionalId;
        data["clientId"] = this.clientId;
        data["scheduledActivityId"] = this.scheduledActivityId;
        data["isActivityAssociated"] = this.isActivityAssociated;
        return data;
    }
}

export interface ICreateInteractionDto {
    comment?: string | undefined;
    technicalComment?: string | undefined;
    commentForRelative?: string | undefined;
    creationDate?: Date;
    mood?: number;
    healthCondition?: number;
    feedbackMark?: number;
    isDeleted?: boolean;
    participation?: string | undefined;
    professionalId?: number;
    clientId?: number;
    scheduledActivityId?: number | undefined;
    isActivityAssociated?: boolean;
}

export class UpdateInteractionDto implements IUpdateInteractionDto {
    comment?: string | undefined;
    technicalComment?: string | undefined;
    commentForRelative?: string | undefined;
    creationDate?: Date;
    mood?: number;
    healthCondition?: number;
    feedbackMark?: number;
    isDeleted?: boolean;
    participation?: string | undefined;
    professionalId?: number;
    clientId?: number;
    scheduledActivityId?: number | undefined;
    isActivityAssociated?: boolean;
    id?: number;

    constructor(data?: IUpdateInteractionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.comment = _data["comment"];
            this.technicalComment = _data["technicalComment"];
            this.commentForRelative = _data["commentForRelative"];
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : <any>undefined;
            this.mood = _data["mood"];
            this.healthCondition = _data["healthCondition"];
            this.feedbackMark = _data["feedbackMark"];
            this.isDeleted = _data["isDeleted"];
            this.participation = _data["participation"];
            this.professionalId = _data["professionalId"];
            this.clientId = _data["clientId"];
            this.scheduledActivityId = _data["scheduledActivityId"];
            this.isActivityAssociated = _data["isActivityAssociated"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateInteractionDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateInteractionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["comment"] = this.comment;
        data["technicalComment"] = this.technicalComment;
        data["commentForRelative"] = this.commentForRelative;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : <any>undefined;
        data["mood"] = this.mood;
        data["healthCondition"] = this.healthCondition;
        data["feedbackMark"] = this.feedbackMark;
        data["isDeleted"] = this.isDeleted;
        data["participation"] = this.participation;
        data["professionalId"] = this.professionalId;
        data["clientId"] = this.clientId;
        data["scheduledActivityId"] = this.scheduledActivityId;
        data["isActivityAssociated"] = this.isActivityAssociated;
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateInteractionDto {
    comment?: string | undefined;
    technicalComment?: string | undefined;
    commentForRelative?: string | undefined;
    creationDate?: Date;
    mood?: number;
    healthCondition?: number;
    feedbackMark?: number;
    isDeleted?: boolean;
    participation?: string | undefined;
    professionalId?: number;
    clientId?: number;
    scheduledActivityId?: number | undefined;
    isActivityAssociated?: boolean;
    id?: number;
}

export class JitsiRoom implements IJitsiRoom {
    room?: string | undefined;
    token?: string | undefined;

    constructor(data?: IJitsiRoom) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.room = _data["room"];
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): JitsiRoom {
        data = typeof data === 'object' ? data : {};
        let result = new JitsiRoom();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["room"] = this.room;
        data["token"] = this.token;
        return data;
    }
}

export interface IJitsiRoom {
    room?: string | undefined;
    token?: string | undefined;
}

export class ScheduledActivityDto implements IScheduledActivityDto {
    id?: number;
    startDate?: Date;
    endDate?: Date;
    jitsiRoom?: string | undefined;
    professional?: UserMinDto;
    activity?: ActivityDto;
    comments?: string | undefined;
    description?: string | undefined;
    isHeld?: boolean;
    isCancel?: boolean;
    hasUserConnected?: boolean;
    cancelDescription?: string | undefined;
    interactions?: InteractionDto[] | undefined;
    clientAffinities?: ClientAffinityDto[] | undefined;
    stateId?: number;
    reasonForCancellationId?: number | undefined;
    participants?: UserMinDto[] | undefined;
    realStartDate?: Date | undefined;
    realEndDate?: Date | undefined;
    isDeleted?: boolean;
    stateName?: string | undefined;

    constructor(data?: IScheduledActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.jitsiRoom = _data["jitsiRoom"];
            this.professional = _data["professional"] ? UserMinDto.fromJS(_data["professional"]) : <any>undefined;
            this.activity = _data["activity"] ? ActivityDto.fromJS(_data["activity"]) : <any>undefined;
            this.comments = _data["comments"];
            this.description = _data["description"];
            this.isHeld = _data["isHeld"];
            this.isCancel = _data["isCancel"];
            this.hasUserConnected = _data["hasUserConnected"];
            this.cancelDescription = _data["cancelDescription"];
            if (Array.isArray(_data["interactions"])) {
                this.interactions = [] as any;
                for (let item of _data["interactions"])
                    this.interactions!.push(InteractionDto.fromJS(item));
            }
            if (Array.isArray(_data["clientAffinities"])) {
                this.clientAffinities = [] as any;
                for (let item of _data["clientAffinities"])
                    this.clientAffinities!.push(ClientAffinityDto.fromJS(item));
            }
            this.stateId = _data["stateId"];
            this.reasonForCancellationId = _data["reasonForCancellationId"];
            if (Array.isArray(_data["participants"])) {
                this.participants = [] as any;
                for (let item of _data["participants"])
                    this.participants!.push(UserMinDto.fromJS(item));
            }
            this.realStartDate = _data["realStartDate"] ? new Date(_data["realStartDate"].toString()) : <any>undefined;
            this.realEndDate = _data["realEndDate"] ? new Date(_data["realEndDate"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.stateName = _data["stateName"];
        }
    }

    static fromJS(data: any): ScheduledActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduledActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["jitsiRoom"] = this.jitsiRoom;
        data["professional"] = this.professional ? this.professional.toJSON() : <any>undefined;
        data["activity"] = this.activity ? this.activity.toJSON() : <any>undefined;
        data["comments"] = this.comments;
        data["description"] = this.description;
        data["isHeld"] = this.isHeld;
        data["isCancel"] = this.isCancel;
        data["hasUserConnected"] = this.hasUserConnected;
        data["cancelDescription"] = this.cancelDescription;
        if (Array.isArray(this.interactions)) {
            data["interactions"] = [];
            for (let item of this.interactions)
                data["interactions"].push(item.toJSON());
        }
        if (Array.isArray(this.clientAffinities)) {
            data["clientAffinities"] = [];
            for (let item of this.clientAffinities)
                data["clientAffinities"].push(item.toJSON());
        }
        data["stateId"] = this.stateId;
        data["reasonForCancellationId"] = this.reasonForCancellationId;
        if (Array.isArray(this.participants)) {
            data["participants"] = [];
            for (let item of this.participants)
                data["participants"].push(item.toJSON());
        }
        data["realStartDate"] = this.realStartDate ? this.realStartDate.toISOString() : <any>undefined;
        data["realEndDate"] = this.realEndDate ? this.realEndDate.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["stateName"] = this.stateName;
        return data;
    }
}

export interface IScheduledActivityDto {
    id?: number;
    startDate?: Date;
    endDate?: Date;
    jitsiRoom?: string | undefined;
    professional?: UserMinDto;
    activity?: ActivityDto;
    comments?: string | undefined;
    description?: string | undefined;
    isHeld?: boolean;
    isCancel?: boolean;
    hasUserConnected?: boolean;
    cancelDescription?: string | undefined;
    interactions?: InteractionDto[] | undefined;
    clientAffinities?: ClientAffinityDto[] | undefined;
    stateId?: number;
    reasonForCancellationId?: number | undefined;
    participants?: UserMinDto[] | undefined;
    realStartDate?: Date | undefined;
    realEndDate?: Date | undefined;
    isDeleted?: boolean;
    stateName?: string | undefined;
}

export class LoginRequestDto implements ILoginRequestDto {
    identificationNumber?: string | undefined;
    password?: string | undefined;
    token?: string | undefined;
    veraAppVersion?: string | undefined;

    constructor(data?: ILoginRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identificationNumber = _data["identificationNumber"];
            this.password = _data["password"];
            this.token = _data["token"];
            this.veraAppVersion = _data["veraAppVersion"];
        }
    }

    static fromJS(data: any): LoginRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new LoginRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identificationNumber"] = this.identificationNumber;
        data["password"] = this.password;
        data["token"] = this.token;
        data["veraAppVersion"] = this.veraAppVersion;
        return data;
    }
}

export interface ILoginRequestDto {
    identificationNumber?: string | undefined;
    password?: string | undefined;
    token?: string | undefined;
    veraAppVersion?: string | undefined;
}

export class AuthenticateResultDto implements IAuthenticateResultDto {
    accessToken?: string | undefined;
    firstLogin?: boolean;
    reason?: string | undefined;

    constructor(data?: IAuthenticateResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.firstLogin = _data["firstLogin"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): AuthenticateResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["firstLogin"] = this.firstLogin;
        data["reason"] = this.reason;
        return data;
    }
}

export interface IAuthenticateResultDto {
    accessToken?: string | undefined;
    firstLogin?: boolean;
    reason?: string | undefined;
}

export class ChangeDefaultPasswordDto implements IChangeDefaultPasswordDto {
    id?: number;
    oldPassword?: string | undefined;
    newPassword?: string | undefined;
    repeatNewPassword?: string | undefined;

    constructor(data?: IChangeDefaultPasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.oldPassword = _data["oldPassword"];
            this.newPassword = _data["newPassword"];
            this.repeatNewPassword = _data["repeatNewPassword"];
        }
    }

    static fromJS(data: any): ChangeDefaultPasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeDefaultPasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["oldPassword"] = this.oldPassword;
        data["newPassword"] = this.newPassword;
        data["repeatNewPassword"] = this.repeatNewPassword;
        return data;
    }
}

export interface IChangeDefaultPasswordDto {
    id?: number;
    oldPassword?: string | undefined;
    newPassword?: string | undefined;
    repeatNewPassword?: string | undefined;
}

export class ForgotPasswordDto implements IForgotPasswordDto {
    email?: string | undefined;
    telefono?: string | undefined;

    constructor(data?: IForgotPasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.telefono = _data["telefono"];
        }
    }

    static fromJS(data: any): ForgotPasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ForgotPasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["telefono"] = this.telefono;
        return data;
    }
}

export interface IForgotPasswordDto {
    email?: string | undefined;
    telefono?: string | undefined;
}

export class CurrentUserDto2 implements ICurrentUserDto2 {
    userId?: number;
    relatedUsers?: number[] | undefined;
    professionalId?: number | undefined;
    email?: string | undefined;
    identificationNumber?: string | undefined;
    name?: string | undefined;
    alias?: string | undefined;
    cellPhone?: string | undefined;
    homePhone?: string | undefined;
    country?: string | undefined;
    province?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    address?: string | undefined;
    address2?: string | undefined;
    defaultLanguage?: string | undefined;
    clientType?: string | undefined;
    likes?: string | undefined;
    sharepointFolder?: string | undefined;
    languages?: string[] | undefined;
    contractLogoId?: number | undefined;
    type?: string | undefined;
    workingCenter?: string | undefined;
    roles?: string | undefined;
    professionalValue?: string | undefined;
    userType?: string | undefined;

    constructor(data?: ICurrentUserDto2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            if (Array.isArray(_data["relatedUsers"])) {
                this.relatedUsers = [] as any;
                for (let item of _data["relatedUsers"])
                    this.relatedUsers!.push(item);
            }
            this.professionalId = _data["professionalId"];
            this.email = _data["email"];
            this.identificationNumber = _data["identificationNumber"];
            this.name = _data["name"];
            this.alias = _data["alias"];
            this.cellPhone = _data["cellPhone"];
            this.homePhone = _data["homePhone"];
            this.country = _data["country"];
            this.province = _data["province"];
            this.city = _data["city"];
            this.postalCode = _data["postalCode"];
            this.address = _data["address"];
            this.address2 = _data["address2"];
            this.defaultLanguage = _data["defaultLanguage"];
            this.clientType = _data["clientType"];
            this.likes = _data["likes"];
            this.sharepointFolder = _data["sharepointFolder"];
            if (Array.isArray(_data["languages"])) {
                this.languages = [] as any;
                for (let item of _data["languages"])
                    this.languages!.push(item);
            }
            this.contractLogoId = _data["contractLogoId"];
            this.type = _data["type"];
            this.workingCenter = _data["workingCenter"];
            this.roles = _data["roles"];
            this.professionalValue = _data["professionalValue"];
            this.userType = _data["userType"];
        }
    }

    static fromJS(data: any): CurrentUserDto2 {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentUserDto2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        if (Array.isArray(this.relatedUsers)) {
            data["relatedUsers"] = [];
            for (let item of this.relatedUsers)
                data["relatedUsers"].push(item);
        }
        data["professionalId"] = this.professionalId;
        data["email"] = this.email;
        data["identificationNumber"] = this.identificationNumber;
        data["name"] = this.name;
        data["alias"] = this.alias;
        data["cellPhone"] = this.cellPhone;
        data["homePhone"] = this.homePhone;
        data["country"] = this.country;
        data["province"] = this.province;
        data["city"] = this.city;
        data["postalCode"] = this.postalCode;
        data["address"] = this.address;
        data["address2"] = this.address2;
        data["defaultLanguage"] = this.defaultLanguage;
        data["clientType"] = this.clientType;
        data["likes"] = this.likes;
        data["sharepointFolder"] = this.sharepointFolder;
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item);
        }
        data["contractLogoId"] = this.contractLogoId;
        data["type"] = this.type;
        data["workingCenter"] = this.workingCenter;
        data["roles"] = this.roles;
        data["professionalValue"] = this.professionalValue;
        data["userType"] = this.userType;
        return data;
    }
}

export interface ICurrentUserDto2 {
    userId?: number;
    relatedUsers?: number[] | undefined;
    professionalId?: number | undefined;
    email?: string | undefined;
    identificationNumber?: string | undefined;
    name?: string | undefined;
    alias?: string | undefined;
    cellPhone?: string | undefined;
    homePhone?: string | undefined;
    country?: string | undefined;
    province?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    address?: string | undefined;
    address2?: string | undefined;
    defaultLanguage?: string | undefined;
    clientType?: string | undefined;
    likes?: string | undefined;
    sharepointFolder?: string | undefined;
    languages?: string[] | undefined;
    contractLogoId?: number | undefined;
    type?: string | undefined;
    workingCenter?: string | undefined;
    roles?: string | undefined;
    professionalValue?: string | undefined;
    userType?: string | undefined;
}

export class LogsDto implements ILogsDto {
    name?: string | undefined;
    log?: string | undefined;

    constructor(data?: ILogsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.log = _data["log"];
        }
    }

    static fromJS(data: any): LogsDto {
        data = typeof data === 'object' ? data : {};
        let result = new LogsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["log"] = this.log;
        return data;
    }
}

export interface ILogsDto {
    name?: string | undefined;
    log?: string | undefined;
}

export class MasterTableQueryDto implements IMasterTableQueryDto {
    type?: string | undefined;
    subType?: string | undefined;

    constructor(data?: IMasterTableQueryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.subType = _data["subType"];
        }
    }

    static fromJS(data: any): MasterTableQueryDto {
        data = typeof data === 'object' ? data : {};
        let result = new MasterTableQueryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["subType"] = this.subType;
        return data;
    }
}

export interface IMasterTableQueryDto {
    type?: string | undefined;
    subType?: string | undefined;
}

export class MasterTableListQueryDto implements IMasterTableListQueryDto {
    querys?: MasterTableQueryDto[] | undefined;

    constructor(data?: IMasterTableListQueryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["querys"])) {
                this.querys = [] as any;
                for (let item of _data["querys"])
                    this.querys!.push(MasterTableQueryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MasterTableListQueryDto {
        data = typeof data === 'object' ? data : {};
        let result = new MasterTableListQueryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.querys)) {
            data["querys"] = [];
            for (let item of this.querys)
                data["querys"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMasterTableListQueryDto {
    querys?: MasterTableQueryDto[] | undefined;
}

export class MasterTableDto implements IMasterTableDto {
    id?: number;
    type?: string | undefined;
    subType?: string | undefined;
    code?: string | undefined;
    value?: string | undefined;
    order?: number;

    constructor(data?: IMasterTableDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.subType = _data["subType"];
            this.code = _data["code"];
            this.value = _data["value"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): MasterTableDto {
        data = typeof data === 'object' ? data : {};
        let result = new MasterTableDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["subType"] = this.subType;
        data["code"] = this.code;
        data["value"] = this.value;
        data["order"] = this.order;
        return data;
    }
}

export interface IMasterTableDto {
    id?: number;
    type?: string | undefined;
    subType?: string | undefined;
    code?: string | undefined;
    value?: string | undefined;
    order?: number;
}

export class MasterTableResult implements IMasterTableResult {
    type?: string | undefined;
    elements?: MasterTableDto[] | undefined;

    constructor(data?: IMasterTableResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            if (Array.isArray(_data["elements"])) {
                this.elements = [] as any;
                for (let item of _data["elements"])
                    this.elements!.push(MasterTableDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MasterTableResult {
        data = typeof data === 'object' ? data : {};
        let result = new MasterTableResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        if (Array.isArray(this.elements)) {
            data["elements"] = [];
            for (let item of this.elements)
                data["elements"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMasterTableResult {
    type?: string | undefined;
    elements?: MasterTableDto[] | undefined;
}

export class MasterTableListResult implements IMasterTableListResult {
    elements?: MasterTableResult[] | undefined;

    constructor(data?: IMasterTableListResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["elements"])) {
                this.elements = [] as any;
                for (let item of _data["elements"])
                    this.elements!.push(MasterTableResult.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MasterTableListResult {
        data = typeof data === 'object' ? data : {};
        let result = new MasterTableListResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.elements)) {
            data["elements"] = [];
            for (let item of this.elements)
                data["elements"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMasterTableListResult {
    elements?: MasterTableResult[] | undefined;
}

export enum OhlConstants_MastertableType {
    Clientlikes = "clientlikes",
    Physicalcognitivestatus = "physicalcognitivestatus",
    Physicalstatus = "physicalstatus",
    Workingcenter = "workingcenter",
    ActivitytypeValue = "activitytypeValue",
    Activitytype = "activitytype",
    Contacttype = "contacttype",
    Gender = "gender",
    DependencyDegree = "dependencyDegree",
    TherapeuticProfile = "therapeuticProfile",
    TechnologicalIndependence = "technologicalIndependence",
    UsesTechHelp = "usesTechHelp",
    AerialLocation = "aerialLocation",
    AerialDeviceType = "aerialDeviceType",
    AerialResidentPetSize = "aerialResidentPetSize",
    AerialResidenceType = "aerialResidenceType",
    ClientCivilStatus = "clientCivilStatus",
    ClientProfession = "clientProfession",
    CommunicationDevicesPlugModel = "communicationDevicesPlugModel",
    CommunicationDevicesBaseportModel = "communicationDevicesBaseportModel",
    CommunicationDevicesFirmwareModel = "communicationDevicesFirmwareModel",
    CommunicationDevicesTvboxModel = "communicationDevicesTvboxModel",
    CommunicationDevicesCameraModel = "communicationDevicesCameraModel",
    CommunicationDevicesRouterModel = "communicationDevicesRouterModel",
    ClientLevelOfEducation = "clientLevelOfEducation",
    ClientTypeOfStudies = "clientTypeOfStudies",
    ClientCulturalLevel = "clientCulturalLevel",
    Configurationtype = "configurationtype",
    ConfigurationtypeValue = "configurationtypeValue",
    ClientServiceModality = "clientServiceModality",
    ClientSociodemographicEnvironment = "clientSociodemographicEnvironment",
    ClientLevelOfLoneliness = "clientLevelOfLoneliness",
    ClientLevelOfSocialization = "clientLevelOfSocialization",
    ClientCauseOfWithdrawal = "clientCauseOfWithdrawal",
    ScheduledActivityReasonForCancellation = "scheduledActivityReasonForCancellation",
    ClientMunicipalityPEVS = "clientMunicipalityPEVS",
    ClientCohabitant = "clientCohabitant",
    ClientCognitiveDecline = "clientCognitiveDecline",
    ServicePackagesServiceType = "servicePackagesServiceType",
}

export class CreateOrUpdateMasterTable implements ICreateOrUpdateMasterTable {
    id?: number | undefined;
    type?: OhlConstants_MastertableType;
    subType?: string | undefined;
    code?: string | undefined;
    value?: string | undefined;

    constructor(data?: ICreateOrUpdateMasterTable) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.subType = _data["subType"];
            this.code = _data["code"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): CreateOrUpdateMasterTable {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateMasterTable();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["subType"] = this.subType;
        data["code"] = this.code;
        data["value"] = this.value;
        return data;
    }
}

export interface ICreateOrUpdateMasterTable {
    id?: number | undefined;
    type?: OhlConstants_MastertableType;
    subType?: string | undefined;
    code?: string | undefined;
    value?: string | undefined;
}

export class ScaleObjectiveQueryDto implements IScaleObjectiveQueryDto {
    pageNumber?: number;
    pageSize?: number;
    readonly skipElments?: number;
    orderField?: string | undefined;
    orderAsc?: boolean;
    id?: number | undefined;
    areaId?: number | undefined;
    objectiveStatusId?: number | undefined;
    clientId?: number | undefined;
    areaName?: string | undefined;
    clientName?: string | undefined;
    contractName?: string | undefined;
    createdDate?: Date | undefined;
    targetDate?: Date | undefined;

    constructor(data?: IScaleObjectiveQueryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            (<any>this).skipElments = _data["skipElments"];
            this.orderField = _data["orderField"];
            this.orderAsc = _data["orderAsc"];
            this.id = _data["id"];
            this.areaId = _data["areaId"];
            this.objectiveStatusId = _data["objectiveStatusId"];
            this.clientId = _data["clientId"];
            this.areaName = _data["areaName"];
            this.clientName = _data["clientName"];
            this.contractName = _data["contractName"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.targetDate = _data["targetDate"] ? new Date(_data["targetDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ScaleObjectiveQueryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScaleObjectiveQueryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["skipElments"] = this.skipElments;
        data["orderField"] = this.orderField;
        data["orderAsc"] = this.orderAsc;
        data["id"] = this.id;
        data["areaId"] = this.areaId;
        data["objectiveStatusId"] = this.objectiveStatusId;
        data["clientId"] = this.clientId;
        data["areaName"] = this.areaName;
        data["clientName"] = this.clientName;
        data["contractName"] = this.contractName;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["targetDate"] = this.targetDate ? this.targetDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IScaleObjectiveQueryDto {
    pageNumber?: number;
    pageSize?: number;
    skipElments?: number;
    orderField?: string | undefined;
    orderAsc?: boolean;
    id?: number | undefined;
    areaId?: number | undefined;
    objectiveStatusId?: number | undefined;
    clientId?: number | undefined;
    areaName?: string | undefined;
    clientName?: string | undefined;
    contractName?: string | undefined;
    createdDate?: Date | undefined;
    targetDate?: Date | undefined;
}

export class ScaleObjectiveDto implements IScaleObjectiveDto {
    id?: number;
    objective?: string | undefined;
    description?: string | undefined;
    areaId?: number;
    areaName?: string | undefined;
    objectiveStatusId?: number;
    objectiveStatusName?: string | undefined;
    clientId?: number;
    clientName?: string | undefined;
    contractName?: string | undefined;
    createdDate?: Date;
    targetDate?: Date | undefined;
    isDeleted?: boolean;

    constructor(data?: IScaleObjectiveDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.objective = _data["objective"];
            this.description = _data["description"];
            this.areaId = _data["areaId"];
            this.areaName = _data["areaName"];
            this.objectiveStatusId = _data["objectiveStatusId"];
            this.objectiveStatusName = _data["objectiveStatusName"];
            this.clientId = _data["clientId"];
            this.clientName = _data["clientName"];
            this.contractName = _data["contractName"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.targetDate = _data["targetDate"] ? new Date(_data["targetDate"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): ScaleObjectiveDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScaleObjectiveDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["objective"] = this.objective;
        data["description"] = this.description;
        data["areaId"] = this.areaId;
        data["areaName"] = this.areaName;
        data["objectiveStatusId"] = this.objectiveStatusId;
        data["objectiveStatusName"] = this.objectiveStatusName;
        data["clientId"] = this.clientId;
        data["clientName"] = this.clientName;
        data["contractName"] = this.contractName;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["targetDate"] = this.targetDate ? this.targetDate.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface IScaleObjectiveDto {
    id?: number;
    objective?: string | undefined;
    description?: string | undefined;
    areaId?: number;
    areaName?: string | undefined;
    objectiveStatusId?: number;
    objectiveStatusName?: string | undefined;
    clientId?: number;
    clientName?: string | undefined;
    contractName?: string | undefined;
    createdDate?: Date;
    targetDate?: Date | undefined;
    isDeleted?: boolean;
}

export class PagedResultDto_1OfOfScaleObjectiveDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null implements IPagedResultDto_1OfOfScaleObjectiveDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    elements?: ScaleObjectiveDto[] | undefined;
    total?: number;
    pageNumber?: number;

    constructor(data?: IPagedResultDto_1OfOfScaleObjectiveDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["elements"])) {
                this.elements = [] as any;
                for (let item of _data["elements"])
                    this.elements!.push(ScaleObjectiveDto.fromJS(item));
            }
            this.total = _data["total"];
            this.pageNumber = _data["pageNumber"];
        }
    }

    static fromJS(data: any): PagedResultDto_1OfOfScaleObjectiveDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDto_1OfOfScaleObjectiveDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.elements)) {
            data["elements"] = [];
            for (let item of this.elements)
                data["elements"].push(item.toJSON());
        }
        data["total"] = this.total;
        data["pageNumber"] = this.pageNumber;
        return data;
    }
}

export interface IPagedResultDto_1OfOfScaleObjectiveDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    elements?: ScaleObjectiveDto[] | undefined;
    total?: number;
    pageNumber?: number;
}

export class CreateUpdateScaleObjectiveDto implements ICreateUpdateScaleObjectiveDto {
    id?: number | undefined;
    objective?: string | undefined;
    description?: string | undefined;
    areaId?: number;
    clientId?: number;
    objectiveStatusId?: number;
    targetDate?: Date | undefined;
    isDeleted?: boolean;

    constructor(data?: ICreateUpdateScaleObjectiveDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.objective = _data["objective"];
            this.description = _data["description"];
            this.areaId = _data["areaId"];
            this.clientId = _data["clientId"];
            this.objectiveStatusId = _data["objectiveStatusId"];
            this.targetDate = _data["targetDate"] ? new Date(_data["targetDate"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): CreateUpdateScaleObjectiveDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUpdateScaleObjectiveDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["objective"] = this.objective;
        data["description"] = this.description;
        data["areaId"] = this.areaId;
        data["clientId"] = this.clientId;
        data["objectiveStatusId"] = this.objectiveStatusId;
        data["targetDate"] = this.targetDate ? this.targetDate.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface ICreateUpdateScaleObjectiveDto {
    id?: number | undefined;
    objective?: string | undefined;
    description?: string | undefined;
    areaId?: number;
    clientId?: number;
    objectiveStatusId?: number;
    targetDate?: Date | undefined;
    isDeleted?: boolean;
}

export class PlannedActivityDto implements IPlannedActivityDto {
    id?: string | undefined;
    sessionCode?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    professionalId?: number;
    professionalName?: string | undefined;
    primaryTypeId?: number;
    typologyName?: string | undefined;
    secondaryTypeId?: number;
    subtypologyName?: string | undefined;
    contractsIds?: number[] | undefined;
    contracts?: ContractDto[] | undefined;
    participantsIds?: number[] | undefined;
    participants?: ClientDto[] | undefined;
    day?: number;
    duration?: number;
    startTime?: string | undefined;
    isCreated?: boolean;
    error?: string | undefined;

    constructor(data?: IPlannedActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sessionCode = _data["sessionCode"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.professionalId = _data["professionalId"];
            this.professionalName = _data["professionalName"];
            this.primaryTypeId = _data["primaryTypeId"];
            this.typologyName = _data["typologyName"];
            this.secondaryTypeId = _data["secondaryTypeId"];
            this.subtypologyName = _data["subtypologyName"];
            if (Array.isArray(_data["contractsIds"])) {
                this.contractsIds = [] as any;
                for (let item of _data["contractsIds"])
                    this.contractsIds!.push(item);
            }
            if (Array.isArray(_data["contracts"])) {
                this.contracts = [] as any;
                for (let item of _data["contracts"])
                    this.contracts!.push(ContractDto.fromJS(item));
            }
            if (Array.isArray(_data["participantsIds"])) {
                this.participantsIds = [] as any;
                for (let item of _data["participantsIds"])
                    this.participantsIds!.push(item);
            }
            if (Array.isArray(_data["participants"])) {
                this.participants = [] as any;
                for (let item of _data["participants"])
                    this.participants!.push(ClientDto.fromJS(item));
            }
            this.day = _data["day"];
            this.duration = _data["duration"];
            this.startTime = _data["startTime"];
            this.isCreated = _data["isCreated"];
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): PlannedActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlannedActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sessionCode"] = this.sessionCode;
        data["name"] = this.name;
        data["description"] = this.description;
        data["professionalId"] = this.professionalId;
        data["professionalName"] = this.professionalName;
        data["primaryTypeId"] = this.primaryTypeId;
        data["typologyName"] = this.typologyName;
        data["secondaryTypeId"] = this.secondaryTypeId;
        data["subtypologyName"] = this.subtypologyName;
        if (Array.isArray(this.contractsIds)) {
            data["contractsIds"] = [];
            for (let item of this.contractsIds)
                data["contractsIds"].push(item);
        }
        if (Array.isArray(this.contracts)) {
            data["contracts"] = [];
            for (let item of this.contracts)
                data["contracts"].push(item.toJSON());
        }
        if (Array.isArray(this.participantsIds)) {
            data["participantsIds"] = [];
            for (let item of this.participantsIds)
                data["participantsIds"].push(item);
        }
        if (Array.isArray(this.participants)) {
            data["participants"] = [];
            for (let item of this.participants)
                data["participants"].push(item.toJSON());
        }
        data["day"] = this.day;
        data["duration"] = this.duration;
        data["startTime"] = this.startTime;
        data["isCreated"] = this.isCreated;
        data["error"] = this.error;
        return data;
    }
}

export interface IPlannedActivityDto {
    id?: string | undefined;
    sessionCode?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    professionalId?: number;
    professionalName?: string | undefined;
    primaryTypeId?: number;
    typologyName?: string | undefined;
    secondaryTypeId?: number;
    subtypologyName?: string | undefined;
    contractsIds?: number[] | undefined;
    contracts?: ContractDto[] | undefined;
    participantsIds?: number[] | undefined;
    participants?: ClientDto[] | undefined;
    day?: number;
    duration?: number;
    startTime?: string | undefined;
    isCreated?: boolean;
    error?: string | undefined;
}

export class PagedResultDto_1OfOfPlannedActivityDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null implements IPagedResultDto_1OfOfPlannedActivityDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    elements?: PlannedActivityDto[] | undefined;
    total?: number;
    pageNumber?: number;

    constructor(data?: IPagedResultDto_1OfOfPlannedActivityDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["elements"])) {
                this.elements = [] as any;
                for (let item of _data["elements"])
                    this.elements!.push(PlannedActivityDto.fromJS(item));
            }
            this.total = _data["total"];
            this.pageNumber = _data["pageNumber"];
        }
    }

    static fromJS(data: any): PagedResultDto_1OfOfPlannedActivityDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDto_1OfOfPlannedActivityDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.elements)) {
            data["elements"] = [];
            for (let item of this.elements)
                data["elements"].push(item.toJSON());
        }
        data["total"] = this.total;
        data["pageNumber"] = this.pageNumber;
        return data;
    }
}

export interface IPagedResultDto_1OfOfPlannedActivityDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    elements?: PlannedActivityDto[] | undefined;
    total?: number;
    pageNumber?: number;
}

export class InitialPlannedActivityDto implements IInitialPlannedActivityDto {
    servicePackageId?: number;
    startDate?: Date;
    endDate?: Date;
    contracts?: number[] | undefined;
    days?: number[] | undefined;
    maxNumberUsers?: number;

    constructor(data?: IInitialPlannedActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.servicePackageId = _data["servicePackageId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["contracts"])) {
                this.contracts = [] as any;
                for (let item of _data["contracts"])
                    this.contracts!.push(item);
            }
            if (Array.isArray(_data["days"])) {
                this.days = [] as any;
                for (let item of _data["days"])
                    this.days!.push(item);
            }
            this.maxNumberUsers = _data["maxNumberUsers"];
        }
    }

    static fromJS(data: any): InitialPlannedActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new InitialPlannedActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["servicePackageId"] = this.servicePackageId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        if (Array.isArray(this.contracts)) {
            data["contracts"] = [];
            for (let item of this.contracts)
                data["contracts"].push(item);
        }
        if (Array.isArray(this.days)) {
            data["days"] = [];
            for (let item of this.days)
                data["days"].push(item);
        }
        data["maxNumberUsers"] = this.maxNumberUsers;
        return data;
    }
}

export interface IInitialPlannedActivityDto {
    servicePackageId?: number;
    startDate?: Date;
    endDate?: Date;
    contracts?: number[] | undefined;
    days?: number[] | undefined;
    maxNumberUsers?: number;
}

export class CreatePlannedActivityDto implements ICreatePlannedActivityDto {
    plannedActivities?: PlannedActivityDto[] | undefined;

    constructor(data?: ICreatePlannedActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["plannedActivities"])) {
                this.plannedActivities = [] as any;
                for (let item of _data["plannedActivities"])
                    this.plannedActivities!.push(PlannedActivityDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreatePlannedActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePlannedActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.plannedActivities)) {
            data["plannedActivities"] = [];
            for (let item of this.plannedActivities)
                data["plannedActivities"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreatePlannedActivityDto {
    plannedActivities?: PlannedActivityDto[] | undefined;
}

export class CreateUpdateProfessionalDto implements ICreateUpdateProfessionalDto {
    id?: number | undefined;
    email?: string | undefined;
    identificationNumber?: string | undefined;
    password?: string | undefined;
    name!: string;
    surnames?: string | undefined;
    cellPhone?: string | undefined;
    homePhone?: string | undefined;
    languagesId?: number[] | undefined;
    professionalTypeId?: number | undefined;
    associatedWorkingCenterId?: number | undefined;
    roleId?: number;
    contracts?: number[] | undefined;
    ip?: string | undefined;
    admin?: number;
    activeDate?: Date | undefined;
    leavingDate?: Date | undefined;
    mainContractId?: number | undefined;
    picture?: ImageAttachment;

    constructor(data?: ICreateUpdateProfessionalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
            this.identificationNumber = _data["identificationNumber"];
            this.password = _data["password"];
            this.name = _data["name"];
            this.surnames = _data["surnames"];
            this.cellPhone = _data["cellPhone"];
            this.homePhone = _data["homePhone"];
            if (Array.isArray(_data["languagesId"])) {
                this.languagesId = [] as any;
                for (let item of _data["languagesId"])
                    this.languagesId!.push(item);
            }
            this.professionalTypeId = _data["professionalTypeId"];
            this.associatedWorkingCenterId = _data["associatedWorkingCenterId"];
            this.roleId = _data["roleId"];
            if (Array.isArray(_data["contracts"])) {
                this.contracts = [] as any;
                for (let item of _data["contracts"])
                    this.contracts!.push(item);
            }
            this.ip = _data["ip"];
            this.admin = _data["admin"];
            this.activeDate = _data["activeDate"] ? new Date(_data["activeDate"].toString()) : <any>undefined;
            this.leavingDate = _data["leavingDate"] ? new Date(_data["leavingDate"].toString()) : <any>undefined;
            this.mainContractId = _data["mainContractId"];
            this.picture = _data["picture"] ? ImageAttachment.fromJS(_data["picture"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateUpdateProfessionalDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUpdateProfessionalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        data["identificationNumber"] = this.identificationNumber;
        data["password"] = this.password;
        data["name"] = this.name;
        data["surnames"] = this.surnames;
        data["cellPhone"] = this.cellPhone;
        data["homePhone"] = this.homePhone;
        if (Array.isArray(this.languagesId)) {
            data["languagesId"] = [];
            for (let item of this.languagesId)
                data["languagesId"].push(item);
        }
        data["professionalTypeId"] = this.professionalTypeId;
        data["associatedWorkingCenterId"] = this.associatedWorkingCenterId;
        data["roleId"] = this.roleId;
        if (Array.isArray(this.contracts)) {
            data["contracts"] = [];
            for (let item of this.contracts)
                data["contracts"].push(item);
        }
        data["ip"] = this.ip;
        data["admin"] = this.admin;
        data["activeDate"] = this.activeDate ? this.activeDate.toISOString() : <any>undefined;
        data["leavingDate"] = this.leavingDate ? this.leavingDate.toISOString() : <any>undefined;
        data["mainContractId"] = this.mainContractId;
        data["picture"] = this.picture ? this.picture.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateUpdateProfessionalDto {
    id?: number | undefined;
    email?: string | undefined;
    identificationNumber?: string | undefined;
    password?: string | undefined;
    name: string;
    surnames?: string | undefined;
    cellPhone?: string | undefined;
    homePhone?: string | undefined;
    languagesId?: number[] | undefined;
    professionalTypeId?: number | undefined;
    associatedWorkingCenterId?: number | undefined;
    roleId?: number;
    contracts?: number[] | undefined;
    ip?: string | undefined;
    admin?: number;
    activeDate?: Date | undefined;
    leavingDate?: Date | undefined;
    mainContractId?: number | undefined;
    picture?: ImageAttachment;
}

export class ImageAttachmentProfessional implements IImageAttachmentProfessional {
    title?: string | undefined;
    src?: string | undefined;

    constructor(data?: IImageAttachmentProfessional) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.src = _data["src"];
        }
    }

    static fromJS(data: any): ImageAttachmentProfessional {
        data = typeof data === 'object' ? data : {};
        let result = new ImageAttachmentProfessional();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["src"] = this.src;
        return data;
    }
}

export interface IImageAttachmentProfessional {
    title?: string | undefined;
    src?: string | undefined;
}

export class ProfessionalDto implements IProfessionalDto {
    id?: number;
    professionalUserId?: number;
    email?: string | undefined;
    identificationNumber?: string | undefined;
    name?: string | undefined;
    surnames?: string | undefined;
    cellPhone?: string | undefined;
    homePhone?: string | undefined;
    isDeleted?: boolean;
    languagesId?: number[] | undefined;
    professionalTypeId?: number | undefined;
    professionalValue?: string | undefined;
    associatedWorkingCenterId?: number | undefined;
    contracts?: ContractDto[] | undefined;
    role?: RoleDto;
    activeDate?: Date | undefined;
    leavingDate?: Date | undefined;
    active?: boolean;
    mainContractId?: number | undefined;
    contractLogoId?: number | undefined;
    picture?: ImageAttachmentProfessional;

    constructor(data?: IProfessionalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.professionalUserId = _data["professionalUserId"];
            this.email = _data["email"];
            this.identificationNumber = _data["identificationNumber"];
            this.name = _data["name"];
            this.surnames = _data["surnames"];
            this.cellPhone = _data["cellPhone"];
            this.homePhone = _data["homePhone"];
            this.isDeleted = _data["isDeleted"];
            if (Array.isArray(_data["languagesId"])) {
                this.languagesId = [] as any;
                for (let item of _data["languagesId"])
                    this.languagesId!.push(item);
            }
            this.professionalTypeId = _data["professionalTypeId"];
            this.professionalValue = _data["professionalValue"];
            this.associatedWorkingCenterId = _data["associatedWorkingCenterId"];
            if (Array.isArray(_data["contracts"])) {
                this.contracts = [] as any;
                for (let item of _data["contracts"])
                    this.contracts!.push(ContractDto.fromJS(item));
            }
            this.role = _data["role"] ? RoleDto.fromJS(_data["role"]) : <any>undefined;
            this.activeDate = _data["activeDate"] ? new Date(_data["activeDate"].toString()) : <any>undefined;
            this.leavingDate = _data["leavingDate"] ? new Date(_data["leavingDate"].toString()) : <any>undefined;
            this.active = _data["active"];
            this.mainContractId = _data["mainContractId"];
            this.contractLogoId = _data["contractLogoId"];
            this.picture = _data["picture"] ? ImageAttachmentProfessional.fromJS(_data["picture"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ProfessionalDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProfessionalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["professionalUserId"] = this.professionalUserId;
        data["email"] = this.email;
        data["identificationNumber"] = this.identificationNumber;
        data["name"] = this.name;
        data["surnames"] = this.surnames;
        data["cellPhone"] = this.cellPhone;
        data["homePhone"] = this.homePhone;
        data["isDeleted"] = this.isDeleted;
        if (Array.isArray(this.languagesId)) {
            data["languagesId"] = [];
            for (let item of this.languagesId)
                data["languagesId"].push(item);
        }
        data["professionalTypeId"] = this.professionalTypeId;
        data["professionalValue"] = this.professionalValue;
        data["associatedWorkingCenterId"] = this.associatedWorkingCenterId;
        if (Array.isArray(this.contracts)) {
            data["contracts"] = [];
            for (let item of this.contracts)
                data["contracts"].push(item.toJSON());
        }
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        data["activeDate"] = this.activeDate ? this.activeDate.toISOString() : <any>undefined;
        data["leavingDate"] = this.leavingDate ? this.leavingDate.toISOString() : <any>undefined;
        data["active"] = this.active;
        data["mainContractId"] = this.mainContractId;
        data["contractLogoId"] = this.contractLogoId;
        data["picture"] = this.picture ? this.picture.toJSON() : <any>undefined;
        return data;
    }
}

export interface IProfessionalDto {
    id?: number;
    professionalUserId?: number;
    email?: string | undefined;
    identificationNumber?: string | undefined;
    name?: string | undefined;
    surnames?: string | undefined;
    cellPhone?: string | undefined;
    homePhone?: string | undefined;
    isDeleted?: boolean;
    languagesId?: number[] | undefined;
    professionalTypeId?: number | undefined;
    professionalValue?: string | undefined;
    associatedWorkingCenterId?: number | undefined;
    contracts?: ContractDto[] | undefined;
    role?: RoleDto;
    activeDate?: Date | undefined;
    leavingDate?: Date | undefined;
    active?: boolean;
    mainContractId?: number | undefined;
    contractLogoId?: number | undefined;
    picture?: ImageAttachmentProfessional;
}

export class ProfessionalQueryDto implements IProfessionalQueryDto {
    pageNumber?: number;
    pageSize?: number;
    readonly skipElments?: number;
    orderField?: string | undefined;
    orderAsc?: boolean;
    contractMainId?: number | undefined;
    contractId?: number | undefined;
    contractIds?: number[] | undefined;
    contractingAuthorityId?: number | undefined;
    email?: string | undefined;
    identificationNumber?: string | undefined;
    name?: string | undefined;
    surnames?: string | undefined;
    cellPhone?: string | undefined;
    homePhone?: string | undefined;
    nameINumber?: string | undefined;
    languagesId?: number[] | undefined;
    professionalTypeId?: number[] | undefined;
    associatedWorkingCenterId?: number | undefined;
    adminId?: number | undefined;
    professionalId?: number | undefined;
    onlyAdmins?: boolean;
    active?: string | undefined;
    isMain?: boolean | undefined;
    notInContract?: boolean;

    constructor(data?: IProfessionalQueryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            (<any>this).skipElments = _data["skipElments"];
            this.orderField = _data["orderField"];
            this.orderAsc = _data["orderAsc"];
            this.contractMainId = _data["contractMainId"];
            this.contractId = _data["contractId"];
            if (Array.isArray(_data["contractIds"])) {
                this.contractIds = [] as any;
                for (let item of _data["contractIds"])
                    this.contractIds!.push(item);
            }
            this.contractingAuthorityId = _data["contractingAuthorityId"];
            this.email = _data["email"];
            this.identificationNumber = _data["identificationNumber"];
            this.name = _data["name"];
            this.surnames = _data["surnames"];
            this.cellPhone = _data["cellPhone"];
            this.homePhone = _data["homePhone"];
            this.nameINumber = _data["nameINumber"];
            if (Array.isArray(_data["languagesId"])) {
                this.languagesId = [] as any;
                for (let item of _data["languagesId"])
                    this.languagesId!.push(item);
            }
            if (Array.isArray(_data["professionalTypeId"])) {
                this.professionalTypeId = [] as any;
                for (let item of _data["professionalTypeId"])
                    this.professionalTypeId!.push(item);
            }
            this.associatedWorkingCenterId = _data["associatedWorkingCenterId"];
            this.adminId = _data["adminId"];
            this.professionalId = _data["professionalId"];
            this.onlyAdmins = _data["onlyAdmins"];
            this.active = _data["active"];
            this.isMain = _data["isMain"];
            this.notInContract = _data["notInContract"];
        }
    }

    static fromJS(data: any): ProfessionalQueryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProfessionalQueryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["skipElments"] = this.skipElments;
        data["orderField"] = this.orderField;
        data["orderAsc"] = this.orderAsc;
        data["contractMainId"] = this.contractMainId;
        data["contractId"] = this.contractId;
        if (Array.isArray(this.contractIds)) {
            data["contractIds"] = [];
            for (let item of this.contractIds)
                data["contractIds"].push(item);
        }
        data["contractingAuthorityId"] = this.contractingAuthorityId;
        data["email"] = this.email;
        data["identificationNumber"] = this.identificationNumber;
        data["name"] = this.name;
        data["surnames"] = this.surnames;
        data["cellPhone"] = this.cellPhone;
        data["homePhone"] = this.homePhone;
        data["nameINumber"] = this.nameINumber;
        if (Array.isArray(this.languagesId)) {
            data["languagesId"] = [];
            for (let item of this.languagesId)
                data["languagesId"].push(item);
        }
        if (Array.isArray(this.professionalTypeId)) {
            data["professionalTypeId"] = [];
            for (let item of this.professionalTypeId)
                data["professionalTypeId"].push(item);
        }
        data["associatedWorkingCenterId"] = this.associatedWorkingCenterId;
        data["adminId"] = this.adminId;
        data["professionalId"] = this.professionalId;
        data["onlyAdmins"] = this.onlyAdmins;
        data["active"] = this.active;
        data["isMain"] = this.isMain;
        data["notInContract"] = this.notInContract;
        return data;
    }
}

export interface IProfessionalQueryDto {
    pageNumber?: number;
    pageSize?: number;
    skipElments?: number;
    orderField?: string | undefined;
    orderAsc?: boolean;
    contractMainId?: number | undefined;
    contractId?: number | undefined;
    contractIds?: number[] | undefined;
    contractingAuthorityId?: number | undefined;
    email?: string | undefined;
    identificationNumber?: string | undefined;
    name?: string | undefined;
    surnames?: string | undefined;
    cellPhone?: string | undefined;
    homePhone?: string | undefined;
    nameINumber?: string | undefined;
    languagesId?: number[] | undefined;
    professionalTypeId?: number[] | undefined;
    associatedWorkingCenterId?: number | undefined;
    adminId?: number | undefined;
    professionalId?: number | undefined;
    onlyAdmins?: boolean;
    active?: string | undefined;
    isMain?: boolean | undefined;
    notInContract?: boolean;
}

export class PagedResultDto_1OfOfProfessionalDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null implements IPagedResultDto_1OfOfProfessionalDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    elements?: ProfessionalDto[] | undefined;
    total?: number;
    pageNumber?: number;

    constructor(data?: IPagedResultDto_1OfOfProfessionalDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["elements"])) {
                this.elements = [] as any;
                for (let item of _data["elements"])
                    this.elements!.push(ProfessionalDto.fromJS(item));
            }
            this.total = _data["total"];
            this.pageNumber = _data["pageNumber"];
        }
    }

    static fromJS(data: any): PagedResultDto_1OfOfProfessionalDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDto_1OfOfProfessionalDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.elements)) {
            data["elements"] = [];
            for (let item of this.elements)
                data["elements"].push(item.toJSON());
        }
        data["total"] = this.total;
        data["pageNumber"] = this.pageNumber;
        return data;
    }
}

export interface IPagedResultDto_1OfOfProfessionalDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    elements?: ProfessionalDto[] | undefined;
    total?: number;
    pageNumber?: number;
}

export class ScaleQueryDto implements IScaleQueryDto {
    pageNumber?: number;
    pageSize?: number;
    readonly skipElments?: number;
    orderField?: string | undefined;
    orderAsc?: boolean;
    id?: number | undefined;
    code?: string | undefined;
    name?: string | undefined;
    areaId?: number | undefined;

    constructor(data?: IScaleQueryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            (<any>this).skipElments = _data["skipElments"];
            this.orderField = _data["orderField"];
            this.orderAsc = _data["orderAsc"];
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.areaId = _data["areaId"];
        }
    }

    static fromJS(data: any): ScaleQueryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScaleQueryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["skipElments"] = this.skipElments;
        data["orderField"] = this.orderField;
        data["orderAsc"] = this.orderAsc;
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["areaId"] = this.areaId;
        return data;
    }
}

export interface IScaleQueryDto {
    pageNumber?: number;
    pageSize?: number;
    skipElments?: number;
    orderField?: string | undefined;
    orderAsc?: boolean;
    id?: number | undefined;
    code?: string | undefined;
    name?: string | undefined;
    areaId?: number | undefined;
}

export class ScaleFactorMinDto implements IScaleFactorMinDto {
    id?: number;
    code?: string | undefined;
    name?: string | undefined;
    order?: number;

    constructor(data?: IScaleFactorMinDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): ScaleFactorMinDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScaleFactorMinDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["order"] = this.order;
        return data;
    }
}

export interface IScaleFactorMinDto {
    id?: number;
    code?: string | undefined;
    name?: string | undefined;
    order?: number;
}

export enum OhlConstants_ResponseType {
    Unknown = "Unknown",
    Choice = "Choice",
    Check = "Check",
    Text = "Text",
    Number = "Number",
    Date = "Date",
}

export class ScaleOptionMinDto implements IScaleOptionMinDto {
    id?: number;
    code?: string | undefined;
    label?: string | undefined;

    constructor(data?: IScaleOptionMinDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.label = _data["label"];
        }
    }

    static fromJS(data: any): ScaleOptionMinDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScaleOptionMinDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["label"] = this.label;
        return data;
    }
}

export interface IScaleOptionMinDto {
    id?: number;
    code?: string | undefined;
    label?: string | undefined;
}

export class QuestionOptionScoreMinDto implements IQuestionOptionScoreMinDto {
    id?: number;
    scaleQuestionId?: number;
    scaleOptionId?: number;
    score?: number | undefined;
    order?: number;
    scaleOption?: ScaleOptionMinDto;

    constructor(data?: IQuestionOptionScoreMinDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.scaleQuestionId = _data["scaleQuestionId"];
            this.scaleOptionId = _data["scaleOptionId"];
            this.score = _data["score"];
            this.order = _data["order"];
            this.scaleOption = _data["scaleOption"] ? ScaleOptionMinDto.fromJS(_data["scaleOption"]) : <any>undefined;
        }
    }

    static fromJS(data: any): QuestionOptionScoreMinDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionOptionScoreMinDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["scaleQuestionId"] = this.scaleQuestionId;
        data["scaleOptionId"] = this.scaleOptionId;
        data["score"] = this.score;
        data["order"] = this.order;
        data["scaleOption"] = this.scaleOption ? this.scaleOption.toJSON() : <any>undefined;
        return data;
    }
}

export interface IQuestionOptionScoreMinDto {
    id?: number;
    scaleQuestionId?: number;
    scaleOptionId?: number;
    score?: number | undefined;
    order?: number;
    scaleOption?: ScaleOptionMinDto;
}

export class ScaleQuestionMinDto implements IScaleQuestionMinDto {
    id?: number;
    code?: string | undefined;
    text?: string | undefined;
    subText?: string | undefined;
    responseType?: OhlConstants_ResponseType;
    isVisible?: boolean;
    order?: number;
    scaleId!: number;
    scaleFactorId?: number | undefined;
    questionOptionScores?: QuestionOptionScoreMinDto[] | undefined;

    constructor(data?: IScaleQuestionMinDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.text = _data["text"];
            this.subText = _data["subText"];
            this.responseType = _data["responseType"];
            this.isVisible = _data["isVisible"];
            this.order = _data["order"];
            this.scaleId = _data["scaleId"];
            this.scaleFactorId = _data["scaleFactorId"];
            if (Array.isArray(_data["questionOptionScores"])) {
                this.questionOptionScores = [] as any;
                for (let item of _data["questionOptionScores"])
                    this.questionOptionScores!.push(QuestionOptionScoreMinDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ScaleQuestionMinDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScaleQuestionMinDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["text"] = this.text;
        data["subText"] = this.subText;
        data["responseType"] = this.responseType;
        data["isVisible"] = this.isVisible;
        data["order"] = this.order;
        data["scaleId"] = this.scaleId;
        data["scaleFactorId"] = this.scaleFactorId;
        if (Array.isArray(this.questionOptionScores)) {
            data["questionOptionScores"] = [];
            for (let item of this.questionOptionScores)
                data["questionOptionScores"].push(item.toJSON());
        }
        return data;
    }
}

export interface IScaleQuestionMinDto {
    id?: number;
    code?: string | undefined;
    text?: string | undefined;
    subText?: string | undefined;
    responseType?: OhlConstants_ResponseType;
    isVisible?: boolean;
    order?: number;
    scaleId: number;
    scaleFactorId?: number | undefined;
    questionOptionScores?: QuestionOptionScoreMinDto[] | undefined;
}

export class ScaleDto implements IScaleDto {
    id?: number;
    code?: string | undefined;
    name?: string | undefined;
    detail?: string | undefined;
    estimatedTime?: string | undefined;
    order?: number;
    items?: number | undefined;
    areaId?: number | undefined;
    areaName?: string | undefined;
    isDeleted?: boolean;
    factors?: ScaleFactorMinDto[] | undefined;
    questions?: ScaleQuestionMinDto[] | undefined;

    constructor(data?: IScaleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.name = _data["name"];
            this.detail = _data["detail"];
            this.estimatedTime = _data["estimatedTime"];
            this.order = _data["order"];
            this.items = _data["items"];
            this.areaId = _data["areaId"];
            this.areaName = _data["areaName"];
            this.isDeleted = _data["isDeleted"];
            if (Array.isArray(_data["factors"])) {
                this.factors = [] as any;
                for (let item of _data["factors"])
                    this.factors!.push(ScaleFactorMinDto.fromJS(item));
            }
            if (Array.isArray(_data["questions"])) {
                this.questions = [] as any;
                for (let item of _data["questions"])
                    this.questions!.push(ScaleQuestionMinDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ScaleDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScaleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["name"] = this.name;
        data["detail"] = this.detail;
        data["estimatedTime"] = this.estimatedTime;
        data["order"] = this.order;
        data["items"] = this.items;
        data["areaId"] = this.areaId;
        data["areaName"] = this.areaName;
        data["isDeleted"] = this.isDeleted;
        if (Array.isArray(this.factors)) {
            data["factors"] = [];
            for (let item of this.factors)
                data["factors"].push(item.toJSON());
        }
        if (Array.isArray(this.questions)) {
            data["questions"] = [];
            for (let item of this.questions)
                data["questions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IScaleDto {
    id?: number;
    code?: string | undefined;
    name?: string | undefined;
    detail?: string | undefined;
    estimatedTime?: string | undefined;
    order?: number;
    items?: number | undefined;
    areaId?: number | undefined;
    areaName?: string | undefined;
    isDeleted?: boolean;
    factors?: ScaleFactorMinDto[] | undefined;
    questions?: ScaleQuestionMinDto[] | undefined;
}

export class PagedResultDto_1OfOfScaleDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null implements IPagedResultDto_1OfOfScaleDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    elements?: ScaleDto[] | undefined;
    total?: number;
    pageNumber?: number;

    constructor(data?: IPagedResultDto_1OfOfScaleDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["elements"])) {
                this.elements = [] as any;
                for (let item of _data["elements"])
                    this.elements!.push(ScaleDto.fromJS(item));
            }
            this.total = _data["total"];
            this.pageNumber = _data["pageNumber"];
        }
    }

    static fromJS(data: any): PagedResultDto_1OfOfScaleDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDto_1OfOfScaleDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.elements)) {
            data["elements"] = [];
            for (let item of this.elements)
                data["elements"].push(item.toJSON());
        }
        data["total"] = this.total;
        data["pageNumber"] = this.pageNumber;
        return data;
    }
}

export interface IPagedResultDto_1OfOfScaleDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    elements?: ScaleDto[] | undefined;
    total?: number;
    pageNumber?: number;
}

export class ScaleRegisterQueryDto implements IScaleRegisterQueryDto {
    pageNumber?: number;
    pageSize?: number;
    readonly skipElments?: number;
    orderField?: string | undefined;
    orderAsc?: boolean;
    id?: number | undefined;
    scaleId?: number | undefined;
    clientId?: number | undefined;
    adminId?: number | undefined;
    professionalId?: number | undefined;
    scaleStatusId?: number | undefined;
    scaleName?: string | undefined;
    clientName?: string | undefined;
    professionalName?: string | undefined;
    scaleStatusName?: string | undefined;
    contractName?: string | undefined;
    areaName?: string | undefined;
    createdDate?: Date | undefined;
    evaluationDateFrom?: Date | undefined;
    evaluationDateTo?: Date | undefined;
    contractIds?: number[] | undefined;

    constructor(data?: IScaleRegisterQueryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            (<any>this).skipElments = _data["skipElments"];
            this.orderField = _data["orderField"];
            this.orderAsc = _data["orderAsc"];
            this.id = _data["id"];
            this.scaleId = _data["scaleId"];
            this.clientId = _data["clientId"];
            this.adminId = _data["adminId"];
            this.professionalId = _data["professionalId"];
            this.scaleStatusId = _data["scaleStatusId"];
            this.scaleName = _data["scaleName"];
            this.clientName = _data["clientName"];
            this.professionalName = _data["professionalName"];
            this.scaleStatusName = _data["scaleStatusName"];
            this.contractName = _data["contractName"];
            this.areaName = _data["areaName"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.evaluationDateFrom = _data["evaluationDateFrom"] ? new Date(_data["evaluationDateFrom"].toString()) : <any>undefined;
            this.evaluationDateTo = _data["evaluationDateTo"] ? new Date(_data["evaluationDateTo"].toString()) : <any>undefined;
            if (Array.isArray(_data["contractIds"])) {
                this.contractIds = [] as any;
                for (let item of _data["contractIds"])
                    this.contractIds!.push(item);
            }
        }
    }

    static fromJS(data: any): ScaleRegisterQueryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScaleRegisterQueryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["skipElments"] = this.skipElments;
        data["orderField"] = this.orderField;
        data["orderAsc"] = this.orderAsc;
        data["id"] = this.id;
        data["scaleId"] = this.scaleId;
        data["clientId"] = this.clientId;
        data["adminId"] = this.adminId;
        data["professionalId"] = this.professionalId;
        data["scaleStatusId"] = this.scaleStatusId;
        data["scaleName"] = this.scaleName;
        data["clientName"] = this.clientName;
        data["professionalName"] = this.professionalName;
        data["scaleStatusName"] = this.scaleStatusName;
        data["contractName"] = this.contractName;
        data["areaName"] = this.areaName;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["evaluationDateFrom"] = this.evaluationDateFrom ? this.evaluationDateFrom.toISOString() : <any>undefined;
        data["evaluationDateTo"] = this.evaluationDateTo ? this.evaluationDateTo.toISOString() : <any>undefined;
        if (Array.isArray(this.contractIds)) {
            data["contractIds"] = [];
            for (let item of this.contractIds)
                data["contractIds"].push(item);
        }
        return data;
    }
}

export interface IScaleRegisterQueryDto {
    pageNumber?: number;
    pageSize?: number;
    skipElments?: number;
    orderField?: string | undefined;
    orderAsc?: boolean;
    id?: number | undefined;
    scaleId?: number | undefined;
    clientId?: number | undefined;
    adminId?: number | undefined;
    professionalId?: number | undefined;
    scaleStatusId?: number | undefined;
    scaleName?: string | undefined;
    clientName?: string | undefined;
    professionalName?: string | undefined;
    scaleStatusName?: string | undefined;
    contractName?: string | undefined;
    areaName?: string | undefined;
    createdDate?: Date | undefined;
    evaluationDateFrom?: Date | undefined;
    evaluationDateTo?: Date | undefined;
    contractIds?: number[] | undefined;
}

export class TimeSpan implements ITimeSpan {
    readonly ticks?: number;
    readonly days?: number;
    readonly hours?: number;
    readonly milliseconds?: number;
    readonly minutes?: number;
    readonly seconds?: number;
    readonly totalDays?: number;
    readonly totalHours?: number;
    readonly totalMilliseconds?: number;
    readonly totalMinutes?: number;
    readonly totalSeconds?: number;

    constructor(data?: ITimeSpan) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).ticks = _data["ticks"];
            (<any>this).days = _data["days"];
            (<any>this).hours = _data["hours"];
            (<any>this).milliseconds = _data["milliseconds"];
            (<any>this).minutes = _data["minutes"];
            (<any>this).seconds = _data["seconds"];
            (<any>this).totalDays = _data["totalDays"];
            (<any>this).totalHours = _data["totalHours"];
            (<any>this).totalMilliseconds = _data["totalMilliseconds"];
            (<any>this).totalMinutes = _data["totalMinutes"];
            (<any>this).totalSeconds = _data["totalSeconds"];
        }
    }

    static fromJS(data: any): TimeSpan {
        data = typeof data === 'object' ? data : {};
        let result = new TimeSpan();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticks"] = this.ticks;
        data["days"] = this.days;
        data["hours"] = this.hours;
        data["milliseconds"] = this.milliseconds;
        data["minutes"] = this.minutes;
        data["seconds"] = this.seconds;
        data["totalDays"] = this.totalDays;
        data["totalHours"] = this.totalHours;
        data["totalMilliseconds"] = this.totalMilliseconds;
        data["totalMinutes"] = this.totalMinutes;
        data["totalSeconds"] = this.totalSeconds;
        return data;
    }
}

export interface ITimeSpan {
    ticks?: number;
    days?: number;
    hours?: number;
    milliseconds?: number;
    minutes?: number;
    seconds?: number;
    totalDays?: number;
    totalHours?: number;
    totalMilliseconds?: number;
    totalMinutes?: number;
    totalSeconds?: number;
}

export class ScaleResponseDto implements IScaleResponseDto {
    id?: number;
    scaleQuestionId?: number;
    scaleOptionId?: number | undefined;
    textValue?: string | undefined;
    numericValue?: number | undefined;
    score?: number | undefined;
    order?: number;

    constructor(data?: IScaleResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.scaleQuestionId = _data["scaleQuestionId"];
            this.scaleOptionId = _data["scaleOptionId"];
            this.textValue = _data["textValue"];
            this.numericValue = _data["numericValue"];
            this.score = _data["score"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): ScaleResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScaleResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["scaleQuestionId"] = this.scaleQuestionId;
        data["scaleOptionId"] = this.scaleOptionId;
        data["textValue"] = this.textValue;
        data["numericValue"] = this.numericValue;
        data["score"] = this.score;
        data["order"] = this.order;
        return data;
    }
}

export interface IScaleResponseDto {
    id?: number;
    scaleQuestionId?: number;
    scaleOptionId?: number | undefined;
    textValue?: string | undefined;
    numericValue?: number | undefined;
    score?: number | undefined;
    order?: number;
}

export class ScaleRegisterDto implements IScaleRegisterDto {
    id?: number;
    scaleId?: number;
    clientId?: number;
    professionalId?: number;
    scaleStatusId?: number;
    evaluationDate?: Date;
    createdDate?: Date;
    timeConsumed?: TimeSpan;
    scaleNotes?: string | undefined;
    totalScore?: string | undefined;
    isDeleted?: boolean;
    scaleName?: string | undefined;
    clientName?: string | undefined;
    clientAge?: number;
    contractName?: string | undefined;
    areaName?: string | undefined;
    professionalName?: string | undefined;
    scaleStatusName?: string | undefined;
    scaleResponses?: ScaleResponseDto[] | undefined;

    constructor(data?: IScaleRegisterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.scaleId = _data["scaleId"];
            this.clientId = _data["clientId"];
            this.professionalId = _data["professionalId"];
            this.scaleStatusId = _data["scaleStatusId"];
            this.evaluationDate = _data["evaluationDate"] ? new Date(_data["evaluationDate"].toString()) : <any>undefined;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.timeConsumed = _data["timeConsumed"] ? TimeSpan.fromJS(_data["timeConsumed"]) : <any>undefined;
            this.scaleNotes = _data["scaleNotes"];
            this.totalScore = _data["totalScore"];
            this.isDeleted = _data["isDeleted"];
            this.scaleName = _data["scaleName"];
            this.clientName = _data["clientName"];
            this.clientAge = _data["clientAge"];
            this.contractName = _data["contractName"];
            this.areaName = _data["areaName"];
            this.professionalName = _data["professionalName"];
            this.scaleStatusName = _data["scaleStatusName"];
            if (Array.isArray(_data["scaleResponses"])) {
                this.scaleResponses = [] as any;
                for (let item of _data["scaleResponses"])
                    this.scaleResponses!.push(ScaleResponseDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ScaleRegisterDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScaleRegisterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["scaleId"] = this.scaleId;
        data["clientId"] = this.clientId;
        data["professionalId"] = this.professionalId;
        data["scaleStatusId"] = this.scaleStatusId;
        data["evaluationDate"] = this.evaluationDate ? this.evaluationDate.toISOString() : <any>undefined;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["timeConsumed"] = this.timeConsumed ? this.timeConsumed.toJSON() : <any>undefined;
        data["scaleNotes"] = this.scaleNotes;
        data["totalScore"] = this.totalScore;
        data["isDeleted"] = this.isDeleted;
        data["scaleName"] = this.scaleName;
        data["clientName"] = this.clientName;
        data["clientAge"] = this.clientAge;
        data["contractName"] = this.contractName;
        data["areaName"] = this.areaName;
        data["professionalName"] = this.professionalName;
        data["scaleStatusName"] = this.scaleStatusName;
        if (Array.isArray(this.scaleResponses)) {
            data["scaleResponses"] = [];
            for (let item of this.scaleResponses)
                data["scaleResponses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IScaleRegisterDto {
    id?: number;
    scaleId?: number;
    clientId?: number;
    professionalId?: number;
    scaleStatusId?: number;
    evaluationDate?: Date;
    createdDate?: Date;
    timeConsumed?: TimeSpan;
    scaleNotes?: string | undefined;
    totalScore?: string | undefined;
    isDeleted?: boolean;
    scaleName?: string | undefined;
    clientName?: string | undefined;
    clientAge?: number;
    contractName?: string | undefined;
    areaName?: string | undefined;
    professionalName?: string | undefined;
    scaleStatusName?: string | undefined;
    scaleResponses?: ScaleResponseDto[] | undefined;
}

export class PagedResultDto_1OfOfScaleRegisterDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null implements IPagedResultDto_1OfOfScaleRegisterDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    elements?: ScaleRegisterDto[] | undefined;
    total?: number;
    pageNumber?: number;

    constructor(data?: IPagedResultDto_1OfOfScaleRegisterDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["elements"])) {
                this.elements = [] as any;
                for (let item of _data["elements"])
                    this.elements!.push(ScaleRegisterDto.fromJS(item));
            }
            this.total = _data["total"];
            this.pageNumber = _data["pageNumber"];
        }
    }

    static fromJS(data: any): PagedResultDto_1OfOfScaleRegisterDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDto_1OfOfScaleRegisterDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.elements)) {
            data["elements"] = [];
            for (let item of this.elements)
                data["elements"].push(item.toJSON());
        }
        data["total"] = this.total;
        data["pageNumber"] = this.pageNumber;
        return data;
    }
}

export interface IPagedResultDto_1OfOfScaleRegisterDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    elements?: ScaleRegisterDto[] | undefined;
    total?: number;
    pageNumber?: number;
}

export class CreateUpdateScaleRegisterDto implements ICreateUpdateScaleRegisterDto {
    id?: number;
    scaleId?: number;
    clientId?: number;
    professionalId?: number;
    scaleStatusId?: number;
    evaluationDate?: Date;
    timeConsumed?: TimeSpan;
    scaleNotes?: string | undefined;
    totalScore?: string | undefined;
    scaleResponses?: ScaleResponseDto[] | undefined;

    constructor(data?: ICreateUpdateScaleRegisterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.scaleId = _data["scaleId"];
            this.clientId = _data["clientId"];
            this.professionalId = _data["professionalId"];
            this.scaleStatusId = _data["scaleStatusId"];
            this.evaluationDate = _data["evaluationDate"] ? new Date(_data["evaluationDate"].toString()) : <any>undefined;
            this.timeConsumed = _data["timeConsumed"] ? TimeSpan.fromJS(_data["timeConsumed"]) : <any>undefined;
            this.scaleNotes = _data["scaleNotes"];
            this.totalScore = _data["totalScore"];
            if (Array.isArray(_data["scaleResponses"])) {
                this.scaleResponses = [] as any;
                for (let item of _data["scaleResponses"])
                    this.scaleResponses!.push(ScaleResponseDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateUpdateScaleRegisterDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUpdateScaleRegisterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["scaleId"] = this.scaleId;
        data["clientId"] = this.clientId;
        data["professionalId"] = this.professionalId;
        data["scaleStatusId"] = this.scaleStatusId;
        data["evaluationDate"] = this.evaluationDate ? this.evaluationDate.toISOString() : <any>undefined;
        data["timeConsumed"] = this.timeConsumed ? this.timeConsumed.toJSON() : <any>undefined;
        data["scaleNotes"] = this.scaleNotes;
        data["totalScore"] = this.totalScore;
        if (Array.isArray(this.scaleResponses)) {
            data["scaleResponses"] = [];
            for (let item of this.scaleResponses)
                data["scaleResponses"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateUpdateScaleRegisterDto {
    id?: number;
    scaleId?: number;
    clientId?: number;
    professionalId?: number;
    scaleStatusId?: number;
    evaluationDate?: Date;
    timeConsumed?: TimeSpan;
    scaleNotes?: string | undefined;
    totalScore?: string | undefined;
    scaleResponses?: ScaleResponseDto[] | undefined;
}

export class FinishScaleRegisterDto implements IFinishScaleRegisterDto {
    scaleRegisterId?: number;
    totalScore?: string | undefined;
    createdDate?: Date | undefined;

    constructor(data?: IFinishScaleRegisterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scaleRegisterId = _data["scaleRegisterId"];
            this.totalScore = _data["totalScore"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): FinishScaleRegisterDto {
        data = typeof data === 'object' ? data : {};
        let result = new FinishScaleRegisterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scaleRegisterId"] = this.scaleRegisterId;
        data["totalScore"] = this.totalScore;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IFinishScaleRegisterDto {
    scaleRegisterId?: number;
    totalScore?: string | undefined;
    createdDate?: Date | undefined;
}

export class UpdateScaleResponseDto implements IUpdateScaleResponseDto {
    id?: number;
    scaleQuestionId?: number;
    scaleOptionId?: number | undefined;
    textValue?: string | undefined;
    numericValue?: number | undefined;
    score?: number | undefined;
    order?: number;

    constructor(data?: IUpdateScaleResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.scaleQuestionId = _data["scaleQuestionId"];
            this.scaleOptionId = _data["scaleOptionId"];
            this.textValue = _data["textValue"];
            this.numericValue = _data["numericValue"];
            this.score = _data["score"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): UpdateScaleResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateScaleResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["scaleQuestionId"] = this.scaleQuestionId;
        data["scaleOptionId"] = this.scaleOptionId;
        data["textValue"] = this.textValue;
        data["numericValue"] = this.numericValue;
        data["score"] = this.score;
        data["order"] = this.order;
        return data;
    }
}

export interface IUpdateScaleResponseDto {
    id?: number;
    scaleQuestionId?: number;
    scaleOptionId?: number | undefined;
    textValue?: string | undefined;
    numericValue?: number | undefined;
    score?: number | undefined;
    order?: number;
}

export class ScheduledActivityQueryDto implements IScheduledActivityQueryDto {
    pageNumber?: number;
    pageSize?: number;
    readonly skipElments?: number;
    orderField?: string | undefined;
    orderAsc?: boolean;
    activityId?: number | undefined;
    clientId?: number | undefined;
    adminId?: number | undefined;
    contractingAuthorityId?: number | undefined;
    profesionalId?: number | undefined;
    includeUnRealized?: boolean;
    includeCanceled?: boolean;
    includeDeleted?: boolean;
    areHeld?: boolean | undefined;
    startDateFrom?: Date | undefined;
    startDateTo?: Date | undefined;
    realEndDateFrom?: Date | undefined;
    realEndDateTo?: Date | undefined;
    comments?: string | undefined;
    description?: string | undefined;
    filteredForInput?: boolean;
    maxDaysSearch?: number;
    isRecord?: boolean | undefined;
    includeUsers?: boolean;
    isCalendar?: boolean;
    origin?: string | undefined;

    constructor(data?: IScheduledActivityQueryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            (<any>this).skipElments = _data["skipElments"];
            this.orderField = _data["orderField"];
            this.orderAsc = _data["orderAsc"];
            this.activityId = _data["activityId"];
            this.clientId = _data["clientId"];
            this.adminId = _data["adminId"];
            this.contractingAuthorityId = _data["contractingAuthorityId"];
            this.profesionalId = _data["profesionalId"];
            this.includeUnRealized = _data["includeUnRealized"];
            this.includeCanceled = _data["includeCanceled"];
            this.includeDeleted = _data["includeDeleted"];
            this.areHeld = _data["areHeld"];
            this.startDateFrom = _data["startDateFrom"] ? new Date(_data["startDateFrom"].toString()) : <any>undefined;
            this.startDateTo = _data["startDateTo"] ? new Date(_data["startDateTo"].toString()) : <any>undefined;
            this.realEndDateFrom = _data["realEndDateFrom"] ? new Date(_data["realEndDateFrom"].toString()) : <any>undefined;
            this.realEndDateTo = _data["realEndDateTo"] ? new Date(_data["realEndDateTo"].toString()) : <any>undefined;
            this.comments = _data["comments"];
            this.description = _data["description"];
            this.filteredForInput = _data["filteredForInput"];
            this.maxDaysSearch = _data["maxDaysSearch"];
            this.isRecord = _data["isRecord"];
            this.includeUsers = _data["includeUsers"];
            this.isCalendar = _data["isCalendar"];
            this.origin = _data["origin"];
        }
    }

    static fromJS(data: any): ScheduledActivityQueryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduledActivityQueryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["skipElments"] = this.skipElments;
        data["orderField"] = this.orderField;
        data["orderAsc"] = this.orderAsc;
        data["activityId"] = this.activityId;
        data["clientId"] = this.clientId;
        data["adminId"] = this.adminId;
        data["contractingAuthorityId"] = this.contractingAuthorityId;
        data["profesionalId"] = this.profesionalId;
        data["includeUnRealized"] = this.includeUnRealized;
        data["includeCanceled"] = this.includeCanceled;
        data["includeDeleted"] = this.includeDeleted;
        data["areHeld"] = this.areHeld;
        data["startDateFrom"] = this.startDateFrom ? this.startDateFrom.toISOString() : <any>undefined;
        data["startDateTo"] = this.startDateTo ? this.startDateTo.toISOString() : <any>undefined;
        data["realEndDateFrom"] = this.realEndDateFrom ? this.realEndDateFrom.toISOString() : <any>undefined;
        data["realEndDateTo"] = this.realEndDateTo ? this.realEndDateTo.toISOString() : <any>undefined;
        data["comments"] = this.comments;
        data["description"] = this.description;
        data["filteredForInput"] = this.filteredForInput;
        data["maxDaysSearch"] = this.maxDaysSearch;
        data["isRecord"] = this.isRecord;
        data["includeUsers"] = this.includeUsers;
        data["isCalendar"] = this.isCalendar;
        data["origin"] = this.origin;
        return data;
    }
}

export interface IScheduledActivityQueryDto {
    pageNumber?: number;
    pageSize?: number;
    skipElments?: number;
    orderField?: string | undefined;
    orderAsc?: boolean;
    activityId?: number | undefined;
    clientId?: number | undefined;
    adminId?: number | undefined;
    contractingAuthorityId?: number | undefined;
    profesionalId?: number | undefined;
    includeUnRealized?: boolean;
    includeCanceled?: boolean;
    includeDeleted?: boolean;
    areHeld?: boolean | undefined;
    startDateFrom?: Date | undefined;
    startDateTo?: Date | undefined;
    realEndDateFrom?: Date | undefined;
    realEndDateTo?: Date | undefined;
    comments?: string | undefined;
    description?: string | undefined;
    filteredForInput?: boolean;
    maxDaysSearch?: number;
    isRecord?: boolean | undefined;
    includeUsers?: boolean;
    isCalendar?: boolean;
    origin?: string | undefined;
}

export class PagedResultDto_1OfOfScheduledActivityDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null implements IPagedResultDto_1OfOfScheduledActivityDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    elements?: ScheduledActivityDto[] | undefined;
    total?: number;
    pageNumber?: number;

    constructor(data?: IPagedResultDto_1OfOfScheduledActivityDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["elements"])) {
                this.elements = [] as any;
                for (let item of _data["elements"])
                    this.elements!.push(ScheduledActivityDto.fromJS(item));
            }
            this.total = _data["total"];
            this.pageNumber = _data["pageNumber"];
        }
    }

    static fromJS(data: any): PagedResultDto_1OfOfScheduledActivityDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDto_1OfOfScheduledActivityDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.elements)) {
            data["elements"] = [];
            for (let item of this.elements)
                data["elements"].push(item.toJSON());
        }
        data["total"] = this.total;
        data["pageNumber"] = this.pageNumber;
        return data;
    }
}

export interface IPagedResultDto_1OfOfScheduledActivityDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    elements?: ScheduledActivityDto[] | undefined;
    total?: number;
    pageNumber?: number;
}

export class ScheduledActivityDtoMin implements IScheduledActivityDtoMin {
    id?: number;
    startDate?: Date;
    endDate?: Date;
    jitsiRoom?: string | undefined;
    professional?: UserMinDto;
    activity?: ActivityDto;
    comments?: string | undefined;
    description?: string | undefined;
    isHeld?: boolean;
    isCancel?: boolean;
    hasUserConnected?: boolean;
    cancelDescription?: string | undefined;
    interactions?: InteractionDto[] | undefined;
    clientAffinities?: ClientAffinityDto[] | undefined;
    stateId?: number;
    reasonForCancellationId?: number | undefined;

    constructor(data?: IScheduledActivityDtoMin) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.jitsiRoom = _data["jitsiRoom"];
            this.professional = _data["professional"] ? UserMinDto.fromJS(_data["professional"]) : <any>undefined;
            this.activity = _data["activity"] ? ActivityDto.fromJS(_data["activity"]) : <any>undefined;
            this.comments = _data["comments"];
            this.description = _data["description"];
            this.isHeld = _data["isHeld"];
            this.isCancel = _data["isCancel"];
            this.hasUserConnected = _data["hasUserConnected"];
            this.cancelDescription = _data["cancelDescription"];
            if (Array.isArray(_data["interactions"])) {
                this.interactions = [] as any;
                for (let item of _data["interactions"])
                    this.interactions!.push(InteractionDto.fromJS(item));
            }
            if (Array.isArray(_data["clientAffinities"])) {
                this.clientAffinities = [] as any;
                for (let item of _data["clientAffinities"])
                    this.clientAffinities!.push(ClientAffinityDto.fromJS(item));
            }
            this.stateId = _data["stateId"];
            this.reasonForCancellationId = _data["reasonForCancellationId"];
        }
    }

    static fromJS(data: any): ScheduledActivityDtoMin {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduledActivityDtoMin();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["jitsiRoom"] = this.jitsiRoom;
        data["professional"] = this.professional ? this.professional.toJSON() : <any>undefined;
        data["activity"] = this.activity ? this.activity.toJSON() : <any>undefined;
        data["comments"] = this.comments;
        data["description"] = this.description;
        data["isHeld"] = this.isHeld;
        data["isCancel"] = this.isCancel;
        data["hasUserConnected"] = this.hasUserConnected;
        data["cancelDescription"] = this.cancelDescription;
        if (Array.isArray(this.interactions)) {
            data["interactions"] = [];
            for (let item of this.interactions)
                data["interactions"].push(item.toJSON());
        }
        if (Array.isArray(this.clientAffinities)) {
            data["clientAffinities"] = [];
            for (let item of this.clientAffinities)
                data["clientAffinities"].push(item.toJSON());
        }
        data["stateId"] = this.stateId;
        data["reasonForCancellationId"] = this.reasonForCancellationId;
        return data;
    }
}

export interface IScheduledActivityDtoMin {
    id?: number;
    startDate?: Date;
    endDate?: Date;
    jitsiRoom?: string | undefined;
    professional?: UserMinDto;
    activity?: ActivityDto;
    comments?: string | undefined;
    description?: string | undefined;
    isHeld?: boolean;
    isCancel?: boolean;
    hasUserConnected?: boolean;
    cancelDescription?: string | undefined;
    interactions?: InteractionDto[] | undefined;
    clientAffinities?: ClientAffinityDto[] | undefined;
    stateId?: number;
    reasonForCancellationId?: number | undefined;
}

export class CalendarDayDto implements ICalendarDayDto {
    day?: Date;
    activities?: ScheduledActivityDtoMin[] | undefined;

    constructor(data?: ICalendarDayDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.day = _data["day"] ? new Date(_data["day"].toString()) : <any>undefined;
            if (Array.isArray(_data["activities"])) {
                this.activities = [] as any;
                for (let item of _data["activities"])
                    this.activities!.push(ScheduledActivityDtoMin.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CalendarDayDto {
        data = typeof data === 'object' ? data : {};
        let result = new CalendarDayDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["day"] = this.day ? this.day.toISOString() : <any>undefined;
        if (Array.isArray(this.activities)) {
            data["activities"] = [];
            for (let item of this.activities)
                data["activities"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICalendarDayDto {
    day?: Date;
    activities?: ScheduledActivityDtoMin[] | undefined;
}

export class ServicePackageQueryDto implements IServicePackageQueryDto {
    pageNumber?: number;
    pageSize?: number;
    readonly skipElments?: number;
    orderField?: string | undefined;
    orderAsc?: boolean;
    id?: number | undefined;
    name?: string | undefined;
    serviceTypeId?: number | undefined;
    activityTypeId?: number | undefined;
    subtypeActivityId?: number | undefined;
    numberOfSessions?: number | undefined;

    constructor(data?: IServicePackageQueryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            (<any>this).skipElments = _data["skipElments"];
            this.orderField = _data["orderField"];
            this.orderAsc = _data["orderAsc"];
            this.id = _data["id"];
            this.name = _data["name"];
            this.serviceTypeId = _data["serviceTypeId"];
            this.activityTypeId = _data["activityTypeId"];
            this.subtypeActivityId = _data["subtypeActivityId"];
            this.numberOfSessions = _data["numberOfSessions"];
        }
    }

    static fromJS(data: any): ServicePackageQueryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServicePackageQueryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["skipElments"] = this.skipElments;
        data["orderField"] = this.orderField;
        data["orderAsc"] = this.orderAsc;
        data["id"] = this.id;
        data["name"] = this.name;
        data["serviceTypeId"] = this.serviceTypeId;
        data["activityTypeId"] = this.activityTypeId;
        data["subtypeActivityId"] = this.subtypeActivityId;
        data["numberOfSessions"] = this.numberOfSessions;
        return data;
    }
}

export interface IServicePackageQueryDto {
    pageNumber?: number;
    pageSize?: number;
    skipElments?: number;
    orderField?: string | undefined;
    orderAsc?: boolean;
    id?: number | undefined;
    name?: string | undefined;
    serviceTypeId?: number | undefined;
    activityTypeId?: number | undefined;
    subtypeActivityId?: number | undefined;
    numberOfSessions?: number | undefined;
}

export class PagedResultDto_1OfOfServicePackageDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null implements IPagedResultDto_1OfOfServicePackageDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    elements?: ServicePackageDto[] | undefined;
    total?: number;
    pageNumber?: number;

    constructor(data?: IPagedResultDto_1OfOfServicePackageDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["elements"])) {
                this.elements = [] as any;
                for (let item of _data["elements"])
                    this.elements!.push(ServicePackageDto.fromJS(item));
            }
            this.total = _data["total"];
            this.pageNumber = _data["pageNumber"];
        }
    }

    static fromJS(data: any): PagedResultDto_1OfOfServicePackageDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDto_1OfOfServicePackageDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.elements)) {
            data["elements"] = [];
            for (let item of this.elements)
                data["elements"].push(item.toJSON());
        }
        data["total"] = this.total;
        data["pageNumber"] = this.pageNumber;
        return data;
    }
}

export interface IPagedResultDto_1OfOfServicePackageDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    elements?: ServicePackageDto[] | undefined;
    total?: number;
    pageNumber?: number;
}

export class CreateUpdateServicePackageDto implements ICreateUpdateServicePackageDto {
    id?: number;
    name?: string | undefined;
    serviceTypeId?: number | undefined;
    activityTypeId?: number | undefined;
    subtypeActivityId?: number | undefined;
    numberOfSessions?: number;
    isDeleted?: boolean;

    constructor(data?: ICreateUpdateServicePackageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.serviceTypeId = _data["serviceTypeId"];
            this.activityTypeId = _data["activityTypeId"];
            this.subtypeActivityId = _data["subtypeActivityId"];
            this.numberOfSessions = _data["numberOfSessions"];
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): CreateUpdateServicePackageDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUpdateServicePackageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["serviceTypeId"] = this.serviceTypeId;
        data["activityTypeId"] = this.activityTypeId;
        data["subtypeActivityId"] = this.subtypeActivityId;
        data["numberOfSessions"] = this.numberOfSessions;
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface ICreateUpdateServicePackageDto {
    id?: number;
    name?: string | undefined;
    serviceTypeId?: number | undefined;
    activityTypeId?: number | undefined;
    subtypeActivityId?: number | undefined;
    numberOfSessions?: number;
    isDeleted?: boolean;
}

export class SSEEvent implements ISSEEvent {
    clientId?: string | undefined;
    jitsiRoom?: string | undefined;
    type?: string | undefined;
    data?: string | undefined;
    expiration?: Date | undefined;

    constructor(data?: ISSEEvent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.jitsiRoom = _data["jitsiRoom"];
            this.type = _data["type"];
            this.data = _data["data"];
            this.expiration = _data["expiration"] ? new Date(_data["expiration"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SSEEvent {
        data = typeof data === 'object' ? data : {};
        let result = new SSEEvent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["jitsiRoom"] = this.jitsiRoom;
        data["type"] = this.type;
        data["data"] = this.data;
        data["expiration"] = this.expiration ? this.expiration.toISOString() : <any>undefined;
        return data;
    }
}

export interface ISSEEvent {
    clientId?: string | undefined;
    jitsiRoom?: string | undefined;
    type?: string | undefined;
    data?: string | undefined;
    expiration?: Date | undefined;
}

export class CreateUpdateSuggestionDto implements ICreateUpdateSuggestionDto {
    userId?: number;
    device?: string | undefined;
    body?: string | undefined;

    constructor(data?: ICreateUpdateSuggestionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.device = _data["device"];
            this.body = _data["body"];
        }
    }

    static fromJS(data: any): CreateUpdateSuggestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUpdateSuggestionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["device"] = this.device;
        data["body"] = this.body;
        return data;
    }
}

export interface ICreateUpdateSuggestionDto {
    userId?: number;
    device?: string | undefined;
    body?: string | undefined;
}

export class SuggestionDto implements ISuggestionDto {
    user?: UserMinDto;
    device?: string | undefined;
    body?: string | undefined;

    constructor(data?: ISuggestionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? UserMinDto.fromJS(_data["user"]) : <any>undefined;
            this.device = _data["device"];
            this.body = _data["body"];
        }
    }

    static fromJS(data: any): SuggestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new SuggestionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["device"] = this.device;
        data["body"] = this.body;
        return data;
    }
}

export interface ISuggestionDto {
    user?: UserMinDto;
    device?: string | undefined;
    body?: string | undefined;
}

export class TownQueryDto implements ITownQueryDto {
    pageNumber?: number;
    pageSize?: number;
    readonly skipElments?: number;
    orderField?: string | undefined;
    orderAsc?: boolean;
    id?: number | undefined;
    provinceId?: number | undefined;
    ineCode?: string | undefined;
    ine4Code?: string | undefined;
    name?: string | undefined;
    postCode?: string | undefined;

    constructor(data?: ITownQueryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            (<any>this).skipElments = _data["skipElments"];
            this.orderField = _data["orderField"];
            this.orderAsc = _data["orderAsc"];
            this.id = _data["id"];
            this.provinceId = _data["provinceId"];
            this.ineCode = _data["ineCode"];
            this.ine4Code = _data["ine4Code"];
            this.name = _data["name"];
            this.postCode = _data["postCode"];
        }
    }

    static fromJS(data: any): TownQueryDto {
        data = typeof data === 'object' ? data : {};
        let result = new TownQueryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["skipElments"] = this.skipElments;
        data["orderField"] = this.orderField;
        data["orderAsc"] = this.orderAsc;
        data["id"] = this.id;
        data["provinceId"] = this.provinceId;
        data["ineCode"] = this.ineCode;
        data["ine4Code"] = this.ine4Code;
        data["name"] = this.name;
        data["postCode"] = this.postCode;
        return data;
    }
}

export interface ITownQueryDto {
    pageNumber?: number;
    pageSize?: number;
    skipElments?: number;
    orderField?: string | undefined;
    orderAsc?: boolean;
    id?: number | undefined;
    provinceId?: number | undefined;
    ineCode?: string | undefined;
    ine4Code?: string | undefined;
    name?: string | undefined;
    postCode?: string | undefined;
}

export class MasterTable implements IMasterTable {
    readonly id?: number;
    type?: string | undefined;
    subType?: string | undefined;
    code?: string | undefined;
    value?: string | undefined;
    order?: number;
    isDeleted?: boolean;

    constructor(data?: IMasterTable) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).id = _data["id"];
            this.type = _data["type"];
            this.subType = _data["subType"];
            this.code = _data["code"];
            this.value = _data["value"];
            this.order = _data["order"];
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): MasterTable {
        data = typeof data === 'object' ? data : {};
        let result = new MasterTable();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["subType"] = this.subType;
        data["code"] = this.code;
        data["value"] = this.value;
        data["order"] = this.order;
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface IMasterTable {
    id?: number;
    type?: string | undefined;
    subType?: string | undefined;
    code?: string | undefined;
    value?: string | undefined;
    order?: number;
    isDeleted?: boolean;
}

export class Town implements ITown {
    readonly id?: number;
    province?: MasterTable;
    ineCode?: string | undefined;
    ine4Code?: string | undefined;
    name!: string;
    postCodes?: PostCode[] | undefined;
    isDeleted?: boolean;

    constructor(data?: ITown) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).id = _data["id"];
            this.province = _data["province"] ? MasterTable.fromJS(_data["province"]) : <any>undefined;
            this.ineCode = _data["ineCode"];
            this.ine4Code = _data["ine4Code"];
            this.name = _data["name"];
            if (Array.isArray(_data["postCodes"])) {
                this.postCodes = [] as any;
                for (let item of _data["postCodes"])
                    this.postCodes!.push(PostCode.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): Town {
        data = typeof data === 'object' ? data : {};
        let result = new Town();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["province"] = this.province ? this.province.toJSON() : <any>undefined;
        data["ineCode"] = this.ineCode;
        data["ine4Code"] = this.ine4Code;
        data["name"] = this.name;
        if (Array.isArray(this.postCodes)) {
            data["postCodes"] = [];
            for (let item of this.postCodes)
                data["postCodes"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface ITown {
    id?: number;
    province?: MasterTable;
    ineCode?: string | undefined;
    ine4Code?: string | undefined;
    name: string;
    postCodes?: PostCode[] | undefined;
    isDeleted?: boolean;
}

export class PostCode implements IPostCode {
    readonly id?: number;
    code!: string;
    town?: Town;
    isDeleted?: boolean;

    constructor(data?: IPostCode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).id = _data["id"];
            this.code = _data["code"];
            this.town = _data["town"] ? Town.fromJS(_data["town"]) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): PostCode {
        data = typeof data === 'object' ? data : {};
        let result = new PostCode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["town"] = this.town ? this.town.toJSON() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface IPostCode {
    id?: number;
    code: string;
    town?: Town;
    isDeleted?: boolean;
}

export class TownDto implements ITownDto {
    id?: number;
    provinceId?: number;
    ineCode?: string | undefined;
    ine4Code?: string | undefined;
    name?: string | undefined;
    postCodes?: PostCode[] | undefined;
    isDeleted?: boolean;

    constructor(data?: ITownDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.provinceId = _data["provinceId"];
            this.ineCode = _data["ineCode"];
            this.ine4Code = _data["ine4Code"];
            this.name = _data["name"];
            if (Array.isArray(_data["postCodes"])) {
                this.postCodes = [] as any;
                for (let item of _data["postCodes"])
                    this.postCodes!.push(PostCode.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): TownDto {
        data = typeof data === 'object' ? data : {};
        let result = new TownDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["provinceId"] = this.provinceId;
        data["ineCode"] = this.ineCode;
        data["ine4Code"] = this.ine4Code;
        data["name"] = this.name;
        if (Array.isArray(this.postCodes)) {
            data["postCodes"] = [];
            for (let item of this.postCodes)
                data["postCodes"].push(item.toJSON());
        }
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface ITownDto {
    id?: number;
    provinceId?: number;
    ineCode?: string | undefined;
    ine4Code?: string | undefined;
    name?: string | undefined;
    postCodes?: PostCode[] | undefined;
    isDeleted?: boolean;
}

export class PagedResultDto_1OfOfTownDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null implements IPagedResultDto_1OfOfTownDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    elements?: TownDto[] | undefined;
    total?: number;
    pageNumber?: number;

    constructor(data?: IPagedResultDto_1OfOfTownDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["elements"])) {
                this.elements = [] as any;
                for (let item of _data["elements"])
                    this.elements!.push(TownDto.fromJS(item));
            }
            this.total = _data["total"];
            this.pageNumber = _data["pageNumber"];
        }
    }

    static fromJS(data: any): PagedResultDto_1OfOfTownDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDto_1OfOfTownDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.elements)) {
            data["elements"] = [];
            for (let item of this.elements)
                data["elements"].push(item.toJSON());
        }
        data["total"] = this.total;
        data["pageNumber"] = this.pageNumber;
        return data;
    }
}

export interface IPagedResultDto_1OfOfTownDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    elements?: TownDto[] | undefined;
    total?: number;
    pageNumber?: number;
}

export enum DayOfWeek {
    Sunday = "Sunday",
    Monday = "Monday",
    Tuesday = "Tuesday",
    Wednesday = "Wednesday",
    Thursday = "Thursday",
    Friday = "Friday",
    Saturday = "Saturday",
}

export class WeeklyScheduleQueryDto implements IWeeklyScheduleQueryDto {
    pageNumber?: number;
    pageSize?: number;
    readonly skipElments?: number;
    orderField?: string | undefined;
    orderAsc?: boolean;
    id?: number | undefined;
    professionalId?: number | undefined;
    clientId?: number | undefined;
    day?: DayOfWeek;
    isProfesionalWeeklySchedule?: boolean | undefined;

    constructor(data?: IWeeklyScheduleQueryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            (<any>this).skipElments = _data["skipElments"];
            this.orderField = _data["orderField"];
            this.orderAsc = _data["orderAsc"];
            this.id = _data["id"];
            this.professionalId = _data["professionalId"];
            this.clientId = _data["clientId"];
            this.day = _data["day"];
            this.isProfesionalWeeklySchedule = _data["isProfesionalWeeklySchedule"];
        }
    }

    static fromJS(data: any): WeeklyScheduleQueryDto {
        data = typeof data === 'object' ? data : {};
        let result = new WeeklyScheduleQueryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["skipElments"] = this.skipElments;
        data["orderField"] = this.orderField;
        data["orderAsc"] = this.orderAsc;
        data["id"] = this.id;
        data["professionalId"] = this.professionalId;
        data["clientId"] = this.clientId;
        data["day"] = this.day;
        data["isProfesionalWeeklySchedule"] = this.isProfesionalWeeklySchedule;
        return data;
    }
}

export interface IWeeklyScheduleQueryDto {
    pageNumber?: number;
    pageSize?: number;
    skipElments?: number;
    orderField?: string | undefined;
    orderAsc?: boolean;
    id?: number | undefined;
    professionalId?: number | undefined;
    clientId?: number | undefined;
    day?: DayOfWeek;
    isProfesionalWeeklySchedule?: boolean | undefined;
}

export class TimeSlotDto implements ITimeSlotDto {
    id?: number | undefined;
    weeklyScheduleId?: number | undefined;
    startTimeTS?: string | undefined;
    endTimeTS?: string | undefined;
    order?: number | undefined;
    isDeleted?: boolean;

    constructor(data?: ITimeSlotDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.weeklyScheduleId = _data["weeklyScheduleId"];
            this.startTimeTS = _data["startTimeTS"];
            this.endTimeTS = _data["endTimeTS"];
            this.order = _data["order"];
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): TimeSlotDto {
        data = typeof data === 'object' ? data : {};
        let result = new TimeSlotDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["weeklyScheduleId"] = this.weeklyScheduleId;
        data["startTimeTS"] = this.startTimeTS;
        data["endTimeTS"] = this.endTimeTS;
        data["order"] = this.order;
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface ITimeSlotDto {
    id?: number | undefined;
    weeklyScheduleId?: number | undefined;
    startTimeTS?: string | undefined;
    endTimeTS?: string | undefined;
    order?: number | undefined;
    isDeleted?: boolean;
}

export class WeeklyScheduleDto implements IWeeklyScheduleDto {
    id?: number | undefined;
    professionalId?: number | undefined;
    clientId?: number | undefined;
    day?: DayOfWeek;
    readonly dayOrder?: number;
    timeBlocks?: TimeSlotDto[] | undefined;
    isWorkingDay?: boolean;
    isProfesionalWeeklySchedule?: boolean;

    constructor(data?: IWeeklyScheduleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.professionalId = _data["professionalId"];
            this.clientId = _data["clientId"];
            this.day = _data["day"];
            (<any>this).dayOrder = _data["dayOrder"];
            if (Array.isArray(_data["timeBlocks"])) {
                this.timeBlocks = [] as any;
                for (let item of _data["timeBlocks"])
                    this.timeBlocks!.push(TimeSlotDto.fromJS(item));
            }
            this.isWorkingDay = _data["isWorkingDay"];
            this.isProfesionalWeeklySchedule = _data["isProfesionalWeeklySchedule"];
        }
    }

    static fromJS(data: any): WeeklyScheduleDto {
        data = typeof data === 'object' ? data : {};
        let result = new WeeklyScheduleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["professionalId"] = this.professionalId;
        data["clientId"] = this.clientId;
        data["day"] = this.day;
        data["dayOrder"] = this.dayOrder;
        if (Array.isArray(this.timeBlocks)) {
            data["timeBlocks"] = [];
            for (let item of this.timeBlocks)
                data["timeBlocks"].push(item.toJSON());
        }
        data["isWorkingDay"] = this.isWorkingDay;
        data["isProfesionalWeeklySchedule"] = this.isProfesionalWeeklySchedule;
        return data;
    }
}

export interface IWeeklyScheduleDto {
    id?: number | undefined;
    professionalId?: number | undefined;
    clientId?: number | undefined;
    day?: DayOfWeek;
    dayOrder?: number;
    timeBlocks?: TimeSlotDto[] | undefined;
    isWorkingDay?: boolean;
    isProfesionalWeeklySchedule?: boolean;
}

export class PagedResultDto_1OfOfWeeklyScheduleDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null implements IPagedResultDto_1OfOfWeeklyScheduleDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    elements?: WeeklyScheduleDto[] | undefined;
    total?: number;
    pageNumber?: number;

    constructor(data?: IPagedResultDto_1OfOfWeeklyScheduleDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["elements"])) {
                this.elements = [] as any;
                for (let item of _data["elements"])
                    this.elements!.push(WeeklyScheduleDto.fromJS(item));
            }
            this.total = _data["total"];
            this.pageNumber = _data["pageNumber"];
        }
    }

    static fromJS(data: any): PagedResultDto_1OfOfWeeklyScheduleDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDto_1OfOfWeeklyScheduleDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.elements)) {
            data["elements"] = [];
            for (let item of this.elements)
                data["elements"].push(item.toJSON());
        }
        data["total"] = this.total;
        data["pageNumber"] = this.pageNumber;
        return data;
    }
}

export interface IPagedResultDto_1OfOfWeeklyScheduleDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    elements?: WeeklyScheduleDto[] | undefined;
    total?: number;
    pageNumber?: number;
}

export class CreateUpdateWeeklyScheduleDto implements ICreateUpdateWeeklyScheduleDto {
    filterId?: number;
    isProfesionalWeeklySchedule?: boolean;
    weeklySchedules?: WeeklyScheduleDto[] | undefined;

    constructor(data?: ICreateUpdateWeeklyScheduleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filterId = _data["filterId"];
            this.isProfesionalWeeklySchedule = _data["isProfesionalWeeklySchedule"];
            if (Array.isArray(_data["weeklySchedules"])) {
                this.weeklySchedules = [] as any;
                for (let item of _data["weeklySchedules"])
                    this.weeklySchedules!.push(WeeklyScheduleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateUpdateWeeklyScheduleDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUpdateWeeklyScheduleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filterId"] = this.filterId;
        data["isProfesionalWeeklySchedule"] = this.isProfesionalWeeklySchedule;
        if (Array.isArray(this.weeklySchedules)) {
            data["weeklySchedules"] = [];
            for (let item of this.weeklySchedules)
                data["weeklySchedules"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateUpdateWeeklyScheduleDto {
    filterId?: number;
    isProfesionalWeeklySchedule?: boolean;
    weeklySchedules?: WeeklyScheduleDto[] | undefined;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}